// tslint:disable:max-file-line-count
import {ChangeDetectorRef, Component, ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef,} from '@angular/core';
import {trigger, transition, style, animate} from '@angular/animations';
import {ActivatedRoute, Router} from '@angular/router';
import { MaiaUploadService } from '../../data-access-layer/maia/maia-upload.service';
import { SovLastJob } from '../../model/maia/sov-upload';
import {AccountService} from '../../data-access-layer/account/account.service';
import {Account} from '../../model/account/account';
import {Dataset} from '../../model/dataset/dataset';
import {ACCUMULATIONS_PANEL_ID, ANALYTICS_PANEL_ID, COLORIZE_MARKERS_PANEL_ID, COMMON_PANEL_WIDTH, Constants, DatapointsViewMode, DatasetsNames, DistanceUnit} from '../../constants';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../auth/auth.service';
import {RenderingOptions} from '../../model/dataset/rendering/rendering-options';
import {DatapointConverterOptions, DatapointConverterType, Grouping,} from '../../model/dataset/rendering/datapoint-converter-options';
import {VisualizationType} from '../../model/dataset/rendering/visualization-options';
import {DatapointFilter} from '../../model/datapoint/filter/datapoint-filter';
import {DatapointProjection} from '../../model/datapoint/projection/datapoint-projection';
import {DatasetField} from '../../model/dataset/field/dataset-field';
import {DatasetFieldType} from '../../model/dataset/dataset-field-type';
import {DatapointsAggregateService} from '../../data-access-layer/datapoints/datapoints-aggregate.service';
import {OverlaysService} from '../../data-access-layer/global-overlays/overlays.service';
import {ActivateOverlayEvent} from '../../model/events/activate-overlay-event';
import {DatasetUtils} from '../../core/utils/dataset-utils';
import {MapStateService} from '../../map/map-state.service';
import {defaultMapStatus, defaultTileSize,} from '../../core/map/map.constants';
import {GroupPanelComponent} from '../group-panel/group-panel.component';
import {DatapointSort, SortOrder} from '../../model/filter/draft-filter-sort';
import {SortDirection} from '@angular/material/sort';
import {LinkDatasetService} from '../../data-access-layer/dataset/link-dataset.service';
import {DatasetService} from '../../data-access-layer/dataset/dataset.service';
import {PanelComponent} from '../../shared/panel/panel.component';
import {DatapointsPageStateService} from './datapoints-page-state.service';
import {DatapointFilterObject} from '../../model/datapoint/datapoint-filter-object';
import {DatasetGeometryType} from '../../model/dataset/dataset-geometry-type';
import {ColorScaleType} from '../../model/dataset/rendering/color-scale-type';
import {ClimatologyOptions, getDefaultClimatologyOptions, transformClimatologyOptionsForBackend} from '../../model/dataset/rendering/climatology-options';
import {SidePanelComponent} from '../../core/side-panel/side-panel.component';
import {MapDrawType} from '../../model/map/map-draw-type';
// import { MAT_INPUT_VALUE_ACCESSOR } from "@angular/material";
import {MatDialog} from '@angular/material/dialog';
import {DatasetDownloadComponent} from '../dataset-download/dataset-download.component';
import {FormBuilder, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DatapointsFilterService} from './datapoints-filter.service';
import {MapShape} from '../../model/map/map-shape';
// Replaces google.maps.drawing.OverlayType — the "drawing" library is no longer loaded.
import {OverlayType} from '../../model/map/overlay-type';
import {FilterBarItem} from '../../model/datapoint/draft/table/filter-bar-item';
import {CircleSelectionConfig} from '../../model/map/circle-selection-config';
import {DatasetFieldStatistics} from '../../model/analytics/dataset-field-statistics';
import {MapStateActionEnum} from '../../model/map/map-state-action.enum';
import {MapViewType} from '../../model/map/map-view-type';
import {activateClimateChangeOverlay} from '../../core/map/climate-overlay-sequence';
import {AggregateGroupRequest} from '../../model/datapoint/report/aggregate-group-request';
import {ReportRequest} from '../../model/datapoint/report/report-request';
import {MapThematicOverlayService, ThematicMapConfig,} from '../../map/map-thematic-overlay.service';
import {NR_THEMATIC_MAP_LEVELS, thematicMapOverlayRenderingOptions,} from '../../core/map/map-thematic-overlay.constants';
import {forkJoin, from, merge, of, Subject, Subscription} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {IntervalOption} from '../../model/dataset/rendering/interval-option';
import {ColorUtils} from '../../core/utils/color-utils';
import {CONSOLIDATED_RISK_SCORE_COLORS} from '../../shared/colorize-markers/colorize-markers.constants';
import {AttachmentUtils} from '../../core/utils/attachment-utils';
import {DownloadService} from '../../data-access-layer/download/download.service';
import {Location} from '@angular/common';
import {DatapointsOverlaysComponent} from './datapoints-overlay/datapoints-overlays.component';
import {NotifService} from '../../core/notification/notif.service';
import {Type} from '../../model/geometry/geometry-filter-shape';
import {GeometryFilter} from '../../model/geometry/geometry-filter';
import {ActivateImageOverlayEvent} from '../../model/events/activate-image-overlay-event';
import {ImageOverlay} from '../../model/overlay/external/image-overlay';
import {getGroupsLocalStorageKey, UserStateService} from '../../auth/user-state-service';
import {DatapointsProfilePanelComponent} from './datapoints-location-profile/datapoints-profile-panel.component';
import {environment, isEnabled} from '../../../environments/environment';
import {DatapointsOverlayFilterService, DatapointsOverlayFilterStore,} from './datapoints-overlay-filter/datapoints-overlay-filter.service';
import {DatapointFilterField} from '../../model/datapoint/filter/datapoint-filter-field';
import {DownloadDatapointRequest} from '../../model/download/download-datapoint-request';
import {MapDetails} from '../../map/map/info-box/map-info-box.component';
import {MapsAPILoader} from '@agm/core';
import {MapLocation} from '../../model/map/map-location';
import {WorkspaceItemDialogComponent} from '../workspace-item/projection/workspace-item-dialog.component';
import {WorkspaceItemType} from '../../model/workspace/workspace-item-type';
import {WorkspaceItemService} from '../../data-access-layer/workspace-item/workspace-item.service';
import {WorkspaceItem} from '../../model/workspace/workspace-item';
import {WorkspaceItemAccess} from '../../model/workspace/workspace-item-access';
import {DialogComponent} from '../../shared/dialog/dialog.component';
import {DialogModel} from '../../model/dialog/dialog-model';
import {debounceTime, mergeMap, skip, take} from 'rxjs/operators';
import {DatasetFieldSpecificType} from '../../model/dataset/dataset-field-specific.type';
import {CustomScoringService} from '../../account/custom-scoring/services/custom-scoring.service';
import {CustomScoringScope} from '../../account/custom-scoring/model/custom-service';
import {ComputationUtils} from '../../core/utils/computation-utils';
import {LegendInfo} from '../../model/legend/legend-info';
import {LegendUtils} from '../../core/utils/legend-utils';
import {GradientDetails} from '../../model/legend/gradient-details';
import {MapInteractionMode} from './map-interaction-mode';
import {TessadataService} from '../../data-access-layer/tessadata.service';
import {Functionalities} from '../../../environments/app-functionalities';
import {OverlaysConstants} from '../../overlays/overlays.constants';
import {DatasetFieldFloatingOption} from '../../model/dataset/dataset-field-floating-option';
import {ObjectUtils} from '../../core/utils/object-utils';
import {TessadataDatasetsByCountry} from '../../core/tessadata/tessadata-datasets-by-country';
import {TessadataDatasetsByGroup} from '../../core/tessadata/tessadata-datasets-by-group';
import {TessadataDataset} from '../../core/tessadata/tessadata-dataset';
import {DatasetFieldScope} from '../../model/dataset/dataset-field-scope';
import {DatapointsService} from '../../data-access-layer/datapoints/datapoints.service';
import {MapComponent} from '../../map/map/map.component';
import {Point} from '../../model/geometry/point';
import {UpdateDatapointRequest} from '../../model/datapoint/update-datapoint-request';
import {DatapointAggregateFieldType} from '../../model/datapoint/report/datapoint-aggregate-field-type';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TessadataDatasetType} from '../../core/tessadata/tessadata-dataset-type';
import {TessadataDatasetStructure} from '../../core/tessadata/tessadata-dataset-structure';
import {ClusteringService} from '../clustering/clustering.service';
import {CircleSelectionStateService} from '../../services/circle-selection-state.service';
import {Datapoint} from '../../model/datapoint/datapoint';
import {ClusterDatapoint} from '../clustering/cluster-datapoint';
import {AddressLocationProfileComponent} from './address-location-profile/address-location-profile.component';
import {MaptycsApplication} from 'src/app/model/account/maptycs-application';
import {SidePanelService} from '../../shared/services/side-panel.service';
import {SidePanels} from '../../shared/services/side-panel.helper';
import {DataPointsServiceState} from '../../shared/services/datapoints-service-state';
import {ProfilePolygonService} from '../../shared/services/profile-polygon.service';
import {ClusteringRequest} from '../clustering/clustering-request';
import {GeographicalRegionsService} from 'src/app/geographical-regions/geographical-regions.service';
import {decodeHtmlText, isNullOrUndefined, isUndefined, sortArrayByName,} from 'src/app/core/utils/util-master';
import {TessadataNriFields} from 'src/app/core/tessadata/tessadata-nri-fields';
import {AgDatapointTableComponent} from './ag-datapoint-table/ag-datapoint-table.component';
import {DatapointsOverlayFilterComponent} from './datapoints-overlay-filter/datapoints-overlay-filter.component';
import {FilteringErrorCodes} from './filtering-error-codes';
import {Crisis24Alert} from 'src/app/model/datapoint/crisis24-alert';
import {TreeStructureUtils} from 'src/app/core/utils/tree-structure-utils';
import {TreeStructure} from 'src/app/model/menu/tree-structure';

/** Tag the backend puts on every generated consolidated risk score field. */
const CONSOLIDATED_RISK_SCORE_TAG = 'Consolidated Risk Score';
import {Datapoints} from './datapoints';
import {DraftsUploadComponent} from '../drafts/drafts-upload/drafts-upload.component';
import {LocationProfile} from 'src/app/model/datapoint/location-profile/location-profile';
import {MatMenu} from '@angular/material/menu';
import {ReportPanelConfig} from 'src/app/model/report/report-panel-config';
import {ReportService} from 'src/app/shared/services/renewal-report-service';
import {REPORT_PANEL_ID} from './reports/reports.constants';
import {AccumulationsService} from 'src/app/shared/services/accumulations.service';
import {LayerExposedService} from 'src/app/account/layer-exposed/services/layer-exposed.service';
import {LayerExposeField} from 'src/app/account/layer-exposed/services/layer-expose-field';
import {GroupService} from 'src/app/data-access-layer/groups/group.service';
import {SeeInfoSearchBarStateService} from './see-info-search-bar-state.service';
import {TileVersionService} from 'src/app/shared/services/tile-version-service';
import {$e} from 'codelyzer/angular/styles/chars';
import { AnalyticsService } from '../../core/services/analytics.service';
import { ViewMode } from '../../core/services/analytics-config';
import { PageTitleService } from '../../core/services/page-title.service';
import { CLIMATE_INDICATORS_LEGEND, getClimateIndicatorName, getSSPFieldLabel } from '../../shared/colorize-markers/climate-indicators.constants';
import { NavigationTrackerService } from '../../core/services/navigation-tracker.service';
import { LoaderStateService } from '../../loader.service';
import { hasFieldValueOrder } from '../../data-access-layer/datapoints/field-value-order.constants';

declare var google: any;

// Constants

const DEFAULT_SORT: any = {
    fields: [],
    datasetID: null,
    links: [],
    linkFields: [],
    // geocodingAccuracyOrder: SortOrder.ASCENDANT,
    // statusOrder: SortOrder.ASCENDANT
};
const LIMIT = 1000;
const DEFAULT_SKIP = 0;
const DIRECTION_MAP = { asc: SortOrder.ASCENDANT, desc: SortOrder.DESCENDANT };

type AnalitycsComponentType = {
    dataset: Dataset;
    nriFields: any;
    _climateOverlays: any;
};

type EventNotificationComponentType = {
    account: Account;
    dataset: Dataset;
    groupsIds: number[];
};

type DatapointsClusterComponentType = {
    filter: DatapointFilter;
    dataset: Dataset;
    initSettings: ClusteringRequest;
    layerExposeFields?: LayerExposeField[];
    formulas?: WorkspaceItem[];
};

type UpdateDatapointComponentType = {
    dataset: Dataset;
};

type crises24DatapointsAgTableComponentType = {
    datapointID: string;
    dataset: Dataset;
    location?: Point;
    version: number;
    radius?: number;
    isListCall?: boolean;
};

export interface MatSortChange {
    active: string;
    direction: SortDirection;
}

interface OutputItem {
    datasetID: string;
    fields: string[];
}

type FilterPanelType = {
    filter: DatapointFilter;
    dataset: Dataset;
    workspaceItemsForFilter: WorkspaceItem[],
    account: Account,
    dataSource: any,
    filterTreeStrcuture: any
    treeControl: any
};


type AccumulationsComponentType = {
    filter: DatapointFilter;
    dataset: Dataset;
    initSettings: ClusteringRequest;
    formulas: WorkspaceItem[];
    dataSource: any;
    treeControl: any;
    heatMapTreeStructure: any,
    nriFields: any,
    climateOverlays: any
};

/**
 * This is the main component of the page with datapoints. It contains header, footer, groupNodes and overlays panels, the map component, and the table component.
 */
@Component({
    selector: "map-datapoints",
    templateUrl: "./datapoints.component.html",
    styleUrls: ["./datapoints.component.scss"],
    animations: [
        trigger('slideIn', [
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('300ms ease-out', style({ transform: 'translateX(0%)' }))
            ]),
            transition(':leave', [
                animate('300ms ease-in', style({ transform: 'translateX(100%)' }))
            ])
        ])
    ],
    // providers: [
    //     {
    //         provide: MAT_INPUT_VALUE_ACCESSOR,
    //         useExisting: MatInputCommifiedDirective,
    //     },
    // ],
})
export class DatapointsComponent implements OnInit, OnDestroy {
    DatasetsNames = DatasetsNames;
    MaptycsApplication = MaptycsApplication;
    isAccountAdmin: boolean;

    filterAttributes: Object = {
        filterAccountDatasets: {},
        tessadataGroups: {},
        tessadataEnabled: false,
        tessadataFieldsByDataset: {},
        overlayComponentEnabled: false,
        filterAccountOverlays: {},
    };
    isFilterAttributesPrepared: boolean = false;

    filterTreeStrcuture = new TreeStructureUtils();
    treeControl = this.filterTreeStrcuture.getTreeControl();
    dataSource = this.filterTreeStrcuture.getDataSource();

    externalDataTreeStrcuture = new TreeStructureUtils();
    externalDatatreeControl = this.externalDataTreeStrcuture.getTreeControl();
    externalDatadataSource = this.externalDataTreeStrcuture.getDataSource();
    externalData: boolean = false;

    showSaveFilterTreeStrcuture = new TreeStructureUtils();
    saveFilterTreeControl = this.showSaveFilterTreeStrcuture.getTreeControl();
    saveFilterDataSource = this.showSaveFilterTreeStrcuture.getDataSource();

    datapointObject = new Datapoints();
   // externalTensorFlightData: any;
    externalPreciselyData: any;
    externalPreciselyWildfireData: any;
    currentSelectedProfile: string | null = null;
    locationProfile = new LocationProfile();
    showDatasetList: boolean = false;
    showReportList: boolean = false;
    reports: WorkspaceItem[] = [];
    overlaysLoading: boolean = true;
    private pendingAnalyticsAction: (() => void) | null = null;
    private _filterPanelSetupPending: boolean = false;
    isAccumulationsPanelClosedForceFully: boolean = false;

    heatMapTreeStructure = new TreeStructureUtils();
    heatMaptreeControl = this.heatMapTreeStructure.getTreeControl();
    heatMapDataSource = this.heatMapTreeStructure.getDataSource();

    showDynamicIndicatorPopup = false;
    dynamicIndicatorLayerExposureData: any;
    showDynamicIndicatorSettings = false;
    createDropdownForm: UntypedFormGroup;
    dynamicDropDownList: any;
    defaultBottom = 65;
    defaultRight = 10;
    iconPosition = { x: null, y: null };
    isDragging = false;
    dragOffset = { x: 0, y: 0 };
    dragMoved = false;
    popupPosition = { x: null, y: null };
    firstPopupPosition = { x: null, y: null };
    secondPopupPosition = { x: null, y: null };
    popupWidth = 250;
    dynamicIndicatorValues: any[] = [];
    accountDetails: Account;
    pendingRequests: Set<number> = new Set();
    filterChanged = false;
    accountId: any;
    accGroups: any;

    isResizing = false;
    justResized = false;
    resizeStart = { x: 0, y: 0 };
    initialSize = { width: 200, height: 300 };

    isAccumalationApplied: boolean = false;
    private tileRefreshInProgress = false;
    constructor(
        private readonly geoRegionsService: GeographicalRegionsService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly maiaUploadService: MaiaUploadService,
        private readonly mapStateService: MapStateService,
        private readonly accountService: AccountService,
        private readonly datasetService: DatasetService,
        private readonly profilePolygonService: ProfilePolygonService,
        private readonly linkDatasetService: LinkDatasetService,
        private readonly datapointsServiceState: DataPointsServiceState,
        private readonly overlayService: OverlaysService,
        private readonly authService: AuthService,
        private readonly clusteringService: ClusteringService,
        private readonly datapointsService: DatapointsService,
        private readonly datapointsPageStateService: DatapointsPageStateService,
        private readonly datapointsFilterService: DatapointsFilterService,
        private readonly datapointAggregateService: DatapointsAggregateService,
        private readonly datapointsOverlayFilterService: DatapointsOverlayFilterService,
        private readonly cd: ChangeDetectorRef,
        private readonly mapThematicOverlayService: MapThematicOverlayService,
        private readonly viewContainerRef: ViewContainerRef,
        private readonly http: HttpClient,
        public readonly dialog: MatDialog,
        private readonly formBuilder: UntypedFormBuilder,
        public readonly downloadService: DownloadService,
        private readonly tessadataService: TessadataService,
        public readonly notifService: NotifService,
        private readonly location: Location,
        private readonly sidePanelService: SidePanelService,
        readonly userStateService: UserStateService,
        private readonly workspaceItemsService: WorkspaceItemService,
        private readonly mapsAPILoader: MapsAPILoader,
        private readonly reportService: ReportService,
        private readonly accumulationsSerivce: AccumulationsService,
        private layerExposeService: LayerExposedService,
        private readonly groupService: GroupService,
        private readonly datapointsAggregateService: DatapointsAggregateService,
        private fb: FormBuilder,
        public readonly datapointService: DatapointsService,
        private popupService: SeeInfoSearchBarStateService,
        private tileVersionService: TileVersionService,
        private readonly customScoringService: CustomScoringService,
        private readonly analytics: AnalyticsService,
        private readonly pageTitleService: PageTitleService,
        private readonly navigationTracker: NavigationTrackerService,
        private readonly circleSelectionStateService: CircleSelectionStateService,
        private readonly loaderStateService: LoaderStateService
    ) {
        this.filterFieldSearchFilter = (field: DatasetField) => {
            return field.name
                .toLowerCase()
                .includes(this.filterFieldSearchString.toLowerCase());
        };

        // Projection search
        this.projectionDatasetSearchFilter = (dataset: Dataset) => {
            return dataset.name
                .toLowerCase()
                .includes(this.projectionDatasetSearchString.toLowerCase());
        };

        this.projectionFieldSearchFilter = (field: DatasetField) => {
            return field.name
                .toLowerCase()
                .includes(this.projectionFieldSearchString.toLowerCase());
        };

        // workspaceItem search
        this.workspaceItemSearchFilter = (workspaceItem: WorkspaceItem) => {
            return workspaceItem.name
                .toLowerCase()
                .includes(this.workspaceItemSearchString.toLowerCase());
        };
        this.accountId = +this.route.snapshot.paramMap.get("accountId");
    }

    analyticsPanel: ComponentRef<SidePanelComponent>;
    notificationsPanel: ComponentRef<SidePanelComponent>;
    updateDatapointPanel: ComponentRef<SidePanelComponent>;
    clusterPanel: ComponentRef<SidePanelComponent>;
    colorizeMarkersPanel: ComponentRef<SidePanelComponent>;
    addressLocationPanel: ComponentRef<SidePanelComponent>;
    crises24DatapointsAgTablePanel: ComponentRef<SidePanelComponent>;
    reportPanel: ComponentRef<SidePanelComponent>;
    filterPanel: ComponentRef<SidePanelComponent>;
    accumulationsPanel: ComponentRef<SidePanelComponent>;


    @ViewChild("mapComponent") mapComponent: MapComponent;
    @ViewChild("groupsPanel") groupsPanel: GroupPanelComponent;
    @ViewChild("pagePanel") pagePanel: PanelComponent;
    @ViewChild("tableComponent") tableComponent: AgDatapointTableComponent;
    @ViewChild("locationProfilePanel")
    locationProfilePanel: DatapointsProfilePanelComponent;
    @ViewChild("addressLocationProfile")
    addressLocationProfile: AddressLocationProfileComponent;
    @ViewChild("filterMenu") filterMenu: any;
    @ViewChild("datapointsOverlaysComponent")
    datapointsOverlaysComponent: DatapointsOverlaysComponent;
    @ViewChild("workspaceItemDialog", { static: true })
    workspaceIemDialog: WorkspaceItemDialogComponent;
    @ViewChild("thematicMapToggleElement") thematicMapToggleElement: any;
    // @ViewChild('datasetMenuAll', { static: false }) datasetMenuAllCheckBox: MatCheckbox;
    // @ViewChild('externalMenuAll', { static: false }) externalMenuAllCheckBox: MatCheckbox;
    // @ViewChild('nriMenuAll', { static: false }) nriMenuAllCheckBox: MatCheckbox;
    @ViewChild("overlaysFilter")
    overlaysFilterComponent: DatapointsOverlayFilterComponent;
    @ViewChild("uploadComponent") uploadComponent: DraftsUploadComponent;
    @ViewChild('switchDatasetMenu') switchDatasetMenu: MatMenu;

    analyticsComponentEnabled = isEnabled(Functionalities.ANALYTICS);
    groupsComponentEnabled = isEnabled(Functionalities.GROUPS);
    overlayComponentEnabled = isEnabled(Functionalities.OVERLAYS);
    thematicMapFeatureEnabled = isEnabled(Functionalities.THEMATICMAP);
    draftsEnabled = isEnabled(Functionalities.DRAFTS);
    eventNotificationsEnabled = isEnabled(Functionalities.NOTIFICATIONS);
    downloadDatapointsEnabled = isEnabled(Functionalities.DOWNLOAD_DATAPOINTS);
    alterDatapointsEnabled = isEnabled(Functionalities.ALTER_DATAPOINTS);
    tessadataEnabled = isEnabled(Functionalities.TESSADATA_DATA);

    account: Account;
    dataset: Dataset;
    linkedAccountOverlays: Dataset[] = [];
    linkedAccountDatasets: Dataset[] = [];
    accountOverlays: Dataset[];
    accountExternalOverlays: Dataset[];
    fieldsByIdsAndDataset: Map<string, Map<string, DatasetField>> = new Map();
    filterAccountDatasets: Dataset[];
    tableVilterAccountDatasets: Dataset[];

    filterAccountOverlays = [];
    sortedFilterAccountOverlays: any = [];
    parentOverlay: any;

    isMapView = false;
    shouldHaveBackgroundColor = false;

    filter: DatapointFilter;
    projection: DatapointProjection;
    renderingOptions: RenderingOptions;
    initialRenderingOptions: RenderingOptions;
    clusteringSettings: ClusteringRequest;
    isClusteringActivated: boolean;

    filterBarItems: FilterBarItem[] = []; // it can contain not populated fields yet, and they have suggestions
    datapointFilterObject: DatapointFilterObject;
    mapReady = false;
    groupsReady = false;
    limit: number = LIMIT;
    sort: DatapointSort = Object.assign({}, DEFAULT_SORT);
    skip = 0;
    mapDatapointInfo?: MapDetails;
    selectedLocationClone: Point; // we make a clone to be able to undo the changes
    overlaysFilterDistance = {};

    mapInteractionMode: MapInteractionMode;
    isThematicMapActive = false;
    activeThematicMapConfig: ThematicMapConfig;
    datasetFloatingFields: DatasetField[] = [];
    datapointsCount = 0;
    floatingFieldsValuesByFields: Map<DatasetField, number>;

    legends: LegendInfo[] = [];
    externalDataMenuItems: TessadataDatasetsByCountry[] = [];
    externalPOIMenuItems: TessadataDataset[] = [];
    externalPOIDatasetsStructures: TessadataDatasetStructure[] = [];

    private readonly subscriptions: Subscription = new Subscription();

    // projection and filter search strings for input
    projectionFieldSearchString = "";
    projectionDatasetSearchString = "";
    filterFieldSearchString = "";
    filterStatisticValuesString = "";
    workspaceItemSearchString = "";

    filterFieldSearchFilter: (field: DatasetField) => boolean;
    projectionFieldSearchFilter: (field: DatasetField) => boolean;
    projectionDatasetSearchFilter: (dataset: Dataset) => boolean;
    workspaceItemSearchFilter: (workspaceItem: WorkspaceItem) => boolean;

    selectedOverlay!: Dataset;
    datasetIsDisabled = false;

    notifPanelIsOpen = false;
    searchIsActive = false;

    searchResultLocation: MapLocation;
    defaultDistanceUnit: DistanceUnit = DistanceUnit.KM;

    workspaceItemsForTableProjection: WorkspaceItem[] = [];
    workspaceItemsForFilter: WorkspaceItem[] = [];
    workspaceItemsForFormulas: WorkspaceItem[] = [];
    workspaceItemsForAnalytics: WorkspaceItem[] = [];

    // Layer expose fields for clustering
    layerExposeFields: LayerExposeField[] = [];

    // Categorized analytics workspace items
    globalAnalyticsItems: WorkspaceItem[] = [];
    memberAnalyticsItems: WorkspaceItem[] = [];

    // Toggle states for analytics menu sections
    openAccountAnalytics: boolean = false;
    openMyAnalytics: boolean = false;

    tableColumnsExcludedOverlayGroups: number[];

    hasWritePermission = false;
    hasClimateChangeAccess = false; // Climate change Risk Score access permission
    moveLocationModeEnabled = false; // when we start to move a datapoint on the map
    displayCoordinatesConfirmation = false; // when we move the point on the map

    tessadataFieldsByDataset = {}; // {externalFields: [], nriFields: []}
    tessadataFieldsForview = {}; /*copy tessadata obj for View feature*/
    tessadataGroups: any;
    thematicMapFormula: WorkspaceItem;
    thematicMapMetric: DatasetField;
    thematicMapTotal: number;
    customScorings: any[] = []; // Store custom scorings for filtering

    thematicMapGrouping: string = Grouping.SUM;
    selectedDatapointForEdit: Datapoint;
    private openThematicMapOnPageLoad: boolean;
    private dataIsReadySubject = new Subject<any>();
    private accountDataIsReady: boolean;

    customLegendsEnabled: boolean = false;
    legendLimitForm: UntypedFormGroup;
    statisticsFiltersFetched = false;
    workspaceItemsProjectionMenuOpen: boolean = false;


    trackByIndexFunction = (index: number): number => index;

    private static computeImageOverlayUrl(
        url: string,
        zoom: number,
        x: number,
        y: number,
        apiKey?: string,
        id?: string,
        offset?: string
    ) {
        return url
            .replace("overlayId", id)
            .replace("zoom", zoom.toString())
            .replace("coordX", x.toString())
            .replace("coordY", y.toString())
            .replace("offset", offset)
            .replace("apiKey", apiKey);
    }

    private static setFieldStatistics(
        colorizationField: DatasetField,
        renderingOptions: RenderingOptions,
        statistics: DatasetFieldStatistics
    ) {
        // Handle undefined statistics
        if (!statistics) {
            return;
        }
        // we need to not allow falsy values exists into the statistics values array - will mess the legends colorization
        if (statistics.values) {
            statistics.values = statistics.values.filter((item) =>
                Boolean(item)
            );
        }
        switch (DatasetUtils.getDatasetFieldType(colorizationField)) {
            case DatasetFieldType.NUMBER:
                renderingOptions.converterOptions.type =
                    DatapointConverterType.NUMBER_FIELD;
                renderingOptions.converterOptions.maxNumber =
                    statistics.maxValue;
                renderingOptions.converterOptions.minNumber =
                    statistics.minValue;
                break;
            case DatasetFieldType.TEXT:
                renderingOptions.converterOptions.type =
                    DatapointConverterType.TEXT_FIELD;
                renderingOptions.converterOptions.values = statistics.values;
                break;
            case DatasetFieldType.DATE_TIME:
                renderingOptions.converterOptions.type =
                    DatapointConverterType.DATE_FIELD;
                renderingOptions.converterOptions.maxDate = statistics.maxValue;
                renderingOptions.converterOptions.minDate = statistics.minValue;
                break;
        }
    }

    private static setFieldStatisticsForInterval(
        colorizationField: DatasetField,
        renderingOptions: RenderingOptions
    ) {
        // min, max are 0 because they are not needed for interval scale type
        switch (DatasetUtils.getDatasetFieldType(colorizationField)) {
            case DatasetFieldType.NUMBER:
                renderingOptions.converterOptions.type =
                    DatapointConverterType.NUMBER_FIELD;
                renderingOptions.converterOptions.maxNumber = 0;
                renderingOptions.converterOptions.minNumber = 0;
                break;
            case DatasetFieldType.TEXT:
                renderingOptions.converterOptions.type =
                    DatapointConverterType.TEXT_FIELD;
                renderingOptions.converterOptions.values = [];
                break;
            case DatasetFieldType.DATE_TIME:
                renderingOptions.converterOptions.type =
                    DatapointConverterType.DATE_FIELD;
                renderingOptions.converterOptions.maxDate = 0;
                renderingOptions.converterOptions.minDate = 0;
                break;
        }
    }

    ngOnInit(): void {
        // implementing custom legends -
        this.legendLimitForm = this.formBuilder.group({
            forGreen: ["", Validators.required],
            forYellow: ["", Validators.required],
            forOrange: ["", Validators.required],
        });

        this.datapointsFilterService.clearFilterBar();
        this.datapointsPageStateService.reset();
        this.datapointsOverlayFilterService.reset();
        this.mapThematicOverlayService.reset();

        let datasetId = this.route.snapshot.paramMap.get("datasetId");
        let accountId = +this.route.snapshot.paramMap.get("accountId");
        let viewMode = this.route.snapshot.paramMap.get(
            Constants.VIEW_MODE_PARAM_NAME
        );
        this.isAccountAdmin = this.userStateService.isAccountAdmin(accountId);
        // JIRA-EMFDU-001: hasWritePermission is also assigned further down, but only once - and
        // hasWriteAccess reads the accountMembers map, which may not be populated that early. Since
        // it now gates the Drafts menu entry, refresh it here alongside isAccountAdmin so an
        // EMFD+U user does not lose the menu to a race on first load.
        this.hasWritePermission = this.userStateService.hasWriteAccess(accountId);
        this.subscriptions.add(
            this.userStateService.userStateSubject.subscribe(() => {
                this.isAccountAdmin = this.userStateService.isAccountAdmin(accountId);
                this.hasWritePermission = this.userStateService.hasWriteAccess(accountId);
            })
        );

        // Check climate change access for this account
        this.subscriptions.add(
            this.datapointsService.hasClimateChangeAccess(accountId.toString()).subscribe(
                (response) => {
                    this.hasClimateChangeAccess = response.hasClimateChangeAccess;
                },
                (error) => {
                    this.hasClimateChangeAccess = false; // Default to no access on error
                }
            )
        );

        // Fetch custom scorings for filtering (INTERNAL and FORMULA scope only)
        this.subscriptions.add(
            forkJoin([
                this.customScoringService.getCustomScoringsForAccount(accountId, CustomScoringScope.INTERNAL),
                this.customScoringService.getCustomScoringsForAccount(accountId, CustomScoringScope.FORMULA)
            ]).subscribe(([internalScorings, formulaScorings]) => {
                this.customScorings = [...(internalScorings || []), ...(formulaScorings || [])];
            })
        );

        this.subscriptions.add(
            this.overlayService
                .getOverlayGroupsByTag(
                    OverlaysConstants.HIDE_GROUP_FROM_TABLE_COLUMNS_TAG
                )
                .subscribe(
                    (overlayGroups) =>
                    (this.tableColumnsExcludedOverlayGroups =
                        overlayGroups.map((group) => group.id))
                )
        );
        this.subscriptions.add(
            this.clusteringService.onClusterSelected().subscribe((cluster) => {
                if (this.clusterPanel) {
                    this.sidePanelService.setPanelFirst(this.clusterPanel.instance);
                    this.clusterPanel.instance.showPanel();
                } else {
                    this.sidePanelService.setRootViewContainerRef(
                        this.viewContainerRef
                    );
                    this.clusterPanel =
                        this.sidePanelService.open<DatapointsClusterComponentType>(
                            SidePanels.CLUSTER_PANEL,
                            {
                                width: 500,
                                id: "clusterPanel",
                                panelTitle: "Cluster",
                                panelIcon: "fa-atom",
                            },
                            {
                                dataset: this.dataset,
                                filter: this.filter,
                                initSettings: this.clusteringSettings,
                                layerExposeFields: this.layerExposeFields,
                                formulas: this.workspaceItemsForFormulas,
                            }
                        );

                    this.datapointsServiceState.onDataPointSelected$.subscribe(
                        (clusterPoint: ClusterDatapoint) =>
                            this.openLocationProfile(clusterPoint)
                    );
                    this.datapointsServiceState.onApplySettings$.subscribe(
                        (settings: ClusteringRequest) => {
                            this.clusteringSettings = settings;
                            if (!this.clusteringSettings.openSidePanel)
                                this.closeClusterPanel();
                        }
                    );

                    this.datapointsServiceState.onCancelClustering$.subscribe(
                        () => {
                            this.clusteringSettings = undefined;
                            this.closeClusterPanel();
                        }
                    );
                }
            })
        );

        this.subscriptions.add(
            this.clusteringService
                .isClusteringActivatedEmitter()
                .subscribe((value) => {
                    this.isClusteringActivated = value;
                    this.tileVersionService.incrementVersionToken();
                    this.isAccumalationApplied = true;
                    this.updateMap();
                })
        );

        this.subscriptions.add(
            this.tessadataService
                .fetchDatasets(TessadataDatasetType.LOCATION_DATA, accountId)
                .subscribe((datasets) => {
                    const temp_hide_datasets_ids = ["25", "26"];
                    datasets.forEach((element) => {
                        element.datasets = element.datasets.filter(
                            (child_element) =>
                                !temp_hide_datasets_ids.includes(
                                    child_element.datasetId
                                )
                        );
                    });
                    this.externalDataMenuItems = datasets;
                })
        );

        this.subscriptions.add(
            merge(
                of(null),
                this.datapointsServiceState.onCreateOverlayGroupSuccess$,
                this.datapointsServiceState.onEditOverlayGroupSuccess$,
                this.datapointsServiceState.onDeleteOverlayGroupSuccess$
            )
                .pipe(switchMap(() => this.tessadataService.fetchDatasetsGrouped(TessadataDatasetType.LOCATION_DATA, accountId)))
                .subscribe((groups) => {
                    this.externalDatadataSource.data = this.buildExternalGroupTree(groups);
                })
        );

        this.subscriptions.add(
            this.tessadataService
                .fetchDatasets(TessadataDatasetType.POINT_OF_INTEREST, accountId)
                .subscribe((datasets) => {
                    this.externalPOIMenuItems = [].concat.apply(
                        [],
                        datasets.map((ds) => ds.datasets)
                    );

                    var datasetsIds = this.externalPOIMenuItems.map(
                        (ds) => ds.datasetId
                    );

                    this.tessadataService
                        .fetchDatasetsStructures(datasetId,datasetsIds)
                        .subscribe(
                            (structures) => {
                                structures.forEach((structure) =>
                                    structure.fields.push({
                                        fieldId: "distance",
                                        fieldLabel: "Distance",
                                        fieldType: "NUMBER",
                                    })
                                );
                                this.externalPOIDatasetsStructures = structures;
                            },
                            (error) =>
                                console.log("Cannot fetch tessadata structures")
                        );
                })
        );

        this.subscriptions.add(
            this.datapointsPageStateService
                .onMapInteractionChange()
                .subscribe((newStatus) => {
                    this.mapInteractionMode = newStatus.mode;
                    this.isThematicMapActive =
                        newStatus.mode ===
                        MapInteractionMode.THEMATIC_MAP_ACTIVE;
                })
        );
        this.datapointsPageStateService.activeAccountId = accountId;
        this.hasWritePermission =
            this.userStateService.hasWriteAccess(accountId);

        this.mapsAPILoader.load().then(() => {
            this.subscriptions.add(
                this.accountService
                    .findAccount(accountId)
                    .subscribe((account) => {
                        this.account = account;
                        this.accountDetails = account;
                        this.datapointsPageStateService.activeAccount = account;
                        this.account.datasets.forEach((dataset) => {
                            let isLocations =
                                dataset.geometryType ===
                                DatasetGeometryType.POINT;
                            if (dataset.id === datasetId) {
                                this.isMapView =
                                    (!viewMode ||
                                        viewMode.toUpperCase() ===
                                        DatapointsViewMode.MAP) &&
                                    dataset.geometryType !==
                                    DatasetGeometryType.NONE;
                                if (!this.isMapView) {
                                    this.fallBackToTableView(
                                        dataset.id,
                                        account.id
                                    );
                                }
                            }

                            if (isLocations) {
                                this.tessadataFieldsByDataset[dataset.id] = {
                                    externalFields: [],
                                    nriFields: [],
                             //       tensorflightFields: [],
                                    e2valueFields: [],
                                    munichreFields: [],
                                    naturalHazardFields: [],
                                    riskScoreFields: [],
                                    customScoreFields:[],
                                    preciselyBuildingFields:[],
                                    consolidatedRiskScoreFields:[],
                                    preciselyCrimeFields:[],
                                    preciselyWildfireRiskFields:[]
                                };
                                this.tessadataFieldsForview[dataset.id] = {
                                    externalFields: [],
                                    nriFields: [],
                              //      tensorflightFields: [],
                                    e2valueFields: [],
                                    munichreFields: [],
                                    naturalHazardFields: [],
                                    riskScoreFields: [],
                                    customScoreFields:[],
                                    preciselyBuildingFields:[],
                                    consolidatedRiskScoreFields:[],
                                    preciselyCrimeFields:[],
                                    preciselyWildfireRiskFields:[]
                                };
                            }

                            dataset.fields.forEach((field) => {
                                field.isDisplayedInFilter = true;
                                field.isDisplayedInProjection = true;
                                if (isLocations && field.isGenerated) {
                                    if (
                                        field.scope ===
                                        DatasetFieldScope.EXTERNAL
                                    ) {
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].externalFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].externalFields.push(field);
                                    }
                                    //  else if (
                                    //     field.scope ===
                                    //     DatasetFieldScope.TENSORFLIGHT
                                    // )
                                    // {
                                    //     this.tessadataFieldsByDataset[
                                    //         dataset.id
                                  /*    ].tensorflightFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                  ].tensorflightFields.push(field);  */
                                    //     ]
                                    // }
                                     else if (
                                        field.scope ===
                                        DatasetFieldScope.E2VALUE
                                    ) {
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].e2valueFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].e2valueFields.push(field);
                                    }
                                    else if (
                                        field.scope ===
                                        DatasetFieldScope.MUNICHRE
                                    ) {
                                        if (field.tags[1] === "Natural Hazards") {
                                            this.tessadataFieldsByDataset[
                                                dataset.id
                                            ].naturalHazardFields.push(field);
                                            this.tessadataFieldsForview[
                                                dataset.id
                                            ].naturalHazardFields.push(field);
                                        } else if (field.tags[1] === "Risk Scores") {
                                            this.tessadataFieldsByDataset[
                                                dataset.id
                                            ].riskScoreFields.push(field);
                                            this.tessadataFieldsForview[
                                                dataset.id
                                            ].riskScoreFields.push(field);
                                        }
                                    } else if(
                                        field.scope ===
                                        DatasetFieldScope.CUSTOM_SCORE
                                    ){
                                        // Filter out GLOBAL and EXTERNAL scope custom scores
                                        // Only include INTERNAL and FORMULA scope custom scores
                                        // Extract custom scoring ID from field ID (format: custom_score_{id})
                                        const customScoreId = field.id.replace('custom_score_', '');
                                        // Check if this custom score exists in our filtered list (INTERNAL/FORMULA only)
                                        const isValidCustomScore = this.customScorings.some(cs => cs._id === customScoreId);
                                        
                                        if (isValidCustomScore) {
                                            this.tessadataFieldsByDataset[dataset.id].customScoreFields.push(field);
                                            this.tessadataFieldsForview[dataset.id].customScoreFields.push(field);
                                        }
                                    }
                                    else if (
                                        field.scope === DatasetFieldScope.NRI
                                    ) {
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].nriFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].nriFields.push(field);
                                    } else if (
                                        field.scope === DatasetFieldScope.PRECISELY_BUILDING
                                    ){
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].preciselyBuildingFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].preciselyBuildingFields.push(field);
                                    } else if (
                                        field.scope === DatasetFieldScope.CONSOLIDATED_RISK_SCORE
                                    ){
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].consolidatedRiskScoreFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].consolidatedRiskScoreFields.push(field);
                                    } else if (
                                        field.scope === DatasetFieldScope.PRECISELY_CRIME
                                    ){
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].preciselyCrimeFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].preciselyCrimeFields.push(field);
                                    } else if (
                                        field.scope === DatasetFieldScope.PRECISELY_WILDFIRE_RISK
                                    ){
                                        this.tessadataFieldsByDataset[
                                            dataset.id
                                        ].preciselyWildfireRiskFields.push(field);
                                        this.tessadataFieldsForview[
                                            dataset.id
                                        ].preciselyWildfireRiskFields.push(field);
                                    }
                                }
                            });
                            this.tessadataFieldsByDataset[dataset.id]?.munichreFields.push(this.tessadataFieldsByDataset[dataset.id]?.naturalHazardFields)
                            this.tessadataFieldsByDataset[dataset.id]?.munichreFields.push(this.tessadataFieldsByDataset[dataset.id]?.riskScoreFields)
                            this.tessadataFieldsForview[dataset.id]?.munichreFields.push(this.tessadataFieldsForview[dataset.id]?.naturalHazardFields)
                            this.tessadataFieldsForview[dataset.id]?.munichreFields.push(this.tessadataFieldsForview[dataset.id]?.riskScoreFields)



                            if (isLocations) {
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].externalFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .externalFields
                                );
                                /* this.tessadataFieldsByDataset[
                                    dataset.id
                                ].tensorflightFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .tensorflightFields
                                ); */
                                this.tessadataFieldsByDataset[dataset.id]
                                .customScoreFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id].customScoreFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].e2valueFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .e2valueFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].nriFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .nriFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].preciselyBuildingFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .preciselyBuildingFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].consolidatedRiskScoreFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .consolidatedRiskScoreFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].preciselyCrimeFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .preciselyCrimeFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].preciselyWildfireRiskFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .preciselyWildfireRiskFields
                                );
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].consolidatedRiskScoreFields = this.sortFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .consolidatedRiskScoreFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].externalFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .externalFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                          /*      ].tensorflightFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .tensorflightFields
                                ); */
                                ]
                                this.tessadataFieldsForview[dataset.id]
                                .customScoreFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id].customScoreFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].e2valueFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .e2valueFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].nriFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .nriFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].preciselyBuildingFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .preciselyBuildingFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].consolidatedRiskScoreFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .consolidatedRiskScoreFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].preciselyCrimeFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .preciselyCrimeFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].preciselyWildfireRiskFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .preciselyWildfireRiskFields
                                );
                                this.tessadataFieldsForview[
                                    dataset.id
                                ].consolidatedRiskScoreFields = this.sortFields(
                                    this.tessadataFieldsForview[dataset.id]
                                        .consolidatedRiskScoreFields
                                );
                            }

                            // Sort External Fields By Alphabetical Name
                            const hasE2ValueData = this.tessadataFieldsByDataset[dataset.id]?.e2valueFields?.length > 0;

                            if (
                                this.tessadataFieldsByDataset[dataset.id] &&
                                (this.tessadataFieldsByDataset[dataset.id]
                                    .externalFields.length > 0 || /*this.tessadataFieldsByDataset[dataset.id]
                                    .tensorflightFields.length > 0 ||*/ hasE2ValueData || this.tessadataFieldsByDataset[dataset.id]
                                    .munichreFields.length > 0 || this.tessadataFieldsByDataset[dataset.id]
                                    .customScoreFields.length > 0 || this.tessadataFieldsByDataset[dataset.id]
                                    .preciselyBuildingFields.length > 0 || this.tessadataFieldsByDataset[dataset.id]
                                    .consolidatedRiskScoreFields.length > 0 || this.tessadataFieldsByDataset[dataset.id]
                                    .preciselyCrimeFields.length > 0 || this.tessadataFieldsByDataset[dataset.id]
                                    .preciselyWildfireRiskFields.length > 0 || this.tessadataFieldsByDataset[dataset.id]
                                    .consolidatedRiskScoreFields.length > 0)
                            ) {
                                this.tessadataGroups = dataset.fields
                                    .filter(
                                        (item) =>
                                            [DatasetFieldScope.EXTERNAL, DatasetFieldScope.E2VALUE, DatasetFieldScope.MUNICHRE, DatasetFieldScope.CUSTOM_SCORE, DatasetFieldScope.PRECISELY_BUILDING, DatasetFieldScope.CONSOLIDATED_RISK_SCORE, DatasetFieldScope.PRECISELY_CRIME, DatasetFieldScope.PRECISELY_WILDFIRE_RISK].includes(item.scope)
                                    )
                                    .reduce((groups, item) => {
		                                let scope = item.scope;
		                                if (scope == DatasetFieldScope.MUNICHRE || scope == DatasetFieldScope.CONSOLIDATED_RISK_SCORE) {
		                                    groups = {
		                                        ...groups,
		                                        [item.tags[0]]: [
		                                            ...(groups[item.tags[0]] || []).map(group =>
		                                                group[item.tags[1]] ? { ...group, [item.tags[1]]: [...group[item.tags[1]], item] } : group
		                                            ),
		                                            ...(groups[item.tags[0]]?.some(group => group[item.tags[1]]) ? [] : [{ [item.tags[1]]: [item] }])
		                                        ]
		                                    };
		                                }

		                                else {
		                                    groups = {
		                                        ...groups,
		                                        [item.tags[0]]: [
		                                            ...(groups[item.tags[0]] || []),
		                                            item,
		                                        ],
		                                    };
		                                }
		                                return groups;
		                            }, {});

                                for (const key in this.tessadataGroups) {
                                    if (
                                        Object.prototype.hasOwnProperty.call(
                                            this.tessadataGroups,
                                            key
                                        )
                                    ) {
                                        this.tessadataGroups[key] =
                                            this.sortFields(
                                                this.tessadataGroups[key]
                                            );
                                    }
                                }
                            }

                            if (
                                this.tessadataFieldsByDataset[dataset.id] &&
                                this.tessadataFieldsByDataset[dataset.id]
                                    .nriFields.length > 0
                            ) {
                                this.tessadataFieldsByDataset[
                                    dataset.id
                                ].nriFields = this.groupByNriFields(
                                    this.tessadataFieldsByDataset[dataset.id]
                                        .nriFields
                                );
                            }
                            dataset.isDisplayedInFilter = true;
                            dataset.isDisplayedInProjection = true;
                            this.datapointsPageStateService.storeDataset(
                                dataset
                            );
                            this.fieldsByIdsAndDataset.set(
                                dataset.id,
                                new Map<string, DatasetField>(
                                    dataset.fields.map((field) => [
                                        field.id,
                                        field,
                                    ])
                                )
                            );
                        });
                        this.datapointsPageStateService.accountDatasets =
                            this.account.datasets;
                        let selectedDataset =
                            this.datapointsPageStateService.getDataset(
                                datasetId
                            ) ||
                            this.datapointsPageStateService.getDataset(
                                account.datasets[0].id
                            ); // we shouldn't work on this
                        this.dataset = ObjectUtils.clone(selectedDataset);
                        this.datapointsPageStateService.setActiveDataset(
                            selectedDataset
                        ); // we save a different object in the state

                        this.sort.datasetID = this.dataset.id;
                        this.initContext(this.dataset);
                        this.datapointFilterObject =
                            this.constructFilterObject();
                        this.datasetFloatingFields = this.dataset.fields.filter(
                            (field) => field.isFloating
                        );
                        this.thematicMapMetric = this.datasetFloatingFields[0];
                        if (this.thematicMapMetric) {
                            this.thematicMapMetric.selectedForTM = true;
                        } else {
                            console.log(
                                "The dataset does not have any floating field"
                            );
                        }
                        // Get assigned Tessadata and rest all overlay to account and merged responce
                        this.subscriptions.add(
                            forkJoin(
                                this.overlayService.getAllAccountOverlays(
                                    this.account.id
                                ),
                                this.overlayService.getAccountTessadataOverlays(
                                    this.account.id
                                )
                            ).subscribe(
                                ([
                                    accountGlobalOverlay,
                                    accountExternalOverlay,
                                ]) => {
                                    // Added id name and groupid as to match Global Oject
                                    accountExternalOverlay.map((item) => {
                                        item.id = item.datasetId;
                                        item.name = item.datasetLabel;
                                        item.overlayGroupId =
                                            item.externalGroupId;
                                    });
                                    const overlays = [
                                        ...accountGlobalOverlay,
                                        ...accountExternalOverlay,
                                    ];
                                    this.accountOverlays = overlays;
                                    this.datapointsPageStateService.accountOverlays =
                                        overlays;
                                    overlays.forEach((overlay) => {
                                        overlay.isDisplayedInFilter = true;
                                        overlay.isDisplayedInProjection = true;
                                        this.fieldsByIdsAndDataset.set(
                                            overlay.id,
                                            new Map<string, DatasetField>(
                                                overlay.fields.map((field) => [
                                                    field.id,
                                                    field,
                                                ])
                                            )
                                        );
                                        this.datapointsPageStateService.storeDataset(
                                            overlay
                                        );
                                        overlay.fields.forEach((field) => {
                                            field.isDisplayedInFilter = true;
                                            field.isDisplayedInProjection =
                                                true;
                                        });
                                    });
                                    this.dataIsReadySubject.next({
                                        dataType: "account",
                                    });
                                }
                            )
                        );

                        // FAST PATH — getLinkedAccountApplications + getLinkedOverlays (~300ms)
                        // Unblocks datapoints load and shows Analytics menu as soon as these respond.
                        this.subscriptions.add(
                            forkJoin([
                                this.linkDatasetService.getLinkedAccountApplications(this.dataset.id),
                                this.linkDatasetService.getLinkedOverlays(this.dataset.id),
                            ]).pipe(
                                catchError((error) => {
                                    console.error('Error loading linked datasets/overlays:', error);
                                    // Return empty arrays to allow the app to continue
                                    return of([[], []]);
                                })
                            ).subscribe(([linkedDatasets, linkedOverlays]) => {
                                // Process getLinkedAccountApplications
                                this.linkedAccountDatasets = [
                                    ObjectUtils.clone(selectedDataset),
                                    ...linkedDatasets,
                                ];
                                this.linkedAccountDatasets[0].fields.forEach(
                                    (field) => {
                                        field.isProjected = field.id !== "created_on" &&
                                            field.id !== "updated_on" &&
                                            field.id !== "id";
                                    }
                                );
                                this.datapointsPageStateService.setLinkedAccountDatasets(
                                    linkedDatasets
                                );

                                // Sort original fields once, then clone (avoids double sort)
                                if (this.linkedAccountDatasets) {
                                    this.linkedAccountDatasets.forEach(
                                        (dataset) => {
                                            dataset.fields = this.sortFields(dataset.fields);
                                        }
                                    );
                                }
                                this.filterAccountDatasets = ObjectUtils.clone([selectedDataset]);
                                this.tableVilterAccountDatasets = ObjectUtils.clone([selectedDataset]);

                                // Recalculate mainSummaryFieldIndex on clone after sort
                                if (this.filterAccountDatasets) {
                                    this.filterAccountDatasets.forEach(
                                        (dataset) => {
                                            const tempField = dataset.fields[dataset.mainSummaryFieldIndex!];
                                            if (
                                                this.datapointsPageStateService.activeDatasetsOnMap.length > 0
                                            ) {
                                                this.datapointsPageStateService.activeDatasetsOnMap[0].mainSummaryFieldIndex =
                                                    dataset.fields.indexOf(tempField);
                                            }
                                            dataset.mainSummaryFieldIndex = dataset.fields.indexOf(tempField);
                                        }
                                    );
                                }
                                this.datapointsPageStateService.setFilterAccountDatasets(
                                    this.filterAccountDatasets
                                );

                                // If slow path already responded before us (race condition), run the deferred setup now
                                if (this._filterPanelSetupPending) {
                                    this._filterPanelSetupPending = false;
                                    this.setupFilterPanelDataSource();
                                }

                                // Process getLinkedOverlays
                                this.linkedAccountOverlays = linkedOverlays;
                                this.datapointsPageStateService.setLinkedAccountOverlays(linkedOverlays);

                                // Unblock datapoints load
                                this.initializeDatasetFilterSelectedState();
                            })
                        );

                        // SLOW PATH — linkedGroupOverlays fires simultaneously but resolves later (~15s)
                        // Processes overlay data for filter panel and analytics field dropdowns.
                        // filterAccountDatasets is guaranteed set by fast path before this responds.
                        this.subscriptions.add(
                            this.linkDatasetService.linkedGroupOverlays(this.dataset.id).pipe(
                                catchError(() => {
                                    this.overlaysLoading = false;
                                    this.isFilterAttributesPrepared = true;
                                    if (this.pendingAnalyticsAction) {
                                        this.loaderStateService.update(false);
                                        this.pendingAnalyticsAction = null;
                                    }
                                    return of([]);
                                })
                            ).subscribe((groupOverlays: any[]) => {
                                if (groupOverlays && groupOverlays.length) {
                                    const res = groupOverlays;
                                    const information =
                                        res.filter(
                                            (element) =>
                                                element.group.name.toLowerCase() ==
                                                "information"
                                        );
                                    res.forEach((element) => {
                                        if (
                                            element.children
                                                .length
                                        ) {
                                            element.children.sort(
                                                (
                                                    item1: any,
                                                    item2: any
                                                ) => {
                                                    if (
                                                        item1 &&
                                                        item1
                                                            .group
                                                            .name &&
                                                        item2 &&
                                                        item2
                                                            .group
                                                            .name
                                                    ) {
                                                        return item1.group.name
                                                            .trim()
                                                            .toLowerCase()
                                                            .localeCompare(
                                                                item2.group.name
                                                                    .trim()
                                                                    .toLowerCase()
                                                            );
                                                    }
                                                }
                                            );
                                        }
                                    });
                                    res.sort((a, b) =>
                                        a.group.name >
                                            b.group.name
                                            ? -1
                                            : 1
                                    );
                                    let index = res.findIndex(
                                        (group) =>
                                            group.group.name.toLowerCase() ===
                                            "information"
                                    );
                                    if (index !== -1) {
                                        res.splice(index, 1);
                                    }
                                    this.filterAccountOverlays = res as any;

                                    // Hide Private Overlays - if exists - for a not superadmin user until BE code for this will be implemented
                                    if (
                                        !this.userStateService
                                            .isSuperadmin
                                    ) {
                                        let index =
                                            this.filterAccountOverlays.findIndex(
                                                (group) =>
                                                    group.group
                                                        .name ===
                                                    "Private Overlays"
                                            );
                                        if (index !== -1) {
                                            this.filterAccountOverlays.splice(
                                                index,
                                                1
                                            );
                                        }
                                    }
                                    this.filterAccountOverlays = (
                                        !isUndefined(information)
                                            ? [
                                                ...this.filterAccountOverlays,
                                                ...information,
                                            ]
                                            : this.filterAccountOverlays
                                    ) as any;

                                    this.filterAccountOverlays =
                                        this.prepareFilterAcccountOverlays(
                                            this
                                                .filterAccountOverlays
                                        );
                                }

                                // Always setup filter panel data source, even if overlays are empty
                                if (this.filterAccountDatasets?.length) {
                                    this.setupFilterPanelDataSource();
                                } else {
                                    // filterAccountDatasets not ready yet (rare race condition)
                                    // fast path will call setupFilterPanelDataSource() once it sets filterAccountDatasets
                                    this._filterPanelSetupPending = true;
                                }

                                this.isFilterAttributesPrepared = true;

                                // Overlays ready — execute any queued analytics action
                                this.overlaysLoading = false;
                                if (this.pendingAnalyticsAction) {
                                    this.loaderStateService.update(false);
                                    this.pendingAnalyticsAction();
                                    this.pendingAnalyticsAction = null;
                                }
                            })
                        );

                        this.fetchWorkspaceItems();
                    })
            );
        });

        this.subscriptions.add(
            this.datapointsFilterService
                .onFilterChange()
                .pipe(debounceTime(200))
                .subscribe((newFilter) => {
                    // An exception thrown here would terminate the subscription,
                    // leaving the map permanently stale: shapes would keep being
                    // computed but the tile layer would never regenerate again.
                    // Contained so one bad filter costs one refresh, not all of them.
                    try {
                        this.filter = newFilter;

                        // Datapoint markers are server-rendered tiles, so a filter
                        // change only takes effect once the tiles are re-fetched.
                        // The cache-buster in the tile URL is the version token, and
                        // nothing was bumping it on a filter change - so tiles
                        // fetched for a previous shape position kept rendering their
                        // markers, which appear outside the shape's new bounds.
                        this.tileVersionService.incrementVersionToken();

                        if (
                            this.filter.geometryFilter &&
                            this.filter.geometryFilter.unionShapes &&
                            this.filter.geometryFilter.unionShapes.length &&
                            !this.datapointsOverlaysComponent.datasetChecked
                        ) {
                            this.datapointsOverlaysComponent.datasetChecked = true;
                        }

                        this.fetchDatapoints();
                        if (this.datasetIsDisabled) {
                            this.disableOverlay(this.dataset.id);
                        }
                        if (this.isThematicMapActive) {
                            this.mapThematicOverlayService.setActive(
                                this.mapThematicOverlayService.currentConfig
                            );
                        }
                    } catch (error) {
                        console.error('[onFilterChange] failed to apply filter', error);
                    }
                })
        );

        this.subscriptions.add(
            this.datapointsFilterService
                .onFilterBarItemsChange()
                .subscribe((filterBarItems) => {
                    this.filterBarItems = filterBarItems;
                    // this.applyFilters();
                })
        );

        let previousOverlay: string | null = null;

        this.subscriptions.add(
            this.mapThematicOverlayService
                .getActive()
                .subscribe((overlaySettings) => {
                    // here we get an empty element if we have to disable thematic map. this is not ideal
                    this.activeThematicMapConfig = overlaySettings;
                    this.removeThematicMapLegends();
                    if (previousOverlay) {
                        this.disableOverlay(previousOverlay);
                    }
                    if (!this.activeThematicMapConfig.dataset) {
                        return; // we have an empty object. we have to remove everything
                    }

                    let formula = this.thematicMapFormula
                        ? JSON.parse(this.thematicMapFormula.data).formula
                        : null;
                    let metricId = this.thematicMapMetric
                        ? this.thematicMapMetric.id
                        : null;
                    let tempFilter = ObjectUtils.clone(
                        this.filter
                    );
                    if (this.isThematicMapActive && this.mapThematicOverlayService.currentConfig.parentDatasetId !== null) {
                        const field: DatapointFilterField[] = [{ id: 'link_' + this.mapThematicOverlayService.currentConfig.parentDatasetId, maxDateValue: null, minDateValue: null, maxNumberValue: null, minNumberValue: 0, searchValue: null, textValues: [this.mapThematicOverlayService.currentConfig.geometryID.geometryID], distanceUnit: null }];
                        tempFilter.fields = tempFilter.fields.length > 0 ? [...tempFilter.fields, ...field] : field;
                    }
                    let filter: DatapointFilter = JSON.parse(
                        JSON.stringify(tempFilter)
                    );
                    if (overlaySettings.filter) {
                        filter.links.push(overlaySettings.filter);
                    }

                    if (metricId === null && formula === null) {
                        this.notifService.error(
                            "Thematic Map View must have a selected Value field or formula"
                        );
                        return;
                    }

                    if (this.thematicMapGrouping === "") {
                        this.notifService.error(
                            "Please select a Grouping option for a selected Value field or formula"
                        );
                        return;
                    }

                    let thematicMapIntervals;

                    this.subscriptions.add(
                        this.datapointAggregateService
                            .getDatapointsAggregateMinMaxForLinkedDatasets(
                                this.dataset.id,
                                this.activeThematicMapConfig.dataset.id,
                                this.thematicMapGrouping,
                                metricId,
                                formula,
                                filter
                            )
                            .subscribe((aggregate) => {
                                thematicMapIntervals =
                                    this.mapThematicOverlayService.getThematicMapIntervals(
                                        aggregate.min,
                                        aggregate.max,
                                        aggregate.total
                                    );
                                this.addLegend(
                                    this.activeThematicMapConfig.dataset.id,
                                    thematicMapIntervals,
                                    true,
                                    "Thematic Map"
                                );
                                this.thematicMapTotal = aggregate.total;
                                this.accumulationsSerivce.thematicMapTotal = aggregate.total;
                                this.accumulationsSerivce.emitThematicMapTotalValue(aggregate.total);

                                let converterType = this.thematicMapFormula
                                    ? DatapointConverterType.FORMULA
                                    : thematicMapOverlayRenderingOptions
                                        .converterOptions.type;
                                let accountApplicationFieldId: any = null;
                                if (this.thematicMapMetric) {
                                    accountApplicationFieldId =
                                        this.thematicMapMetric.id;
                                } else if (this.thematicMapFormula) {
                                    let currentLevelDataset =
                                        this.mapThematicOverlayService
                                            .currentConfig.dataset;
                                    let currentLevelDatasetThematicField =
                                        currentLevelDataset.fields.find(
                                            (field) =>
                                                field.id ===
                                                currentLevelDataset
                                                    .thematicMapSettings
                                                    .mainThematicFieldId
                                        );
                                    let breakdownFields =
                                        this.getBreakdownFields(
                                            currentLevelDataset,
                                            currentLevelDatasetThematicField
                                        );
                                    const field = !isUndefined(
                                        breakdownFields[
                                            breakdownFields.length - 1
                                        ].get(this.dataset.id)
                                    )
                                        ? breakdownFields[
                                            breakdownFields.length - 1
                                        ].get(this.dataset.id)[0].id
                                        : null;
                                    accountApplicationFieldId = field;
                                }

                                let event = {
                                    active: this.isThematicMapActive,
                                    datasetID: overlaySettings.dataset.id,
                                    renderingOptions: {
                                        converterOptions: {
                                            ...thematicMapOverlayRenderingOptions.converterOptions,
                                            accountApplicationGroups:
                                                this.datapointsPageStateService
                                                    .activeGroups,
                                            accountApplicationDatasetId:
                                                this.dataset.id,
                                            datasetID:
                                                overlaySettings.dataset.id,
                                            accountApplicationFieldId:
                                                accountApplicationFieldId,
                                            formula: formula,
                                            grouping:
                                                Grouping[
                                                this.thematicMapGrouping
                                                ],
                                            type: converterType,
                                        },
                                        datasetStylingOptions: {
                                            ...overlaySettings.stylingOptions,
                                            intervalOptions:
                                                thematicMapIntervals,
                                        },
                                        visualizationOptions:
                                            thematicMapOverlayRenderingOptions.visualizationOptions,
                                    },
                                    filter: overlaySettings.filter,
                                };
                                this.onToggleOverlay(event);
                                if (this.isThematicMapActive) {
                                    this.getFloatingFieldsValues();
                                }
                                previousOverlay = overlaySettings.dataset.id;
                                if (
                                    this.thematicMapGrouping ===
                                    this.groupingEnum.COUNT
                                ) {
                                    this.thematicMapMetric = undefined;
                                }
                            })
                    );
                    this.updateAggregateChartPanel();
                })
        );

        this.openThematicMapOnPageLoad = history.state.openThematicMap;
        this.dataIsReadySubject.subscribe((a) => {
            if (a.dataType === "account") {
                this.accountDataIsReady = true;
            }
            if (a.dataType === "groups") {
                this.groupsReady = true;
            }
            if (this.openThematicMapOnPageLoad) {
                if (this.accountDataIsReady && this.groupsReady) {
                    this.toggleThematicMap(true);
                    this.toggleAggregateChartPanel();
                }
            }
        });

        this.getReports(datasetId, accountId);
        this.groupService.getGroupsAsTree(datasetId, accountId).subscribe(groups => {
            this.accGroups = [];
            const ids: number[] = [];
            const collectIds = (nodes: any[]) => {
                nodes.forEach(node => {
                    ids.push(node.value.id);
                    if (node.children && node.children.length > 0) {
                        collectIds(node.children);
                    }
                });
            };
            collectIds(groups);
            this.accGroups = ids
            if (this.datapointsFilterService.getActiveFilter() && this.datapointsFilterService.getActiveFilter()?.datasetID && this.datapointsFilterService.getActiveFilter().datasetID !== datasetId) {
                this.datapointsFilterService.getActiveFilter().datasetID = datasetId;
                this.datapointsFilterService.getActiveFilter().groups = this.accGroups;
            }
        });
        this.subscriptions.add(
            this.datapointsFilterService.onFilterChange().pipe(debounceTime(200)).subscribe(newFilter => {
                this.filterChanged = true;
                this.getDyIndi(accountId, newFilter);
            })
        );
        this.subscriptions.add(
            this.datapointsPageStateService.onDatapointsChanged().pipe(debounceTime(200)).subscribe(() => {
                const currentFilter = this.datapointFilterObject?.filter ?? this.datapointsFilterService.getActiveFilter();
                this.getDyIndi(accountId, currentFilter);
            })
        );

    }

    prepareFilterAcccountOverlays(overlays) {
        overlays.forEach((element, key) => {
            this.parentOverlay = element;
            if (element.children.length <= 0 && element.overlays.length <= 0) {
                overlays.splice(key, 1);
                return;
            } else if (element.children.length > 0) {
                this.recursiveFilterAccountOverlay(element);
            }
            if (element.children.length <= 0 && element.overlays.length <= 0) {
                overlays.splice(key, 1);
            }
        });
        return overlays;
    }

    recursiveFilterAccountOverlay(element) {
        if (element.children.length) {
            let groupIds = [];
            element.children.forEach((sub_element, key) => {
                if (
                    sub_element.children.length <= 0 &&
                    sub_element.overlays.length <= 0
                ) {
                    groupIds.push(sub_element.group.id);
                } else if (sub_element.children.length > 0) {
                    element.children = element.children.filter(
                        (params) => !groupIds.includes(params.group.id)
                    );
                    this.recursiveFilterAccountOverlay(sub_element);
                    return;
                }
            });

            if (groupIds.length) {
                element.children = element.children.filter(
                    (params) => !groupIds.includes(params.group.id)
                );
                this.recursiveFilterAccountOverlay(this.parentOverlay);
            }
        }
    }

    prepareViewFilterAccountOverlays(overlays, emitUpdate: boolean = true) {
        let groupIds = [];
        // overlays = overlays.filter((overlay) => overlay.group.name !== 'Climate');
        overlays.forEach((element, key) => {
            this.parentOverlay = element;
            if (element.children.length <= 0 && element.overlays.length <= 0) {
                overlays.splice(key, 1);
                return;
            } else if (element.children.length > 0) {
                this.filterAccountOverlaysCallback(element);
            }

            if (!isUndefined(element.overlays) && element.overlays.length > 0) {
                const overlays = element.overlays.filter(
                    (overlay) => ['ipcc', "climate_change", "climatology"].includes(overlay.geoWorkspace)
                );
                element.overlays = overlays;
                if (element.overlays.length > 0) {
                    element.overlays.forEach((sub_element, sub_element_key) => {
                        const filterValue = sub_element.fields.filter(
                            (field_element) =>
                                field_element.displayInDropdowns == true
                        );
                        sub_element.fields = [];
                        if (filterValue.length) {
                            filterValue.forEach(element => {
                                element.isProjected = false;
                                this.addProjectionField(sub_element, element);
                            });
                            sub_element.fields = filterValue;
                        } else {
                            element.overlays.splice(sub_element_key);
                        }
                    });
                }
            }
            if (element.children.length <= 0 && element.overlays.length <= 0) {
                groupIds.push(element.group.id);
            }
        });
        overlays = overlays.filter(overlay => !groupIds.includes(overlay.group.id));
        if (emitUpdate) {
            this.datapointFilterObject = this.constructFilterObject();
            this.datapointsFilterService.updateFilter();
        }
        return overlays;
    }

    filterAccountOverlaysCallback(element) {
        if (element.children.length) {
            let groupIds = [];
            element.children.forEach((sub_element, key) => {
                if (
                    sub_element.children.length <= 0 &&
                    sub_element.overlays.length <= 0
                ) {
                    groupIds.push(sub_element.group.id);
                } else if (sub_element.children.length > 0) {
                    element.children = element.children.filter(
                        (params) => !groupIds.includes(params.group.id)
                    );
                    this.filterAccountOverlaysCallback(sub_element);
                    return;
                }

                if (sub_element.overlays.length) {
                    const overlays = sub_element.overlays.filter(
                        (overlay) => ['ipcc', "climate_change", "climatology"].includes(overlay.geoWorkspace)
                    );
                    sub_element.overlays = overlays;
                    if (sub_element.overlays.length > 0) {
                        sub_element.overlays.forEach((overlay, sub_element_key) => {
                            const filterValue = overlay.fields.filter(field_element => field_element.displayInDropdowns == true);
                            overlay.fields = [];
                            if (filterValue.length) {
                                filterValue.forEach(element => {
                                    element.isProjected = false;
                                    this.addProjectionField(overlay, element);
                                });
                                overlay.fields = filterValue;
                            } else {
                                sub_element.overlays.splice(sub_element_key);
                            }
                        });
                    }
                }

                if (
                    sub_element.children.length <= 0 &&
                    sub_element.overlays <= 0
                ) {
                    groupIds.push(sub_element.group.id);
                }
            });

            if (groupIds.length) {
                element.children = element.children.filter(
                    (params) => !groupIds.includes(params.group.id)
                );
                this.filterAccountOverlaysCallback(this.parentOverlay);
            }
        }
    }

    private setupFilterPanelDataSource() {
        const climateFilterAccountOverlays = this.prepareClimateOverlays();
        this.sortedFilterAccountOverlays = [];
        if ([MaptycsApplication.CLAIMS, MaptycsApplication.POLICIES].includes(this.dataset.application)) {
            this.dataSource.data = [
                ...this.datapointObject.prepareDataset(this.filterAccountDatasets, this.filterAccountDatasets[0])
            ];
            this.filterAttributes = {
                A: this.tableVilterAccountDatasets,
                B: [], C: [], D: [], E: []
            };
        } else {
            const overlays = [
                ...this.datapointObject.prepareTesadata(this.tessadataGroups, this.filterAccountDatasets[0]),
                ...this.datapointObject.prepareNRIFields(
                    this.filterAccountDatasets,
                    this.tessadataFieldsByDataset,
                    this.tessadataEnabled,
                    this.filterAccountDatasets[0]
                ),
                ...this.datapointObject.prepareClimateData(climateFilterAccountOverlays, false)
            ];
            this.dataSource.data = [
                ...this.datapointObject.prepareDataset(this.filterAccountDatasets, this.filterAccountDatasets[0]),
                ...sortArrayByName(overlays)
            ];
            this.filterAttributes = {
                A: this.tableVilterAccountDatasets,
                B: this.tessadataGroups,
                C: [
                    this.tessadataEnabled,
                    this.tessadataFieldsByDataset,
                ],
                E: [],
            };
        }
    }

    sortFields(fields: DatasetField[]) {
        fields.sort((item1, item2) => {
            if (item1 && item1.name && item2 && item2.name) {
                return item1.name
                    .trim()
                    .toLowerCase()
                    .localeCompare(item2.name.trim().toLowerCase());
            }
        });
        return fields;
    }

    get datasetFieldScope() {
        return DatasetFieldScope;
    }

    selectThematicMapFormula(item: WorkspaceItem, $event: MatCheckboxChange) {
        this.mapThematicOverlayService.emitCustomizedLegends([]);
        this.customLegendsEnabled = false;
        this.legendLimitForm.reset();
        if ($event.checked) {
            this.thematicMapFormula = item;
            this.workspaceItemsForFormulas.forEach((f) => {
                f.selectedForTM = f.id === item.id;
            });
            this.thematicMapMetric = undefined;
            this.dataset.fields.forEach((f) => (f.selectedForTM = false));
        } else {
            this.thematicMapFormula = undefined;
        }
        if (this.isThematicMapActive) {
            this.mapThematicOverlayService.setActive(
                this.mapThematicOverlayService.currentConfig
            );
        }
    }

    confirmCoordinatesChange() {
        this.moveLocationModeEnabled = false;
        const request: UpdateDatapointRequest = {
            id: this.mapDatapointInfo.datapointID,
            fields: [],
            location: this.mapDatapointInfo.location,
            version: this.mapDatapointInfo.version,
        };
        this.datapointsService
            .updateDatapoint(
                this.dataset.id,
                this.mapDatapointInfo.datapointID,
                request
            )
            .subscribe((success) => {
                this.notifService.success("The datapoint location was updated");
                this.mapStateService.updateOverlay(
                    this.dataset.id,
                    this.generatePortfolioLayer(true)
                );
                this.selectedLocationClone = ObjectUtils.clone(
                    this.mapDatapointInfo.location
                );
            });
    }

    cancelCoordinatesChange() {
        this.moveLocationModeEnabled = false;
        this.mapDatapointInfo.location = ObjectUtils.clone(
            this.selectedLocationClone
        );
    }

    /**
     * Get the display name for an overlay, checking if it's a climate indicator
     * @param overlayId - The overlay ID (e.g., 'climate_t', 'climate_pr', 'climate_tx35')
     * @param overlayName - The fallback overlay name
     * @returns The display name from CLIMATE_INDICATORS_LEGEND (with CMIP6 prefix for climatology) or the original overlay name
     */
    private getOverlayDisplayName(overlayId: string, overlayName: string, climatologyOptions?: ClimatologyOptions): string {
        // Check via climatologyOptions if available (colorize markers path)
        if (climatologyOptions?.enabled && climatologyOptions.selectedIndicator) {
            const indicator = CLIMATE_INDICATORS_LEGEND[climatologyOptions.selectedIndicator.toLowerCase()];
            if (indicator) {
                return 'CMIP6 - ' + indicator.name;
            }
        }
        // Check via overlay.id directly (left panel toggle path)
        if (overlayId) {
            const lowerOverlayId = overlayId.toLowerCase();
            // Direct match (e.g., 'climate_cd')
            let indicator = CLIMATE_INDICATORS_LEGEND[lowerOverlayId];
            if (indicator) {
                return 'CMIP6 - ' + indicator.name;
            }
            // Prefix match for IDs like 'climate_cd_change' — find the longest matching key
            for (const key of Object.keys(CLIMATE_INDICATORS_LEGEND)) {
                if (lowerOverlayId.startsWith(key)) {
                    indicator = CLIMATE_INDICATORS_LEGEND[key];
                    return 'CMIP6 - ' + indicator.name;
                }
            }
        }
        return overlayName;
    }

    /**
     * The Consolidated Risk Score legend rows (FR-1.49): one per score, highest first.
     *
     * Built from the scale rather than from the data, so the reader sees the whole scale and can
     * tell a score that is absent from one that is merely unused in the current view.
     */
    private consolidatedRiskScoreLegend(): IntervalOption[] {
        const rows: IntervalOption[] = [];
        for (let score = CONSOLIDATED_RISK_SCORE_COLORS.length - 1; score >= 0; score--) {
            rows.push({
                color: ColorUtils.colorFromBase64(CONSOLIDATED_RISK_SCORE_COLORS[score]),
                minValue: score,
                maxValue: score,
                total: 0,
            });
        }
        // addLegend reverses the rows it is handed, so give it the reverse of how they should
        // read. Built in display order above to keep that order visible here rather than implied.
        return rows.reverse();
    }

    private addLegend(
        datasetId: string,
        intervalOptions: IntervalOption[],
        isThematicMapLegend: boolean,
        datasetName?: string,
        fieldLabel?: string,
        gradientDetails?: GradientDetails,
        climatologyOptions?: ClimatologyOptions
    ) {
        this.removeLegend(datasetId);
        // text intervals with a configured value sequence are already in display order
        const hasConfiguredOrder = Array.isArray(intervalOptions) &&
            intervalOptions.every(interval => interval.isTextInterval) &&
            hasFieldValueOrder(intervalOptions.map(interval => interval.minValue), datasetId);
        const reversedIntervals = Array.isArray(intervalOptions) && !hasConfiguredOrder
            ? [...intervalOptions].reverse()
            : intervalOptions;
        this.legends.push({
            datasetId: datasetId,
            intervals: reversedIntervals,
            datasetName: datasetName,
            fieldLabel: fieldLabel,
            isForThematicMap: isThematicMapLegend,
            gradientDetails: gradientDetails,
            climatologyOptions: climatologyOptions,
        });
        if (!isThematicMapLegend) {
            this.shouldHaveBackgroundColor = true;
        }
    }

    fetchExternalData(dataset: TessadataDataset, event, refresh: boolean) {
        if (event) {
            let selectedDatapointIds =
                this.tableComponent.getSelectedDatapointIds();
            if (
                selectedDatapointIds.length > 0 ||
                this.tableComponent.selectAll
            ) {
                // Track external data fetch
                this.analytics.trackEvent('external_data_fetch');
                if (refresh === true) {
                    const dialogRef = this.dialog.open(DialogComponent, {
                        data: new DialogModel("Confirm Action", `Please confirm you want to fetch again all the data for the selected locations.`),
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        if (result === true) {
                            this.tableComponent.fetchExternalData(
                                [dataset.datasetId],
                                refresh,
                                selectedDatapointIds
                            );
                        }
                        else {
                            // Do nothing. just close it.
                        }
                    });

                }
                else {
                    this.tableComponent.fetchExternalData(
                        [dataset.datasetId],
                        refresh,
                        selectedDatapointIds
                    );
                }
            }
            else {
                dataset.checked = false;
                this.notifService.error(
                    "Please select one or more datapoints and try again"
                );
            }
        }
    }


    openLocationProfile(datapoint: ClusterDatapoint) {
        this.mapDatapointInfo = {
            location: datapoint.location,
            version: datapoint.version,
            datapointID: datapoint.id,
            dataset: this.dataset,
            refresh: false,
        };
        this.locationProfilePanel.onExpandedClick(true);
    }

    removeLegend(datasetId: string) {
        let searchElement = this.legends.find(
            (legend) => legend.datasetId === datasetId
        );
        if (searchElement) {
            let index = this.legends.indexOf(searchElement);
            this.legends.splice(index, 1);
        }
        if (this.legends.length === 1 && this.legends[0].isForThematicMap) {
            this.shouldHaveBackgroundColor = false;
        }
    }

    private removeThematicMapLegends() {
        this.legends = this.legends.filter(
            (legend) => !legend.isForThematicMap
        );
    }

    constructFilterObject(): DatapointFilterObject {
        const { limit, skip, sort, projection, filter } = this;
        let filterObject: DatapointFilterObject = {
            projection,
            filter,
            limit,
            skip,
            sort,
        };
        return filterObject;
    }

    getDefaultFilterObject(): DatapointFilterObject {
        let projection = {
            datasetID: this.dataset.id,
            fields: this.dataset.fields
                .filter((field) => field.isSummary)
                .map((field) => field.id),
            links: [],
        };

        let filter = {
            datasetID: this.dataset.id,
            groups: this.getSelectedGroupsIds() || [],
            fields: [],
            links: [],
        };
        let sort = Object.assign({}, DEFAULT_SORT);

        sort.datasetID = this.dataset.id;
        let filterObject: DatapointFilterObject = {
            projection,
            filter,
            limit: LIMIT,
            skip: DEFAULT_SKIP,
            sort,
        };
        return filterObject;
    }

    onMapReady() {
        if (this.groupsReady) {
            let activeOverlays: Dataset[] = ObjectUtils.clone(
                this.datapointsPageStateService.activeDatasetsOnMap
            );

            // Check if main dataset is in the active overlays
            const mainDatasetInOverlays = activeOverlays.find(
                (dataset) => dataset.id === this.dataset.id
            );

            if (!mainDatasetInOverlays) {
                // Main dataset is not in activeOverlays
                // Check if it should be added based on its state
                if (!this.datasetIsDisabled && this.dataset.isSelected !== false) {
                    // Main dataset should be enabled - add it to the list
                    activeOverlays.push(this.dataset);
                } else {
                    // Main dataset is disabled or unchecked - don't add it
                    this.dataset.isSelected = false;
                }
            }

            let overlaysRenderingOptions: Map<string, RenderingOptions> =
                this.datapointsOverlaysComponent.getOverlaysRenderingOptions();

            this.datapointsPageStateService.activeDatasetsOnMap = []
            activeOverlays.forEach((dataset, i) => {
                let event: ActivateOverlayEvent = {
                    active: true,
                    datasetID: dataset.id,
                    renderingOptions: overlaysRenderingOptions.get(dataset.id),
                };
                this.enableOverlay(dataset.id, event);
            });

            this.initializeShapesFromActiveFilter();
            this.initializeZoomFromActiveFilter();
        }
        this.mapReady = true;
    }

    private fetchWorkspaceItems() {
        let previousFormulaSelection = {};
        this.workspaceItemsForFormulas.forEach((item) => {
            previousFormulaSelection[item.id] = item.isProjected;
        });
        this.workspaceItemsForFormulas = [];
        this.workspaceItemsForTableProjection = [];
        this.workspaceItemsForFilter = [];
        this.workspaceItemsForAnalytics = [];

        // Fetch layer expose fields for clustering
        this.fetchLayerExposeFieldsForClustering();

        this.subscriptions.add(
            this.workspaceItemsService
                .getAllWorkspaceItemsForUser(this.dataset.id)
                .subscribe((items) => {
                    items.forEach((item) => {
                        switch (item.type) {
                            case WorkspaceItemType.FILTER:
                                this.workspaceItemsForFilter.push(item);
                                break;
                            case WorkspaceItemType.TABLE_PROJECTION:
                                this.workspaceItemsForTableProjection.push(
                                    item
                                );
                                break;
                            case WorkspaceItemType.ANALYTICS:
                            case WorkspaceItemType.ANALYTICS_COMPARISON:
                                this.workspaceItemsForAnalytics.push(item);
                                break;
                            case WorkspaceItemType.FORMULA:
                                item.isProjected =
                                    previousFormulaSelection[item.id]; // we don't want to lose old projections
                                this.workspaceItemsForFormulas.push(item);
                                break;
                        }
                        if (
                            this.userStateService.isSuperadmin ||
                            this.userStateService.isAccountAdmin(
                                this.account.id
                            )
                        ) {
                            item.isDeletable = true;
                        } else {
                            if (item.access === WorkspaceItemAccess.MEMBER) {
                                item.isDeletable = true;
                            }
                        }
                    });

                // Sort workspaceItemsForFormulas alphabetically by name
                this.workspaceItemsForFormulas.sort((a, b) => {
                    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
                });

                // Categorize and sort analytics items by access type
                this.categorizeAndSortAnalyticsItems();

                // Refresh dynamic indicator setup after formulas are loaded
                if (this.accountDetails) {
                    this.settingDynamicIndicator();
                }

                this.saveFilterDataSource.data = [
                    {
                        name: "Open",
                        children: this.workspaceItemsForFilter,
                    },
                ];
                })
        );
    }

    /**
     * Fetch layer expose fields for clustering panel
     */
    private fetchLayerExposeFieldsForClustering() {
        this.layerExposeService.getAppliedLayerExpose(this.account.id).subscribe(
            (data) => {
                if (Array.isArray(data) && data.length > 0) {
                    this.layerExposeFields = data.map((equation) => ({
                        id: equation.id,
                        accountId: equation.accountId,
                        name: equation.name,
                        baseValue: equation.baseValue,
                        layerValue: equation.layerValue,
                        attachmentPoint: equation.attachmentPoint,
                        isApplied: equation.isApplied,
                        participation: equation.participation,
                    }));
                } else {
                    this.layerExposeFields = [];
                }
            },
            (error) => {
                console.error("Failed to fetch layer expose fields for clustering", error);
                this.layerExposeFields = [];
            }
        );
    }

    private initializeShapesFromActiveFilter() {
        let geometryFilter =
            this.datapointsFilterService.getActiveFilter().geometryFilter;
        this.initializeShapesFromFilter(geometryFilter);
    }

    private initializeShapesFromFilter(geometryFilter) {
        // Clear existing custom circles before loading new filter shapes
        // Pass false to prevent filter update during restoration (preserve geometryFilter.unionShapes)
        if (this.mapComponent) {
            this.mapComponent.clearAllCustomCircles(false);
        }

        if (geometryFilter && geometryFilter.unionShapes) {
            // Pass 1: add polygons and rectangles first so polygons.select / rectangles.select
            // are fully populated before circles trigger updateFilterWithAllCircles().
            geometryFilter.unionShapes.forEach((shape) => {
                switch (shape.type) {
                    case Type.POLYGON:
                        let polygon = new google.maps.Polygon({
                            clickable: false
                        });
                        let paths: google.maps.LatLng[] = [];
                        let i = 0;
                        while (i < shape.coordinates.length) {
                            paths.push(
                                new google.maps.LatLng(
                                    shape.coordinates[i + 1],
                                    shape.coordinates[i]
                                )
                            );
                            i += 2;
                        }
                        polygon.setPath(paths);
                        this.mapStateService.insertShape(
                            polygon,
                            OverlayType.POLYGON
                        );
                        break;
                    case Type.BOUNDS:
                        let rectangle = new google.maps.Rectangle({
                            clickable: false
                        });
                        const bounds = {
                            south: shape.bottom,
                            west: shape.left,
                            north: shape.top,
                            east: shape.right,
                        };
                        rectangle.setBounds(bounds);
                        this.mapStateService.insertShape(
                            rectangle,
                            OverlayType.RECTANGLE
                        );
                        break;
                }
            });

            // Pass 2: add circles — addCustomCircleFromFilter ends with updateFilterWithAllCircles()
            // which writes the complete filter now that polygons/rectangles are already in their arrays.
            geometryFilter.unionShapes.forEach((shape: any) => {
                if (shape.type === Type.CIRCLE && this.mapComponent) {
                    this.mapComponent.addCustomCircleFromFilter(
                        shape.center.y,
                        shape.center.x,
                        shape.radius,
                        shape.unit
                    );
                }
            });
        }
    }

    onGroupsReady(groupIDs: number[]) {
        const accountId = +this.route.snapshot.paramMap.get("accountId");
        const key = getGroupsLocalStorageKey(accountId);
        localStorage.setItem(key, JSON.stringify(groupIDs));
        this.filter.groups = groupIDs;
        if (
            groupIDs.length > 0 &&
            this.datapointsOverlaysComponent &&
            this.datapointsOverlaysComponent.isDatasetChecked
        ) {
            this.fetchDatapoints();
            if (!this.groupsReady) {
                this.dataIsReadySubject.next({ dataType: "groups" });
            }
        } else {
            this.dataIsReadySubject.next({ dataType: "groups" });
        }
    }

    initContext(dataset: Dataset) {
        let converterOptions: DatapointConverterOptions = {
            type: DatapointConverterType.NONE,
            datasetID: dataset.id,
            fieldID: this.dataset.stylingOptions
                ? this.dataset.stylingOptions.colorizationFieldIndex
                    ? this.dataset.fields[
                        this.dataset.stylingOptions.colorizationFieldIndex
                    ].id
                    : null
                : null,
        };
        this.renderingOptions = {
            datasetStylingOptions: this.dataset.stylingOptions,
            converterOptions: converterOptions,
            visualizationOptions: { type: VisualizationType.DEFAULT },
        };

        // Store a deep copy of the initial rendering options for reset functionality
        this.initialRenderingOptions = JSON.parse(JSON.stringify(this.renderingOptions));

        this.filter = {
            datasetID: dataset.id,
            groups: this.getSelectedGroupsIds() || [],
            fields: [],
            links: [],
        };

        this.datapointsFilterService.initFilter(this.filter);

        let projectedFields = dataset.fields.filter(
            (field) =>
                field.id !== "created_on" &&
                field.id !== "updated_on" &&
                field.id !== "id"
        );
        this.projection = {
            datasetID: dataset.id,
            fields: projectedFields.map((field) => field.id),
            links: [],
        };
    }

    getSelectedGroupsIds() {
        return this.groupsPanel.selectedGroupsIds;
    }

    getAllGroupsIds() {
        return this.groupsPanel.groupsIds;
    }

    get groupingOptions() {
        return Object.keys(Grouping);
    }

    get groupingEnum() {
        return Grouping;
    }

    fetchDatapoints() {
        if (this.isMapView) {
            this.updatePortfolioLayer();
            // updatePortfolioLayer only rebuilds the active dataset's tile layer.
            // Every other dataset layer keeps the URL it was created with, so
            // without this they would go on serving tiles built before the shape
            // was drawn.
            this.refreshOverlayLayersForGeometryFilter();
        } else {
            this.datapointFilterObject = this.constructFilterObject();
            this.tableComponent?.fetchDatapoints();
        }
    }

    onFilterMenuFieldClick(
        event: boolean,
        dataset: Dataset,
        field: DatasetField
    ) {
        // it is not clear why this in in here
        if (field.datasetId) {
            field.id = field.datasetId;
            field.name = field.datasetLabel;
        }
        //
        if (event) {
            this.datapointsFilterService.addFilterBarItem(field, dataset);
        } else {
            // need to remove the filter filterBarItem
            this.datapointsFilterService.removeFilterBarItem(
                dataset.id,
                field.id
            );
        }
    }

    dynamicFilterMenuEmitter(_event) {
        if (_event.isDistanceFilterCall) {
            this.applyDistanceFilter(
                _event.dataset,
                _event.distance,
                _event.distanceUnit
            );
        } else {
            this.onFilterMenuFieldClick(
                _event.event,
                _event.dataset,
                _event.field
            );
        }
    }

    applyFilters() {
        let isInvalidFilter = "";
        for (const filter of this.filterBarItems) {
            isInvalidFilter =
                this.datapointsFilterService.validatorsForFiltersInputs(filter);
            if (isInvalidFilter) {
                break;
            }
        }
        switch (isInvalidFilter) {
            case FilteringErrorCodes.MIN_GREATER_THAN_MAX:
                this.notifService.error(
                    "Error. Min cannot be greater then Max."
                );
                return;
            case FilteringErrorCodes.EXCEED_MIN_ALLOWED:
                this.notifService.error(
                    "Error. Exceeded the maximum allowed Min length."
                );
                return;
            case FilteringErrorCodes.EXCEED_MAX_ALLOWED:
                this.notifService.error(
                    "Error. Exceeded the maximum allowed Max length."
                );
                return;
            case FilteringErrorCodes.EXCEED_LENGTH_CHARTS:
                this.notifService.error(
                    `Error. Exceed the maximum limit of characters.`
                );
                return;
        }
        this.datapointsFilterService.updateFilter();
        this.datapointFilterObject = this.constructFilterObject();
    }

    applyOverlayFilters(
        selected: DatapointsOverlayFilterStore,
        onlyPrepapredFilter: boolean = false
    ) {
        const overlay = this.datapointsPageStateService.getDataset(
            selected.datasetID
        );
        if (!onlyPrepapredFilter) {
            this.datapointsFilterService
                .onFetchStatisticsReady()
                .subscribe((ready) => {
                    this.datapointsOverlayFilterService.updateFilters(
                        selected.datasetID,
                        selected.filters
                    );
                });
        }
        const fields: DatapointFilterField[] = selected.filters.map((item) => {
            let textValues = [];
            let statistics = item.statisticValues;
            try {
                for (let prop in statistics) {
                    if (statistics.hasOwnProperty(prop) && statistics[prop]) {
                        textValues.push(prop);
                    }
                }
            } catch (err) { }
            const minDateValue = item.minDateValue
                ? new Date(item.minDateValue).getTime()
                : undefined;
            const maxDateValue = item.maxDateValue
                ? new Date(item.maxDateValue).getTime()
                : undefined;
            return {
                id: item.id,
                minNumberValue: item.minNumberValue,
                maxNumberValue: item.maxNumberValue,
                minDateValue,
                maxDateValue,
                searchValue: item.searchValue || null,
                textValues: textValues,
            };
        });
        const event: ActivateOverlayEvent = {
            active: true,
            datasetID: selected.datasetID,
            renderingOptions: this.datapointsOverlaysComponent
                .getOverlaysRenderingOptions()
                .get(selected.datasetID),
            filter: { fields, datasetID: selected.datasetID },
        };
        if (onlyPrepapredFilter) {
            return { fields, datasetID: selected.datasetID };
        } else {
            this.mapStateService.updateOverlay(
                selected.datasetID,
                this.generateOverlayLayer(overlay, event)
            );
        }
    }

    navigateToDrafts(): void {
        this.router.navigate([
            `private/account/${this.account.id}/dataset/${this.dataset.id}/drafts`,
        ]);
    }

    /**
     * Whether to offer "Add Portfolio" at all.
     *
     * Same rule as the Settings gear on the account listing
     * (AccountComponent's `canOpenSettings`): superadmin, account admin, or a
     * member carrying the EMFD+U write bit. AuthService.canUpload mirrors the
     * backend's PrincipalUser.canUpload, which is what actually guards the SOV
     * endpoints this screen would call — so gating on anything else here would
     * only move the rejection from the menu to a failed request.
     *
     * canUpload rather than UserStateService.hasWriteAccess on purpose: it
     * reads the principal synchronously, while hasWriteAccess is backed by an
     * async map that can still be empty when this first renders.
     */
    get canAddPortfolio(): boolean {
        return !!this.account && this.authService.canUpload(this.account.id);
    }

    /**
     * Opens the MAIA assistant for the current account/dataset.
     *
     * A dataset may only have one SOV job at a time, so "Add Portfolio" resumes
     * that job when there is one still to resume, and otherwise opens the blank
     * `/maia` screen to start a fresh upload.
     *
     * "Still to resume" means the job is active. A closed job rejects every
     * change with 409 SOV_JOB_CLOSED, so a wizard opened on one can only fail —
     * whether it closed because its portfolio was imported, because the user
     * gave it up to start another, or because its file never parsed.
     *
     * The lookup never blocks entry: a failed call maps to null (see
     * getLastJob) and falls through to the new-run URL.
     */
    openMaia(): void {
        const accountId = this.account.id;
        const datasetId = this.dataset.id;
        const maiaUrl = `private/account/${accountId}/dataset/${datasetId}/maia`;

        this.maiaUploadService.getLastJob(accountId, datasetId).subscribe((lastJob) => {
            this.router.navigate([
                this.canResumeJob(lastJob) ? `${maiaUrl}/${lastJob.id}` : maiaUrl,
            ]);
        });
    }

    /**
     * Whether `last-job` came back with a job worth reopening.
     *
     * `id` is checked rather than the object: the endpoint answers "no job" with
     * an empty body, and an empty object is truthy — testing the object alone
     * routes to `/maia/undefined`.
     *
     * `active === false` is the test, not `!active`: a job created before that
     * flag existed carries no value for it, and the server resolves those by the
     * older "open" rule. A missing flag therefore means "still open", so it must
     * not be read as closed.
     */
    private canResumeJob(lastJob: SovLastJob | null): boolean {
        return !!lastJob && lastJob.id != null && lastJob.active !== false;
    }

    switchView(viewMode: string): void {
        this.datapointsFilterService.updateArray([]);
        if (viewMode.toUpperCase() === DatapointsViewMode.DASHBOARD) {
            this.analytics.trackEvent('switch_to_dashboard_view.');
            this.router.navigate([
                `private/account/${this.account.id}/dataset/${this.dataset.id}/${viewMode}`,
            ]);
        } else {
            this.tessadataFieldsByDataset[this.dataset.id].nriFields =
                this.groupByNriFields(
                    this.tessadataFieldsForview[this.dataset.id].nriFields
                );
            this.datapointsPageStateService.updateMapMode(defaultMapStatus);

            const currentViewMode = this.isMapView
                ? DatapointsViewMode.MAP
                : DatapointsViewMode.TABLE;
            if (viewMode.toUpperCase() === currentViewMode) {
                return;
            }
            this.analytics.trackEvent('switch_to_' + (this.isMapView ? 'map' : 'table') + `_view.`);
            this.location.replaceState(
                `private/account/${this.account.id}/dataset/${this.dataset.id}/datapoints/${viewMode}`
            );

            this.isMapView = !this.isMapView;

            if (!this.isMapView) {
                // Save overlay state before switching to Table View
                this.datapointsPageStateService.saveOverlayState();
                this.datapointsPageStateService.saveSelectedOverlay(this.selectedOverlay);
                this.datapointsPageStateService.saveDatasetIsDisabled(this.datasetIsDisabled);

                // Also save the main dataset's isSelected state
                if (this.dataset) {
                    const mainDatasetInService = this.datapointsPageStateService.getDataset(this.dataset.id);
                    if (mainDatasetInService) {
                        mainDatasetInService.isSelected = this.dataset.isSelected;
                    }
                }

                this.legends = [];

                this.closeAllPanels();
            } else {
                if (this.filterPanel && this.filterPanel.instance) {
                    this.filterPanel.instance.hidePanel();
                }

                // Sync filter service active filter with current this.filter (e.g., from AG Grid column filters)
                // AG Grid column filters modify this.filter.fields directly without emitting a filter change,
                // so we need to ensure the filter service's activeFilter is in sync before the map renders tiles.
                this.datapointsFilterService.initFilter(this.filter);
                this.datapointsFilterService.emitFilterUpdate();

                // Restore initial rendering options when switching back to map view
                if (this.initialRenderingOptions) {
                    // Deep copy to avoid reference issues
                    this.renderingOptions = JSON.parse(JSON.stringify(this.initialRenderingOptions));

                    // Disable any climatology options
                    if (this.renderingOptions.climatologyOptions) {
                        this.renderingOptions.climatologyOptions.enabled = false;
                    }

                    // Remove any legends and regenerate with initial settings
                    this.removeLegend(this.dataset.id);
                    this.cd.detectChanges();

                    // Only update the map with initial styling if the main dataset is not disabled
                    // This prevents unchecked Locations from appearing when switching back to Map view
                    if (!this.datasetIsDisabled) {
                        this.updatePortfolioLayer();
                    }
                }

                // active clustering on switching view
                if (this.isClusteringActivated === true) {
                    this.clusteringService.enableClusteringMode(
                        this.clusteringSettings
                    );
                }

                if (this.analyticsPanel && this.analyticsPanel.instance) {
                    this.analyticsPanel.instance.hidePanel();
                }
                if (this.notificationsPanel && this.notificationsPanel.instance) {
                    this.notificationsPanel.instance.hidePanel();
                }

                if (this.reportPanel?.instance) {
                    this.reportPanel.instance.hidePanel()
                }

                // Restore the datasetIsDisabled state before map initialization
                this.datasetIsDisabled = this.datapointsPageStateService.getSavedDatasetIsDisabled();

                // Restore the main dataset's isSelected state
                if (this.dataset) {
                    const mainDatasetInService = this.datapointsPageStateService.getDataset(this.dataset.id);
                    if (mainDatasetInService) {
                        this.dataset.isSelected = mainDatasetInService.isSelected;
                    }
                }

                // Restore overlay state when switching back to Map View
                // Use change detection to ensure DOM is ready, then restore state
                this.cd.detectChanges();

                // Subscribe to mapReady event to ensure map is fully initialized
                if (this.mapComponent && this.mapComponent.mapReady) {
                    const mapReadySubscription = this.mapComponent.mapReady.subscribe(() => {
                        this.restoreOverlayState();
                        mapReadySubscription.unsubscribe();
                    });
                } else {
                    // Fallback: If mapReady event doesn't exist, restore immediately
                    // The change detection above ensures DOM is ready
                    this.restoreOverlayState();
                }
            }
        }
    }

    closeAllPanels(): void {
        this.locationProfilePanel.onExpandedClick(false);
        const panelsToClose = [
            this.analyticsPanel,
            this.notificationsPanel,
            this.clusterPanel,
            this.addressLocationPanel,
            this.crises24DatapointsAgTablePanel,
            this.filterPanel,
            this.reportPanel,
            this.colorizeMarkersPanel
        ];
        panelsToClose.forEach(panel => {
            if (panel && panel.instance) {
                panel.instance.hidePanel();
            }
        });
    }

    fallBackToTableView(datasetID, accountID): void {
        // this.router.navigate([`private/account/${accountID}/dataset/${datasetID}/datapoints/table`]);
    }

    switchApplication(datasetId: string): void {
        const viewMode = this.route.snapshot.paramMap.get(
            Constants.VIEW_MODE_PARAM_NAME
        );

        if (datasetId === this.dataset.id) {
            return;
        }

        this.router.navigate(
            [
                `private/account/${this.account.id}/dataset/${datasetId}/datapoints/${viewMode}`,
            ],
            { replaceUrl: true }
        );
    }

    onToggleOverlay(event: ActivateOverlayEvent) {
        if (event.active) {
            // should activate overlay
            // Climate overlays also bring the bioclimatic zone boundaries on the map,
            // in an order that keeps those boundaries visible. See the sequence helper.
            const handled = activateClimateChangeOverlay(event, {
                mainDatasetID: this.dataset.id,
                activeDatasetsOnMap: this.datapointsPageStateService.activeDatasetsOnMap,
                panel: this.datapointsOverlaysComponent,
                getDataset: (id) => this.datapointsPageStateService.getDataset(id),
                enable: (e) => this.enableOverlay(e.datasetID, e),
                addFilterOverlay: (id) => this.datapointsOverlayFilterService.addOverlay(id),
                markSelected: (id) => this.datapointsOverlaysComponent?.markOverlayAsSelected(id),
                onSequenceComplete: () => {
                    if (this.mapComponent && this.mapComponent.mapType?.type !== MapViewType.WORLD_MAP) {
                        this.mapComponent.onIconClick(MapViewType.WORLD_MAP);
                    }
                }
            });
            if (!handled) {
                this.enableOverlay(event.datasetID, event);
            }
            if (event.datasetID === this.dataset.id) {
                this.datasetIsDisabled = false;
            } else {
                this.datapointsOverlayFilterService.addOverlay(event.datasetID);
            }
            if (
                this.selectedOverlay &&
                event.datasetID === this.selectedOverlay.id
            ) {
                this.datapointsOverlayFilterService.selectFilter(
                    event.datasetID
                );
            }
        } else {
            // should remove overlay
            if (event.datasetID === this.dataset.id) {
                this.datasetIsDisabled = true;
                // For the main dataset, we need to remove it from the map
                this.mapStateService.removeOverlay(event.datasetID);
            }
            this.disableOverlay(event.datasetID);
            this.datapointsOverlayFilterService.removeOverlay(event.datasetID);
            if (
                this.selectedOverlay &&
                event.datasetID === this.selectedOverlay.id
            ) {
                this.datapointsOverlayFilterService.selectFilter();
            }
            this.closeCrisis24Panel(event.datasetID);
        }
    }

    updatePortfolioLayer(): void {
        // Check if this is climate data colorization - preserve the existing legend
        const isClimateDataEnabled = this.renderingOptions.climatologyOptions?.enabled;

        let scaleType = this.renderingOptions.datasetStylingOptions.type;
        if (
            this.renderingOptions.datasetStylingOptions &&
            this.renderingOptions.datasetStylingOptions
                .colorizationFieldIndex !== null
        ) {
            // Check if this is a special colorization option (risk_score or risk_level)
            const isSpecialOption = this.renderingOptions.datasetStylingOptions.colorizationFieldIndex === -1;

            if (isSpecialOption) {
                // For special options, fieldID is already set in converterOptions
                // No need to fetch field statistics or update field references
                this.renderingOptions.converterOptions.datasetID = this.dataset.id;
                // fieldID is already set as 'risk_score' or 'risk_level'

                // Skip field statistics lookup and directly update layer
                let layer = this.generatePortfolioLayer();
                this.mapStateService.updateOverlay(layer.name, layer);
                return;
            }

            // For climate data, just update the map layer without regenerating the legend
            if (isClimateDataEnabled) {
                let layer = this.generatePortfolioLayer();
                this.mapStateService.updateOverlay(layer.name, layer);
                return;
            }

            // Regular field colorization
            let colorizationField =
                this.dataset.fields[
                this.renderingOptions.datasetStylingOptions
                    .colorizationFieldIndex
                ];
            this.renderingOptions.converterOptions.datasetID = this.dataset.id;
            this.renderingOptions.converterOptions.fieldID =
                colorizationField.id;

            if (
                scaleType === ColorScaleType.FIXED ||
                scaleType === ColorScaleType.GRADIENT
            ) {
                this.subscriptions.add(
                    this.datapointAggregateService
                        .getDatapointsFieldStatistics(
                            this.dataset.id,
                            colorizationField.id,
                            {
                                datasetID: this.dataset.id,
                                groups: this.getSelectedGroupsIds(),
                            }
                        )
                        .subscribe((statistics) => {
                            DatapointsComponent.setFieldStatistics(
                                colorizationField,
                                this.renderingOptions,
                                statistics
                            );
                            const field = this.dataset.fields.find(
                                (field) => field.id === colorizationField.id
                            );
                            const name =
                                field.displayName === null ||
                                    field.displayName === undefined
                                    ? field.name
                                    : field.displayName;
                            let layer = this.generatePortfolioLayer();
                            this.addLegend(
                                this.dataset.id,
                                LegendUtils.createIntervalsForLegend(
                                    this.renderingOptions,
                                    this.dataset.isGeoserver
                                ),
                                false,
                                this.dataset.name,
                                name,
                                LegendUtils.createGradientForLegend(
                                    this.renderingOptions,
                                    this.dataset.isGeoserver
                                )
                            );
                            this.mapStateService.updateOverlay(
                                layer.name,
                                layer
                            );
                        })
                );
            } else if (scaleType === ColorScaleType.INTERVAL) {
                // it is constant or interval. we don't need min and max
                DatapointsComponent.setFieldStatisticsForInterval(
                    colorizationField,
                    this.renderingOptions
                );
                let layer = this.generatePortfolioLayer();
                const field = this.dataset.fields.find(
                    (field) => field.id === colorizationField.id
                );
                const name =
                    field.displayName === null ||
                        field.displayName === undefined
                        ? field.name
                        : field.displayName;
                this.addLegend(
                    this.dataset.id,
                    LegendUtils.createIntervalsForLegend(
                        this.renderingOptions,
                        this.dataset.isGeoserver
                    ),
                    false,
                    this.dataset.name,
                    name,
                    LegendUtils.createGradientForLegend(
                        this.renderingOptions,
                        this.dataset.isGeoserver
                    )
                );
                this.mapStateService.updateOverlay(layer.name, layer);
            } else {
                let layer = this.generatePortfolioLayer();
                this.mapStateService.updateOverlay(layer.name, layer);
            }
        } else {
            let layer = this.generatePortfolioLayer();
            this.mapStateService.updateOverlay(layer.name, layer);
        }
    }

    private triggerTileTokenRefresh(): void {
        if (this.tileRefreshInProgress || this.authService.refreshing) return;
        this.tileRefreshInProgress = true;
        this.authService.getRefreshToken().subscribe({
            next: () => {
                this.tileRefreshInProgress = false;
                this.mapStateService.refreshAllTiles();
            },
            error: () => {
                this.tileRefreshInProgress = false;
            }
        });
    }

    private generatePortfolioLayer(avoidCache?: boolean) {
        let opacity =
            this.renderingOptions.datasetStylingOptions.backgroundOpacity || 1;
        // so that the the BE requests for tiles do not get triggered only for opacity
        let renderingOptionsCopy: RenderingOptions = JSON.parse(
            JSON.stringify(this.renderingOptions)
        );
        renderingOptionsCopy.datasetStylingOptions.backgroundOpacity =
            undefined;

        let projectionCopy: DatapointProjection = JSON.parse(
            JSON.stringify(this.projection)
        );

        projectionCopy.fields = ["id"];
        if (
            this.renderingOptions.converterOptions &&
            this.renderingOptions.converterOptions.fieldID
        ) {
            projectionCopy.fields.push(
                this.renderingOptions.converterOptions.fieldID
            );
        }
        projectionCopy.links = [];

        let renderingOptionsJson = encodeURIComponent(
            JSON.stringify(this.renderingOptions)
        );
          // Create a copy of the filter and add accumulationApplied if avoidCache is true
        let filterCopy = JSON.parse(JSON.stringify(this.filter));
        // Find links where linkFields has id === "distance".
        //
        // Both `links` and `linkFields` are optional on DatapointFilter, so these
        // were dereferenced unguarded. When either is absent this threw a
        // TypeError inside generatePortfolioLayer, which runs from the
        // onFilterChange subscriber - and an exception in a subscribe callback
        // terminates the subscription, so every later filter change silently
        // stopped regenerating the tile layer. The shapes were computed correctly
        // but the markers never refreshed.
        const hasDistance = (filterCopy?.links ?? []).some((link) =>
            (link?.linkFields ?? []).some((field) => field?.id === "distance")
        );
        filterCopy.accumulationApplied = this.isAccumalationApplied || hasDistance;
        if (this.isAccumalationApplied) {
            filterCopy.accumulationApplied = true;
        }
        let filterJson = encodeURIComponent(JSON.stringify(filterCopy));
        let projectionJson = encodeURIComponent(JSON.stringify(projectionCopy));
        // TEMP DIAGNOSTIC - which dataset layers carry the geometry filter.
        console.log(`[layer] ACTIVE dataset=${this.dataset.id} shapes=${filterCopy?.geometryFilter?.unionShapes?.length ?? 0}`);
        let versionToken = this.tileVersionService.getVersionToken();
        let cacheBuster = `&v=${versionToken}`;

        // Check if climatology is enabled
        const isClimatologyEnabled = this.renderingOptions.climatologyOptions?.enabled;
        let tileUrl: (coord: any, zoom: number) => string;

        if (isClimatologyEnabled) {
            // Use climatology tile endpoint

            // Transform climatology options to backend format
            const transformedClimatologyOptions = transformClimatologyOptionsForBackend(
                this.renderingOptions.climatologyOptions
            );

            const climatologyOptionsJson = encodeURIComponent(
                JSON.stringify(transformedClimatologyOptions)
            );
            const climatologyStylingOptionsJson = encodeURIComponent(
                JSON.stringify(this.renderingOptions.datasetStylingOptions)
            );

            tileUrl = (coord, zoom) => {
                const currentToken = this.authService.getToken();
                if (!this.authService.isAuthenticated()) {
                    this.triggerTileTokenRefresh();
                    return null as unknown as string;
                }
                const tileHosts = environment.tileHosts && environment.tileHosts.length
                    ? environment.tileHosts
                    : [environment.baseUrl];
                const host = tileHosts[(coord.x + coord.y + zoom) % tileHosts.length];
                const url = `${host}/render/dataset/${this.dataset.id}/climatology-tile/${coord.x}/${coord.y}/${zoom}?` +
                    `accountId=${this.account.id}&token=${currentToken}&filter=${filterJson}&projection=${projectionJson}` +
                    `&renderingOptions=${renderingOptionsJson}` +
                    `&climatologyOptions=${climatologyOptionsJson}` +
                    `&climatologyStylingOptions=${climatologyStylingOptionsJson}${cacheBuster}` +
                    (avoidCache ? `&v=${Math.random()}` : "");
                return url;
            };
        } else {
            // Use regular tile endpoint
            tileUrl = (coord, zoom) => {
                const currentToken = this.authService.getToken();
                if (!this.authService.isAuthenticated()) {
                    this.triggerTileTokenRefresh();
                    return null as unknown as string;
                }
                const tileHosts = environment.tileHosts && environment.tileHosts.length
                    ? environment.tileHosts
                    : [environment.baseUrl];
                const host = tileHosts[(coord.x + coord.y + zoom) % tileHosts.length];
                const url = `${host}/render/dataset/${this.dataset.id}/${this.account.id}/tile/${coord.x}/${coord.y}/${zoom}?token=${currentToken}&filter=${filterJson}&projection=` +
                    `${projectionJson}&renderingOptions=${renderingOptionsJson}${cacheBuster}` +
                    (avoidCache ? `&v=${Math.random()}` : "");
                return url;
            };
        }
        let layer = new google.maps.ImageMapType({
            getTileUrl: tileUrl,
            minZoom: 3,
            maxZoom: 15,
            name: this.dataset.id,
            opacity: opacity,
            tileSize: new google.maps.Size(
                defaultTileSize.width,
                defaultTileSize.height
            ),
        });
        return layer;
    }


    enableOverlay(datasetID: string, event: ActivateOverlayEvent) {
        let overlay = this.datapointsPageStateService.getDataset(datasetID);

        // The promise is returned so callers that care about insertion order can chain on
        // it. Existing callers ignore it and are unaffected.
        return this.insertOverlay(
            overlay,
            event,
            MapStateActionEnum.INSERT_OVERLAY
        ).then((resolve: any) => { });
    }

    disableOverlay(datasetID: string) {
        this.removeLegend(datasetID);
        let existingOverlayIndex =
            this.datapointsPageStateService.activeDatasetsOnMap.findIndex(
                (activeOverlay) => activeOverlay.id === datasetID
            );
        if (existingOverlayIndex >= 0) {
            this.mapStateService.removeOverlay(datasetID);
            // this.datapointsPageStateService.activeDatasetsOnMap.splice(existingOverlayIndex, 1);
            // Do not mutate activeDatasetsOnMap here. MapComponent listens to the
            // remove event and is the single owner updating this array to keep it in sync
            // with overlayMapTypes order.
        }
    }

    restoreOverlayState() {
        // Use the saved state instead of current state, as reset() clears activeDatasetsOnMap
        const activeDatasetsOnMap = this.datapointsPageStateService.getSavedActiveDatasetsOnMap();
        const activeImageOverlaysOnMap = this.datapointsPageStateService.getSavedActiveImageOverlaysOnMap();
        const savedSelectedOverlay = this.datapointsPageStateService.getSavedSelectedOverlay();

        if (!activeDatasetsOnMap.length && !activeImageOverlaysOnMap.length) {
            return;
        }

        // Restore active overlays using existing service data
        if (activeDatasetsOnMap && activeDatasetsOnMap.length > 0 && this.datapointsOverlaysComponent) {
            const overlaysRenderingOptions: Map<string, RenderingOptions> =
                this.datapointsOverlaysComponent.getOverlaysRenderingOptions();

            activeDatasetsOnMap.forEach((dataset) => {
                // Update the dataset's isSelected state in the overlay panel
                const overlayInPanel = this.datapointsPageStateService.getDataset(dataset.id);
                if (!overlayInPanel) {
                    console.warn(`Cannot restore overlay ${dataset.id} - overlay not found in panel`);
                    return;
                }

                overlayInPanel.isSelected = true;

                // Get rendering options or create default ones if missing
                let renderingOptions = overlaysRenderingOptions.get(dataset.id);

                // If rendering options are missing, create default ones from dataset styling options
                if (!renderingOptions && overlayInPanel.stylingOptions) {
                    const colorizationField = overlayInPanel.fields[overlayInPanel.stylingOptions.colorizationFieldIndex];
                    renderingOptions = {
                        datasetStylingOptions: JSON.parse(JSON.stringify(overlayInPanel.stylingOptions)),
                        converterOptions: {
                            type: DatapointConverterType.NONE,
                            datasetID: overlayInPanel.id,
                            fieldID: colorizationField ? colorizationField.id : null,
                        },
                        visualizationOptions: { type: VisualizationType.DEFAULT },
                    };
                    // Store the created rendering options for future use
                    overlaysRenderingOptions.set(dataset.id, renderingOptions);
                }

                // For overlays without renderingOptions, trigger re-selection
                // This will cause the overlay panel to emit the proper event with rendering options
                if (!renderingOptions) {
                    // Trigger the overlay panel to re-emit the overlay toggle event
                    if (this.datapointsOverlaysComponent) {
                        this.datapointsOverlaysComponent.setRenderingOption(overlayInPanel);
                        const renderingOpt = this.datapointsOverlaysComponent.getOverlaysRenderingOptions().get(dataset.id);
                        if (renderingOpt) {
                            const event: ActivateOverlayEvent = {
                                active: true,
                                datasetID: dataset.id,
                                renderingOptions: renderingOpt
                            };
                            this.enableOverlay(dataset.id, event);
                            this.datapointsOverlayFilterService.addOverlay(dataset.id);
                        }
                    }
                    return;
                }

                const event: ActivateOverlayEvent = {
                    active: true,
                    datasetID: dataset.id,
                    renderingOptions: renderingOptions
                };

                // Re-enable the overlay
                this.enableOverlay(dataset.id, event);

                // Add to overlay filter service
                this.datapointsOverlayFilterService.addOverlay(dataset.id);
            });
        }

        // Restore active image overlays using existing service data
        if (activeImageOverlaysOnMap && activeImageOverlaysOnMap.length > 0) {
            activeImageOverlaysOnMap.forEach((imageOverlay) => {
                this.onToggleImageOverlay({
                    active: true,
                    overlay: imageOverlay,
                    interactive: false,
                    opacity: 0.6
                });
            });
        }

        // Restore selected overlay
        if (savedSelectedOverlay) {
            const selectedOverlayInPanel = this.datapointsPageStateService.getDataset(savedSelectedOverlay.id);
            if (selectedOverlayInPanel) {
                this.selectedOverlay = selectedOverlayInPanel;
                this.datapointsOverlayFilterService.selectFilter(this.selectedOverlay.id);

                // Update the overlay panel's internal selected overlay reference
                if (this.datapointsOverlaysComponent) {
                    this.datapointsOverlaysComponent._selectedOverlay = selectedOverlayInPanel;
                    this.datapointsOverlaysComponent.colorizationBoxIsClosed = false;
                    this.datapointsOverlaysComponent.colorizationBoxIsExpanded = true;
                    this.datapointsOverlaysComponent.applyChangeDetection();
                }
            }
        }
    }

    prepareProjectionByRenderingOptions(
        datasetID: string,
        event: ActivateOverlayEvent
    ): DatapointProjection {
        if (event.projection) {
            return event.projection;
        }

        let projection: DatapointProjection = { datasetID };

        if (
            event.renderingOptions.visualizationOptions.type ===
            VisualizationType.THEMATIC_MAP
        ) {
            projection.geometryPrecision = 15;
        }

        let linkProjection: DatapointProjection;
        let fields: string[] = [];

        let haveLinkColorization =
            datasetID !== event.renderingOptions.converterOptions.datasetID;

        if (haveLinkColorization) {
            linkProjection = {
                datasetID: event.renderingOptions.converterOptions.datasetID,
            };
        }
        switch (event.renderingOptions.datasetStylingOptions.type) {
            case ColorScaleType.CONSTANT:
            case ColorScaleType.FIXED:
            case ColorScaleType.GRADIENT:
            case ColorScaleType.INTERVAL:
                if (event.renderingOptions.converterOptions.fieldID) {
                    fields = [event.renderingOptions.converterOptions.fieldID];
                }
        }
        if (haveLinkColorization) {
            linkProjection.fields = fields;
            projection.links = [linkProjection];
        } else {
            projection.fields = fields;
        }
        return projection;
    }

    generateOverlayLayer(overlay: Dataset, event: ActivateOverlayEvent) {
        let opacity =
            event.renderingOptions.datasetStylingOptions.backgroundOpacity || 1;
        // so that the the BE requests for tiles do not get triggered only for opacity
        let renderingOptionsCopy: RenderingOptions = JSON.parse(
            JSON.stringify(event.renderingOptions)
        );
        renderingOptionsCopy.datasetStylingOptions.backgroundOpacity =
            undefined;

        let filter = this.prepareFilter(overlay, event);
        let projection: DatapointProjection =
            this.prepareProjectionByRenderingOptions(overlay.id, event);
        let projectionJson = JSON.stringify(projection);
        let renderingOptionsJson = encodeURIComponent(
            JSON.stringify(renderingOptionsCopy)
        );
        let urlSuffix;
        let filterJson;
        let linkedApplicationFilter; //for thematic map only
        let accountId;
        if (
            overlay.thematicMapSettings &&
            overlay.thematicMapSettings.isThematicMapDataset
        ) {
            urlSuffix = "thematic-tile";
            accountId = '';
            if (this.mapThematicOverlayService.currentConfig.parentDatasetId !== null) {
                filter.datasetID = this.dataset.id;
                const field: DatapointFilterField[] = [{ id: 'link_' + this.mapThematicOverlayService.currentConfig.parentDatasetId, maxDateValue: null, minDateValue: null, maxNumberValue: null, minNumberValue: 0, searchValue: null, textValues: [this.mapThematicOverlayService.currentConfig.geometryID.geometryID], distanceUnit: null }];
                filter.fields = filter.fields.length > 0 ? [...filter.fields, ...field] : field;
            }
            let parentFilter = this.mapThematicOverlayService.currentConfig.parentFilter;
            filterJson = encodeURIComponent(JSON.stringify(filter)) + `&parentFilter=` + JSON.stringify(parentFilter);
            linkedApplicationFilter = JSON.stringify(this.filter);
        } else {
            urlSuffix = "tile";
            accountId = this.account.id+'/';
            filterJson = encodeURIComponent(JSON.stringify(filter));
        }
        // TEMP DIAGNOSTIC - which dataset layers carry the geometry filter.
        console.log(`[layer] overlay dataset=${overlay.id} shapes=${(filter as any)?.geometryFilter?.unionShapes?.length ?? 0}`);
        let versionToken = this.tileVersionService.getVersionToken();
        let cacheBuster = `&v=${versionToken}`;
        // ✅ FIX: Get fresh token on each tile request instead of capturing it in closure
        let overlayId = overlay.id;
        let tileUrl = (coord, zoom) => {
            const currentToken = this.authService.getToken();
            if (!this.authService.isAuthenticated()) {
                this.triggerTileTokenRefresh();
                return null as unknown as string;
            }
            const tileHosts = environment.tileHosts && environment.tileHosts.length
                    ? environment.tileHosts
                    : [environment.baseUrl];
            const host = tileHosts[(coord.x + coord.y) % tileHosts.length];
            return `${host}/render/dataset/${overlayId}/${accountId}${urlSuffix}/${coord.x}/${coord.y}/${zoom}?token=${currentToken}&filter=` +
                `${filterJson}&projection=${projectionJson}&renderingOptions=${renderingOptionsJson}&linkedApplicationFilter=${linkedApplicationFilter}${cacheBuster}`;
        };

        if (overlay.name == "GEE Climate Change") {
            tileUrl = function (coord, zoom) {
                var url =
                    "https://earthengine.googleapis.com/v1alpha/projects/earthengine-legacy/maps/4a9bb75df22b107ef53ef99dbd390e89-415b54946cb9482a753272d03e01dde6/tiles/{z}/{x}/{y}"
                        .replace("{x}", coord.x)
                        .replace("{y}", coord.y)
                        .replace("{z}", zoom);
                return url;
            };
        }
        let layer = new google.maps.ImageMapType({
            getTileUrl: tileUrl,
            minZoom: 1,
            maxZoom: 15,
            opacity: opacity,
            name: overlay.id,
            tileSize: new google.maps.Size(
                defaultTileSize.width,
                defaultTileSize.height
            ),
        });
        return layer;
    }

    private prepareFilter(overlay: Dataset, event: ActivateOverlayEvent) {
        // A shape drawn on the map is a filter over the whole view, not over one
        // dataset. Only the active dataset's filter carried the geometry filter,
        // so every other dataset layer was requested without it and rendered all
        // of its datapoints - which is why markers kept appearing outside a drawn
        // rectangle, polygon or circle.
        const geometryFilter = this.filter?.geometryFilter;

        if (event.filter) {
            return this.withGeometryFilter(event.filter, geometryFilter);
        }

        let filter: DatapointFilter;
        if (overlay.id === this.dataset.id) {
            // Already carries the geometry filter; it IS this.filter.
            filter = this.filter;
        } else if (
            overlay.id !== this.dataset.id &&
            this.datapointsOverlayFilterService.getOverlayFilter(overlay.id)
        ) {
            filter = this.withGeometryFilter(
                this.applyOverlayFilters(
                    this.datapointsOverlayFilterService.getOverlayFilter(
                        overlay.id
                    ),
                    true
                ),
                geometryFilter
            );
        } else {
            filter = this.withGeometryFilter(
                { datasetID: overlay.id },
                geometryFilter
            );
        }
        return filter;
    }

    /**
     * Attach the map-wide geometry filter to a dataset layer's filter, without
     * mutating the original. Returns the filter unchanged when no shape or region
     * is active, so an unfiltered view still requests unfiltered tiles.
     */
    private withGeometryFilter(
        filter: DatapointFilter,
        geometryFilter: GeometryFilter | undefined
    ): DatapointFilter {
        const hasShapes = !!geometryFilter?.unionShapes?.length;
        const hasRegions = !!geometryFilter?.regionIds?.length;
        if (!filter || (!hasShapes && !hasRegions)) {
            return filter;
        }
        return { ...filter, geometryFilter };
    }

    onUpdateOverlaySettings(event: ActivateOverlayEvent) {
        let renderingOptions = event.renderingOptions;
        let datasetID = event.datasetID;
        let overlay = this.datapointsPageStateService.getDataset(datasetID);

        if (this.dataset.id === datasetID) {
            this.renderingOptions = renderingOptions;
        }
        this.insertOverlay(
            overlay,
            event,
            MapStateActionEnum.UPDATE_OVERLAY
        ).then((resolve: any) => {
            this.overlaysFilterComponent.resetFilters();
        });
    }

    onSelectedOverlay(event: Dataset) {
        this.selectedOverlay = event;
        if (this.selectedOverlay.isSelected) {
            this.datapointsOverlayFilterService.selectFilter(
                this.selectedOverlay.id
            );
        } else {
            this.datapointsOverlayFilterService.selectFilter();
        }
    }

    drawShapes(shape: MapShape, type: string): void {
        const drawingType =
            type === MapDrawType.MEASURE
                ? MapDrawType.MEASURE
                : MapDrawType.FILTER;

        switch (shape) {
            case MapShape.CIRCLE:
                this.mapStateService.setDrawingMode(
                    OverlayType.CIRCLE,
                    drawingType
                );
                break;
            case MapShape.RECTANGLE:
                this.mapStateService.setDrawingMode(
                    OverlayType.RECTANGLE,
                    drawingType
                );
                break;
            case MapShape.POLYGON:
                this.mapStateService.setDrawingMode(
                    OverlayType.POLYGON,
                    drawingType
                );
                break;
            case MapShape.POLYLINE:
                this.mapStateService.setDrawingMode(
                    OverlayType.POLYLINE,
                    drawingType
                );
                break;
        }
    }

    removeShapes(type: string): void {
        const drawingType =
            type === MapDrawType.MEASURE
                ? MapDrawType.MEASURE
                : MapDrawType.FILTER;
        this.mapStateService.clearShapes(drawingType);
    }

    /**
     * Handle circle configuration from the new Circle Selection Panel
     * This is called when user clicks "Create Circle" button after configuring radius
     * @param config - Circle configuration with radius value, unit, and normalized meters
     */
    onCircleConfigured(config: CircleSelectionConfig): void {

        // Task 2: Store configuration in state service
        this.circleSelectionStateService.setConfig(config);

        // Task 2: Enter placement mode
        this.circleSelectionStateService.enterPlacementMode();

        // Log state for debugging
        // Task 3: Map component will listen to placementMode$ and handle map click
        // (Will be implemented in Task 3)
    }

    /**
     * Handle "Polygon New" from the Select panel.
     *
     * Click-to-add-vertex capture running on plain map click / mousemove /
     * dblclick listeners, with no google.maps.drawing.DrawingManager involved,
     * so it survives the v3.65 removal of the drawing library.
     */
    onPolygonNewClicked(): void {
        this.circleSelectionStateService.enterPolygonDrawMode();
    }

    /**
     * Handle "Rectangle New" from the Select panel.
     *
     * Drag-to-draw capture running on plain map mousedown / mousemove / mouseup
     * listeners, with no google.maps.drawing.DrawingManager involved, so it
     * survives the v3.65 removal of the drawing library.
     */
    onRectangleNewClicked(): void {
        this.circleSelectionStateService.enterRectangleDrawMode();
    }

    /**
     * Handle Cancel from the Select panel.
     *
     * As well as clearing the filter shapes, this disarms whichever draw tool is
     * active. Without that there is no way to abandon an in-progress draw from
     * the UI, which leaves the map stuck in capture mode.
     */
    onSelectPanelCancel(): void {
        this.circleSelectionStateService.exitAllDrawModes();
        this.removeShapes(MapDrawType.FILTER);
    }

    // ----- Measure menu -------------------------------------------------
    // The same in-house capture tools as the Select panel, armed with
    // MapDrawType.MEASURE so the shape reports its area or distance instead of
    // filtering datapoints. No google.maps.drawing.DrawingManager is involved.

    /** Measure > Circle: press at the centre and drag out to set the radius. */
    onMeasureCircleClicked(): void {
        this.circleSelectionStateService.enterCircleDragDrawMode(MapDrawType.MEASURE);
    }

    /** Measure > Polygon: click once per vertex, then close the ring. */
    onMeasurePolygonClicked(): void {
        this.circleSelectionStateService.enterPolygonDrawMode(MapDrawType.MEASURE);
    }

    /** Measure > Rectangle: drag one corner to the opposite one. */
    onMeasureRectangleClicked(): void {
        this.circleSelectionStateService.enterRectangleDrawMode(MapDrawType.MEASURE);
    }

    /** Measure > Distance: click once per point along the route. */
    onMeasureDistanceClicked(): void {
        this.circleSelectionStateService.enterPolylineDrawMode(MapDrawType.MEASURE);
    }

    /**
     * Measure > Cancel: clear the measure shapes AND disarm whichever measure tool
     * is armed, so there is always a way out of an in-progress draw.
     */
    onMeasureCancelClicked(): void {
        this.circleSelectionStateService.exitAllDrawModes();
        this.removeShapes(MapDrawType.MEASURE);
    }

    /**
     * Task 7: Handle Clear All Circles button click
     * Calls MapComponent's clearAllCustomCircles method to cleanup all circles
     */
    onClearAllCircles(): void {
        // Call MapComponent's cleanup method
        if (this.mapComponent) {
            this.mapComponent.clearAllCustomCircles();
        } else {
            console.warn('[DatapointsComponent] MapComponent not available for clearing circles');
        }
    }

    ngOnDestroy(): void {
        // The polygon registry is root-provided, so it outlives this page. Without this, a boundary
        // left drawn when navigating away would still be in the registry on the way back.
        this.profilePolygonService.clearAll();

        if (this.analyticsPanel) {
            this.analyticsPanel.instance.closePanel();
            this.analyticsPanel = null;
        }

        if (this.addressLocationPanel) {
            this.addressLocationPanel.instance.closePanel();
            this.addressLocationPanel = null;
        }

        if (this.updateDatapointPanel) {
            this.updateDatapointPanel.instance.closePanel();
            this.updateDatapointPanel = null;
        }

        if (this.clusterPanel) {
            this.clusterPanel.instance.closePanel();
            this.clusterPanel = null;
        }

        if (this.colorizeMarkersPanel) {
            this.colorizeMarkersPanel.instance.closePanel();
            this.colorizeMarkersPanel = null;
        }

        if (this.notificationsPanel) {
            this.notificationsPanel.instance.closePanel();
            this.notificationsPanel = null;
        }

        if (this.crises24DatapointsAgTablePanel) {
            this.crises24DatapointsAgTablePanel.instance.closePanel();
            this.crises24DatapointsAgTablePanel = null;
        }

        if (this.pendingAnalyticsAction) {
            this.loaderStateService.update(false);
            this.pendingAnalyticsAction = null;
        }
        this.datapointsPageStateService.reset();
        this.mapThematicOverlayService.reset();
        this.subscriptions.unsubscribe();
    }

    open($event: string) { }

    onUpdated() {
        this.updateDatapointPanel.instance.hidePanel();
        this.fetchDatapoints();
    }

    deleteSelected() {
        const selectionCount = this.tableComponent?.getSelectedDatapointIds()?.length || 0;

        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_datapoints_delete');
        this.tableComponent.deleteSelected();
    }

    filterStatisticValues(id: string, $event: any) {
        const filterValue = $event.target.value;
        const filterBarItem = this.filterBarItems.find(
            (currentFilterBarItem) => {
                return currentFilterBarItem.id === id;
            }
        );
        const index = this.filterBarItems.indexOf(filterBarItem);
        this.filterBarItems[index].filteredStatisticValues =
            this.filterBarItems[index].statistics.values.filter((value) => {
                return value.toLowerCase().includes(filterValue.toLowerCase());
            });
    }

    removeFilterBarItem(filterBarItem: FilterBarItem) {
        filterBarItem.datasetField.selected = false;
        // this.bindFilterIds({ fieldIds: [filterBarItem.datasetField.id] }, true);
        this.datapointsFilterService.removeFilterBarItem(
            filterBarItem.dataset.id,
            filterBarItem.datasetField.id
        );
        this.datapointsFilterService.emitRemovedFilterBarItem({ event: { fieldIds: [filterBarItem.datasetField.id] }, isFilterBarItemRemoveCall: true });
        this.statisticsFiltersFetched = false;
    }

    removeFilterBar() {
        this.initializeDatasetFilterSelectedState();
        // Filter
        this.reinitializeDatasetFilterSelectedState();
        this.filterBarItems = [];
        this.datapointsFilterService.clearFilterBar();
        this.statisticsFiltersFetched = false;
        // this.bindFilterIds({ fieldIds: [] }, true);
        this.datapointsFilterService.emitRemovedFilterBarItem({ event: { fieldIds: [] }, isFilterBarItemRemoveCall: true });
    }

    initializeDatasetFilterSelectedState(): void {
        this.linkedAccountOverlays.forEach((dataset) => {
            dataset.fields.forEach((field) => {
                field.selected = false;
            });
        });

        this.linkedAccountDatasets.forEach((dataset) => {
            dataset.fields.forEach((field) => {
                field.selected = false;
            });
        });
    }

    reinitializeDatasetFilterSelectedState(): void {
        this.filterAccountOverlays.forEach((dataset) => {
            dataset.overlays.forEach((overlay) => {
                overlay.fields.forEach((field) => {
                    field.selected = false;
                });
            });
        });

        this.filterAccountDatasets.forEach((dataset) => {
            dataset.fields.forEach((field) => {
                field.selected = false;
            });
        });
    }

    findItemInListAndDelete(item, list) {
        let searchedItem = list.find((listItem) => listItem.id === item.id);
        list.splice(list.indexOf(searchedItem), 1);
    }

    onProjectionChange(dataset, field) {
        //
        if (field.isProjected) {
            this.addProjectionField(dataset, field);
        } else {
            this.removeProjectionField(dataset, field);
        }
        this.sort = { datasetID: this.dataset.id, links: [], fields: [] };
        // this.fetchDatapoints();
        this.datapointFilterObject = this.constructFilterObject();
        this.datapointsFilterService.updateFilter();
    }

    dynamicProjectionMenuEmitter(_event) {
        this.onProjectionChange(_event.dataset, _event.field);
    }

    onNRIParentChange($event, dataset, field) {
        field.isParentSelected = $event;
        field.child.forEach((element) => {
            element.child.isProjected = $event;
        });
    }

    addProjectionField(dataset, field) {
        if (dataset.id !== this.dataset.id) {
            let existingLinks = this.projection.links.find(
                (link) => link.datasetID === dataset.id
            );
            if (!existingLinks) {
                let link: DatapointProjection = {
                    datasetID: dataset.id,
                    fields: [field.id],
                };
                this.projection.links.push(link);
            } else {
                let foundExistingLinkField = existingLinks.fields.some(
                    (fieldId) => fieldId === field.id
                );
                if (!foundExistingLinkField)
                    existingLinks.fields.push(field.id);
            }
        } else {
            let foundExistingField = this.projection.fields.some(
                (fieldId) => fieldId === field.id
            );
            if (!foundExistingField && !['ipcc', "climate_change", "climatology"].includes(dataset.geoWorkspace))
                this.projection.fields.push(field.id);
        }
    }

    removeProjectionField(dataset, field) {
        if (dataset.id !== this.dataset.id) {
            let searchedProjectionLink = this.projection.links.find(
                (link) => link.datasetID === dataset.id
            );
            let index = this.projection.links.indexOf(searchedProjectionLink);
            searchedProjectionLink.fields.splice(
                searchedProjectionLink.fields.indexOf(field.id),
                1
            );
            if (searchedProjectionLink.fields.length < 1) {
                this.projection.links.splice(index, 1);
            }
        } else {
            let searchedField = this.projection.fields.find(
                (Field) => Field === field.id
            );
            this.projection.fields.splice(
                this.projection.fields.indexOf(searchedField),
                1
            );
        }
    }

    openDownloadDialog(): void {
        if (
            (this.tableComponent &&
                (this.tableComponent.selectAll === true ||
                    this.tableComponent.getSelectedDatapointIds().length >
                    0)) ||
            this.isMapView
        ) {
            const selectionCount = this.tableComponent?.getSelectedDatapointIds()?.length || 0;

            this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_download_modal_open');
            
            // Fetch complete overlay tree to include climate_slr_change_v2 and climate_tr_change_v2
            // which are not returned by linkedGroupOverlays API
            this.overlayService.getOverlayGroupsAsTree(this.account.id).subscribe((fullOverlayTree) => {
                const climateFilterAccountOverlays = this.prepareClimateOverlays();
                
                // Merge missing climate change overlays (SLR and TR) from the full overlay tree
                const missingOverlayIds = ['climate_slr_change_v2', 'climate_tr_change_v2'];
                this.mergeOverlaysFromFullTree(climateFilterAccountOverlays, fullOverlayTree, missingOverlayIds);

                const climateData = this.datapointObject.prepareClimateData(
                    climateFilterAccountOverlays,
                    true
                );

                // Consolidated risk score sits alongside the overlay groups in that dialog,
                // even though it is made of dataset fields rather than overlays.
                climateData.push(...this.prepareConsolidatedRiskScoreDownloadItems());

                const dialogRef = this.dialog.open(DatasetDownloadComponent, {
                    width: "450px",
                    data: {
                        climateData: climateData
                    }
                });

                this.subscriptions.add(
                    dialogRef.afterClosed().subscribe((response) => {
                        if (response) {
                            const { result, selectedClimateData } = response;
                            this.downloadDatapoints(result, selectedClimateData);
                        }
                    })
                );
            });
        }
    }

    /**
     * Merge missing overlays from the full overlay tree into the target overlay structure.
     * Searches the full tree for overlays matching the given IDs and adds them to the
     * corresponding group in the target structure.
     */
    private mergeOverlaysFromFullTree(target: any[], fullTree: any[], overlayIds: string[]): void {
        const findOverlaysInTree = (groups: any[], ids: string[]): { overlay: any, groupName: string, parentPath: string[] }[] => {
            let found = [];
            groups?.forEach(group => {
                group.overlays?.forEach(overlay => {
                    if (ids.includes(overlay.id)) {
                        found.push({ overlay, groupName: group.group?.name, parentPath: [] });
                    }
                });
                if (group.children?.length) {
                    const childResults = findOverlaysInTree(group.children, ids);
                    childResults.forEach(r => {
                        r.parentPath = [group.group?.name, ...r.parentPath];
                    });
                    found = found.concat(childResults);
                }
            });
            return found;
        };

        const overlayExists = (groups: any[], overlayId: string): boolean => {
            for (const group of (groups || [])) {
                if (group.overlays?.some(o => o.id === overlayId)) return true;
                if (group.children?.length && overlayExists(group.children, overlayId)) return true;
            }
            return false;
        };

        const foundOverlays = findOverlaysInTree(fullTree, overlayIds);
        
        for (const { overlay, groupName, parentPath } of foundOverlays) {
            // Skip if overlay already exists in target
            if (overlayExists(target, overlay.id)) continue;

            // Find or create the matching group path in target
            let currentLevel = target;
            let inserted = false;

            // Navigate through the parent path to find the right group
            for (const pathName of parentPath) {
                const matchingGroup = currentLevel.find(g => g.group?.name?.trim() === pathName?.trim());
                if (matchingGroup) {
                    currentLevel = matchingGroup.children || [];
                } else {
                    break;
                }
            }

            // Find the final group that should contain this overlay
            const targetGroup = currentLevel.find(g => g.group?.name?.trim() === groupName?.trim());
            if (targetGroup) {
                if (!targetGroup.overlays) targetGroup.overlays = [];
                targetGroup.overlays.push(overlay);
                inserted = true;
            }

            // If not inserted in the correct position, add to a matching top-level group or create one
            if (!inserted) {
                // Try to find any group in the tree that matches the group name at any level
                const findGroupRecursive = (groups: any[], name: string): any => {
                    for (const g of (groups || [])) {
                        if (g.group?.name?.trim() === name?.trim()) return g;
                        if (g.children?.length) {
                            const found = findGroupRecursive(g.children, name);
                            if (found) return found;
                        }
                    }
                    return null;
                };
                const deepGroup = findGroupRecursive(target, groupName);
                if (deepGroup) {
                    if (!deepGroup.overlays) deepGroup.overlays = [];
                    deepGroup.overlays.push(overlay);
                }
            }
        }
    }

    downloadDatapoints(result, selectedClimateData) {
        const cloneObject = ObjectUtils.clone(this.getDefaultFilterObject());
        let geometryPrecision =
            this.dataset.geometryType !== DatasetGeometryType.NONE ? 25 : -1;
        let projection =
            result.projection !== "CURRENT_FIELDS"
                ? cloneObject.projection
                : ObjectUtils.clone(this.datapointFilterObject).projection;
        let formulaNames = projection.formulas && projection.formulas.length ? projection.formulas.filter(formula => formula.isProjected).map((field) => field.name) : [];
        let limit = this.datapointFilterObject.limit;
        let skip = this.datapointFilterObject.skip;
        let datapointIds = this.tableComponent ? this.tableComponent.getSelectedDatapointIds() : [];
        if (this.tableComponent) {


            limit = Number(
                (this.tableComponent.gridApi.paginationGetCurrentPage()+1) *
                20000
            );
            skip =
                this.tableComponent.gridApi.paginationGetCurrentPage() == 0
                    ? 0
                    : Number(
                        this.tableComponent.gridApi.paginationGetCurrentPage() *
                        20000
                    );
            const selectedDownloadRequestData = this.tableComponent
                ? this.tableComponent.getSelectedDownloadRequestData()
                : { selectedRows: [], selectedColumns: [], overlayColumns: [] };
            projection.fields = formulaNames.length ? selectedDownloadRequestData.selectedColumns.filter(column => !formulaNames.includes(column)) : selectedDownloadRequestData.selectedColumns; // [...new Set(projection.fields)];
            datapointIds = selectedDownloadRequestData.selectedRows;
            projection.links = selectedDownloadRequestData.overlayColumns.length
                ? projection.links.filter((element) =>
                    selectedDownloadRequestData.overlayColumns.includes(
                        element.datasetID
                    )
                )
                : projection.links;

        } else if (this.isMapView) {
            limit = -1;
            skip = 0;
            projection.fields = [...new Set(projection.fields)];
        }
        // Consolidated risk score picks are dataset fields, so they join the projection
        // rather than the overlay links the rest of that dialog's selections become.
        const consolidatedRiskScoreFields = this.prepareConsolidatedRiskScoreDownloadFields(selectedClimateData);
        if (consolidatedRiskScoreFields.length) {
            projection.fields = [...new Set([...(projection.fields || []), ...consolidatedRiskScoreFields])];
        }

        // Create an object to store unique records based on datasetID
        const mergedObject: Record<string, any> = {};

        // Merge existing overlays expect climate into mergedObject while skipping duplicates
        for (const item of projection.links) {
            mergedObject[item.datasetID] = item;
        }

        // Merge climate overlays into mergedObject while skipping duplicates
        for (const item of this.prepareClimateDownloadLinks(selectedClimateData)) {
            if (!mergedObject[item.datasetID]) {
                mergedObject[item.datasetID] = item;
            }
        }
        projection.formulas = projection.formulas && projection.formulas.length ? projection.formulas.filter(formula => formula.isProjected) : [];
        projection.links = Object.values(mergedObject); // ObjectUtils.clone([]); // Object.values(mergedObject);
        let request: DownloadDatapointRequest = {
            datapointRequest: {
                limit: limit,
                projection: {
                    ...projection,
                    geometryPrecision: geometryPrecision,
                },
                skip: skip,
                sort:
                    result.sort === "CURRENT_SORT" && !this.isMapView
                        ? this.datapointFilterObject.sort
                        : this.datapointFilterObject.sort,
            },
            filter:
                result.filter === "CURRENT_FILTER"
                    ? this.datapointFilterObject.filter
                    : this.datapointFilterObject.filter,
            timezone: Constants.DEFAULT_TIMEZONE,
            dateFormat: Constants.DEFAULT_DATE_FORMAT,
            outputFileType: result.fileType,
            datapointIds: datapointIds,
            // reportRequest: {},
        };
        const finalFileName = this.generateFileName(
            result.fileName.toString(),
            result.fileType.toLowerCase().toString()
        );
        this.subscriptions.add(
            this.downloadService
                .downloadDatapoints(this.dataset.id, request, result.fileName)
                .subscribe(
                    (response) => {
                        AttachmentUtils.downloadFileWithName(
                            response,
                            finalFileName
                        );
                    },
                    (error) =>
                        this.notifService.error(
                            "Something went wrong during download"
                        )
                )
        );
    }

    generateFileName(name: string, type: string): string {
        return name + "." + type;
    }

    applyDistanceFilter(
        dataset: Dataset,
        distance,
        distanceUnit: DistanceUnit
    ) {
        this.datapointsFilterService.applyOverlayDistance(
            dataset,
            distance,
            distanceUnit
        );
    }

    openDetails($event: MapDetails) {
        this.locationProfilePanel.previousSelectedValue = this.locationProfile.INTERNAL;
    //    this.mapComponent.isTensorflightFirstTimeFetched = true;
        this.mapComponent.isPreciselyFirstTimeFetched = true;
        this.mapComponent.isPreciselyWildfireFirstTimeFetched = true;
        this.mapComponent.areBoundsChanged = false;
    /*    this.externalTensorFlightData = null;
        if ($event.location !== null) {
            this.datasetService.fetchTensorflight({
                lat: $event.location.y,
                lng: $event.location.x
            }, $event.datapointID).subscribe(response => {
                this.externalTensorFlightData = response;
            });
        } */

        this.mapComponent.isPreciselyFirstTimeFetched = true;
        this.mapComponent.isPreciselyWildfireFirstTimeFetched = true;
        this.externalPreciselyData = null;
        // A different location means any Location Profile boundary on the map belongs to the
        // previous one; the panel also resets its dropdown to Internal without emitting a change.
        this.profilePolygonService.clearAll();
        this.externalPreciselyWildfireData = null;
        if ($event.location !== null) {
            this.datasetService.fetchPreciselyData({
                lat: $event.location.y,
                lng: $event.location.x
            }, $event.datapointID).subscribe(response => {
                this.externalPreciselyData = response;
                console.log("externalPreciselyData", this.externalPreciselyData);
            })
            this.datasetService.fetchPreciselyWildfirePolygon({
                lat: $event.location.y,
                lng: $event.location.x
            }, $event.datapointID).subscribe(response => {
                this.externalPreciselyWildfireData = response;
                // the polygon is fetched asynchronously, so draw it when it lands too - not
                // only on profile change, which may already have happened
                this.mapComponent.createPreciselyWildfirePolygon({
                    newSelectedValue: this.currentSelectedProfile
                });
            })
        }

        this.mapDatapointInfo = $event;
        if (!$event.refresh) {
            if ($event.dataset.id !== Crisis24Alert.getId()) {
                this.locationProfilePanel.onExpandedClick(true);
            } else if ($event.dataset.id == Crisis24Alert.getId()) {
                if (this.crises24DatapointsAgTablePanel) {
                    this.crises24DatapointsAgTablePanel.instance.closePanel();
                }
                this.sidePanelService.setRootViewContainerRef(
                    this.viewContainerRef
                );
                this.crises24DatapointsAgTablePanel =
                    this.sidePanelService.open<crises24DatapointsAgTableComponentType>(
                        SidePanels.CRISES24_DATAPOINTS_AGTABLE,
                        {
                            width: 500,
                            id: Crisis24Alert.getPanelId(),
                            panelTitle: "Crisis24 Alert",
                            resizeable: true,
                            panelIcon: "fa-atom",
                        },
                        {
                            datapointID: $event.datapointID,
                            dataset: $event.dataset,
                            location: $event.location,
                            version: $event.version,
                            radius: $event.radius,
                            isListCall: $event.isListCall,
                        }
                    );
                // this.locationProfilePanel.onExpandedClick(true);
            }
        }
        this.selectedLocationClone = ObjectUtils.clone($event.location); // we make a clone to be able to undo the changes
    }

    closeDetails(): void {
        this.mapDatapointInfo = undefined;
        this.selectedLocationClone = undefined;
        this.moveLocationModeEnabled = false;
        this.mapComponent.isPreciselyFirstTimeFetched = true;
        this.mapComponent.isPreciselyWildfireFirstTimeFetched = true;
        this.mapComponent.removePreciselyPolygon();
        this.profilePolygonService.clearAll();
        this.mapComponent.removePreciselyWildfirePolygon();
        this.externalPreciselyWildfireData = null;
    //    this.mapComponent.isTensorflightFirstTimeFetched = true;
    //    this.mapComponent.removeTensorflightPolygon();
    }

    private insertOverlay(
        overlay: Dataset,
        event: ActivateOverlayEvent,
        mapStateAction: MapStateActionEnum
    ) {
        if (event.renderingOptions) {
            let scaleType = event.renderingOptions.datasetStylingOptions.type;
            if (
                scaleType === ColorScaleType.FIXED ||
                scaleType === ColorScaleType.GRADIENT
            ) {
                let datasetID =
                    event.renderingOptions.converterOptions.datasetID;
                let fieldID = event.renderingOptions.converterOptions.fieldID;
                let datasetFields =
                    this.datapointsPageStateService.getDataset(
                        datasetID
                    ).fields;
                let colorizationField = datasetFields.find(
                    (field) => field.id === fieldID
                );
                let filter: DatapointFilter =
                    datasetID === this.dataset.id
                        ? {
                            datasetID: datasetID,
                            groups: this.getSelectedGroupsIds(),
                        }
                        : { datasetID: datasetID };
                return new Promise((resolve, reject) => {
                    this.subscriptions.add(
                        this.datapointAggregateService
                            .getDatapointsFieldStatistics(
                                datasetID,
                                colorizationField.id,
                                filter
                            )
                            .subscribe((statistics) => {
                                DatapointsComponent.setFieldStatistics(
                                    colorizationField,
                                    event.renderingOptions,
                                    statistics
                                );
                                this.putOverlayOnMap(
                                    mapStateAction,
                                    overlay.id,
                                    overlay,
                                    event
                                );
                                const field = this.dataset.fields.find(
                                    (field) => field.id === colorizationField.id
                                );
                                const rawFieldName =
                                    colorizationField.displayName === null ||
                                        colorizationField.displayName === undefined
                                        ? colorizationField.name
                                        : colorizationField.displayName;
                                // Transform SSP field names for climatology overlays
                                const isClimatologyOverlay = overlay.id && overlay.id.toLowerCase().startsWith('climate_');
                                const name = isClimatologyOverlay ? getSSPFieldLabel(rawFieldName) : rawFieldName;

                                if (!event.isDefaultCall) {
                                    this.addLegend(
                                        overlay.id,
                                        LegendUtils.createIntervalsForLegend(
                                            event.renderingOptions,
                                            overlay.isGeoserver
                                        ),
                                        false,
                                        this.getOverlayDisplayName(overlay.id, overlay.name, event.renderingOptions.climatologyOptions),
                                        name,
                                        LegendUtils.createGradientForLegend(
                                            event.renderingOptions,
                                            overlay.isGeoserver
                                        )
                                    );
                                }

                            })
                    );
                    resolve(true);
                });
            } else {
                // it is constant or interval. we don't need min and max
                return new Promise((resolve, reject) => {
                    if (scaleType === ColorScaleType.INTERVAL) {
                        if (
                            event.renderingOptions.visualizationOptions.type !==
                            VisualizationType.THEMATIC_MAP
                        ) {
                            let datasetID =
                                event.renderingOptions.converterOptions
                                    .datasetID;
                            let fieldID =
                                event.renderingOptions.converterOptions.fieldID;
                            let colorizationField =
                                this.datapointsPageStateService
                                    .getDataset(datasetID)
                                    .fields.find(
                                        (field) => field.id === fieldID
                                    );
                            DatapointsComponent.setFieldStatisticsForInterval(
                                colorizationField,
                                event.renderingOptions
                            );
                            const rawFieldName =
                                colorizationField.displayName === null ||
                                    colorizationField.displayName === undefined
                                    ? colorizationField.name
                                    : colorizationField.displayName;
                            // Transform SSP field names for climatology overlays
                            const isClimatologyOverlay = overlay.id && overlay.id.toLowerCase().startsWith('climate_');
                            const name = isClimatologyOverlay ? getSSPFieldLabel(rawFieldName) : rawFieldName;

                            if (!event.isDefaultCall) {
                                this.addLegend(
                                    overlay.id,
                                    LegendUtils.createIntervalsForLegend(
                                        event.renderingOptions,
                                        overlay.isGeoserver
                                    ),
                                    false,
                                    this.getOverlayDisplayName(overlay.id, overlay.name, event.renderingOptions.climatologyOptions),
                                    name,
                                    LegendUtils.createGradientForLegend(
                                        event.renderingOptions,
                                        overlay.isGeoserver
                                    )
                                );
                            }
                        }
                    }
                    if (scaleType === ColorScaleType.CONSTANT) {
                        // this.legends = [];
                    }
                    this.putOverlayOnMap(
                        mapStateAction,
                        overlay.id,
                        overlay,
                        event
                    );
                    resolve(true);
                });
            }
        }
    }

    /**
     * Rebuild the tile layer of every dataset on the map except the active one,
     * so they pick up the current geometry filter.
     *
     * A shape drawn on the map filters the view, not a single dataset. The active
     * dataset is handled by updatePortfolioLayer(); this covers the rest.
     */
    private refreshOverlayLayersForGeometryFilter(): void {
        const activeDatasets: Dataset[] =
            this.datapointsPageStateService?.activeDatasetsOnMap ?? [];

        const renderingOptions: Map<string, RenderingOptions> =
            this.datapointsOverlaysComponent?.getOverlaysRenderingOptions() ??
            new Map<string, RenderingOptions>();

        const skipped: string[] = [];

        activeDatasets.forEach((dataset) => {
            if (!dataset || dataset.id === this.dataset.id) {
                return; // the active dataset is rebuilt by updatePortfolioLayer()
            }
            const options = renderingOptions.get(dataset.id);
            if (!options) {
                // Cannot rebuild without rendering options, so this layer keeps
                // serving tiles from the URL it was created with - i.e. without the
                // geometry filter. Surfaced rather than skipped silently, because
                // such a layer is exactly what renders datapoints outside a shape.
                skipped.push(dataset.id);
                return;
            }
            this.putOverlayOnMap(
                MapStateActionEnum.UPDATE_OVERLAY,
                dataset.id,
                dataset,
                { active: true, datasetID: dataset.id, renderingOptions: options }
            );
        });

        if (skipped.length) {
            console.warn(
                '[geometryFilter] these dataset layers could not be rebuilt and may ' +
                'still render datapoints outside the drawn shape: ' + skipped.join(', ')
            );
        }

        // Re-request tiles for every layer on the map. Layers rebuilt above now
        // carry the geometry filter; this makes the map actually fetch them rather
        // than keep showing what it already had.
        this.mapStateService.refreshAllTiles();
    }

    private putOverlayOnMap(
        mapStateAction: MapStateActionEnum,
        datasetID: string,
        overlay: Dataset,
        event: ActivateOverlayEvent
    ) {
        switch (mapStateAction) {
            case MapStateActionEnum.UPDATE_OVERLAY:
                this.mapStateService.updateOverlay(
                    datasetID,
                    this.generateOverlayLayer(overlay, event)
                );
                break;
            case MapStateActionEnum.INSERT_OVERLAY:
                let index = datasetID !== this.dataset.id ? 0 : undefined; // on first position if it's an overlay
                this.mapStateService.insertOverlay(
                    datasetID,
                    this.generateOverlayLayer(overlay, event),
                    index
                );
                break;
        }
    }

    openAnalyticsPanel() {
        if (this.overlaysLoading) {
            this.loaderStateService.update(true);
            this.pendingAnalyticsAction = () => {
                this.showAnalyticsPanel();
                this.filterPanel?.instance?.hidePanel();
                setTimeout(() => {
                    this.analyticsPanel?.instance?.componentRef?.instance?.removeAllReports();
                }, 100);
            };
            return;
        }
        this.showAnalyticsPanel();
        this.filterPanel?.instance?.hidePanel();

        // Clear existing reports to open a blank analytics panel
        setTimeout(() => {
            this.analyticsPanel?.instance?.componentRef?.instance?.removeAllReports();
        }, 100);
    }

    openClusterPanel() {
        if (this.clusterPanel) {
            // Bring panel to front FIRST
            this.sidePanelService.setPanelFirst(this.clusterPanel.instance);
            this.clusterPanel.instance.showPanel();
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.clusterPanel =
                this.sidePanelService.open<DatapointsClusterComponentType>(
                    SidePanels.CLUSTER_PANEL,
                    {
                        width: 500,
                        id: "clusterPanel",
                        panelTitle: "Cluster",
                        panelIcon: "fa-atom",
                        resizeable: true,
                    },
                    {
                        dataset: this.dataset,
                        filter: this.filter,
                        initSettings: this.clusteringSettings,
                        layerExposeFields: this.layerExposeFields,
                        formulas: this.workspaceItemsForFormulas,
                    }
                );

            this.datapointsServiceState.onDataPointSelected$.subscribe(
                (clusterPoint: ClusterDatapoint) =>
                    this.openLocationProfile(clusterPoint)
            );
            this.datapointsServiceState.onApplySettings$.subscribe(
                (settings: ClusteringRequest) => {
                    this.clusteringSettings = settings;
                }
            );
            this.datapointsServiceState.onCancelClustering$.subscribe(() => {
                this.clusteringSettings = undefined;
                this.closeClusterPanel();
            });
        }
    }

    showAnalyticsPanel() {
        // Track navigation to Analytics Modal (hybrid approach)
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_analytics_modal_open');
        if (this.analyticsPanel) {
            // Bring panel to front FIRST
            this.sidePanelService.setPanelFirst(this.analyticsPanel.instance);
            this.analyticsPanel.instance.showPanel();
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.analyticsPanel =
                this.sidePanelService.open<AnalitycsComponentType>(
                    SidePanels.ANALYTICS,
                    {
                        width: 500,
                        id: ANALYTICS_PANEL_ID,
                        panelTitle: "Analytics",
                        resizeable: true,
                        panelIcon: 'icon-analitycs',
                    },
                    {
                        dataset: this.dataset,
                        nriFields: isUndefined(this.tessadataFieldsByDataset[this.dataset.id]) ? [] :
                            this.tessadataFieldsByDataset[this.dataset.id]
                                .nriFields,
                        _climateOverlays: this.prepareClimateOverlays()
                    }
                );
        }
    }

    openSavedAnalytics(item: WorkspaceItem) {
        if (!item) {
            return;
        }
        if (this.overlaysLoading) {
            this.loaderStateService.update(true);
            this.pendingAnalyticsAction = () => this.openSavedAnalytics(item);
            return;
        }
        this.showAnalyticsPanel();
        this.filterPanel?.instance?.hidePanel();

        // Apply the saved analytics after panel is shown
        setTimeout(() => {
            const analyticsInstance = this.analyticsPanel?.instance?.componentRef?.instance;
            if (analyticsInstance) {
                // Set comparison mode based on item type before applying
                const isComparison = item.type === WorkspaceItemType.ANALYTICS_COMPARISON;
                if (analyticsInstance.isComparisonModeActivated !== isComparison) {
                    analyticsInstance.isComparisonModeActivated = isComparison;
                }
                analyticsInstance.applyWorkspaceItem(item);
            }
        }, 100);
    }

    deleteAnalyticsWorkspaceItem(item: WorkspaceItem) {
        if (!item?.id) {
            return;
        }
        const dialogRef = this.dialog.open(DialogComponent, {
            data: new DialogModel(
                "Confirm Action",
                `Are you sure you want to delete "${item.name}"?`
            ),
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    this.workspaceItemsService.deleteWorkspaceItem(item.id).subscribe({
                        next: () => {
                            this.notifService.success('Analytics deleted successfully');
                            this.fetchWorkspaceItems();
                        },
                        error: (error) => {
                            this.notifService.error(error?.error?.message || 'Failed to delete analytics');
                        }
                    });
                }
            });
    }

    truncateAnalyticsName(name: string): string {
        if (!name) {
            return '';
        }
        const maxLength = 30;
        return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
    }

    /**
     * Categorize analytics workspace items into Global (Account) and Member (My Analysis)
     * and sort them alphabetically
     */
    categorizeAndSortAnalyticsItems(): void {
        // Separate items by access type
        this.globalAnalyticsItems = this.workspaceItemsForAnalytics
            .filter(item => item.access === WorkspaceItemAccess.GLOBAL)
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

        this.memberAnalyticsItems = this.workspaceItemsForAnalytics
            .filter(item => item.access === WorkspaceItemAccess.MEMBER)
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    }

    updateAggregateChartPanel() {
        if (this.accumulationsPanel) {
            let aggregateField = this.getAggregateFieldForThematicReport();
            let formulaIsUsed = false;
            if (this.thematicMapFormula) {
                formulaIsUsed = true;
            }
            const { componentRef } = this.accumulationsPanel.instance;

            if (componentRef) {
                componentRef.instance.removeAllReports();
            }
            let currentLevelDataset =
                this.mapThematicOverlayService.currentConfig.dataset;
            if (currentLevelDataset) {
                let currentLevelDatasetThematicField =
                    currentLevelDataset.fields.find(
                        (field) =>
                            field.id ===
                            currentLevelDataset.thematicMapSettings
                                .mainThematicFieldId
                    );
                let breakdownFields = this.getBreakdownFields(
                    currentLevelDataset,
                    currentLevelDatasetThematicField
                );

                breakdownFields.forEach((breakdownField) => {
                    if (componentRef) {
                        componentRef.instance.addAggregateReport();

                        let aggregateReportComponent =
                            componentRef.instance.aggregateReportComponents.find(
                                (component) =>
                                    !component.getSelectedAggregateField() &&
                                    !component.getSelectedFormula()
                            );
                        aggregateReportComponent?.includeThematicMapDatasets(
                            true
                        );

                        if (formulaIsUsed) {
                            aggregateReportComponent.formulas =
                                this.workspaceItemsForFormulas;
                            aggregateReportComponent?.setSelectedFormula(
                                this.thematicMapFormula
                            );
                        } else {
                            aggregateReportComponent?.setSelectedAggregateField(
                                aggregateField
                            );
                        }

                        aggregateReportComponent?.setSelectedBreakdownFieldsByDataset(
                            breakdownField
                        );

                        let reportFilter =
                            this.getFilterForThematicInteraction();
                        aggregateReportComponent?.setDatapointFilter(
                            reportFilter
                        );
                        aggregateReportComponent?.generateReport();
                    }
                });
            }
        }
    }

    /**
     * The aggregate report needs an aggregate field and a <Dataset, DatasetField[]> map with the breakdown fields
     * For the demo, the aggregate field must be the Total Insured Value, for now we keep it hardcoded, but it will need to be defined in the dataset
     * For the thematic map interaction:
     *      - The breakdown fields map is as follows:
     *          - dataset: the current level dataset
     *          - fields[]: [the main thematic field of the current level dataset]
     *      - The datapoints filter must have a link to the current level dataset and in the link the main thematic field must be specified.
     */
    toggleAggregateChartPanel() {
        if (
            this.mapInteractionMode === MapInteractionMode.THEMATIC_MAP_ACTIVE
        ) {
            if (!this.accumulationsPanel) {
                this.datapointsServiceState.onAnalyticsInit$.subscribe(() => {
                    this.updateAggregateChartPanel();
                });
            } else if (
                this.accumulationsPanel
            ) {
                this.openAccumulationsPanel();
                this.updateAggregateChartPanel();
            } else {
                this.accumulationsPanel.instance.hidePanel();
            }
        } else {
            this.notifService.error(
                "Can't open. Thematic map is not active."
            );
        }
    }

    private getBreakdownFields(
        currentLevelDataset: Dataset,
        currentLevelDatasetThematicField: DatasetField
    ) {
        let breakdownFields: Map<string, DatasetField[]>[] = [];

        let currentLevelBreakdownFieldsByDataset = new Map<
            string,
            DatasetField[]
        >();
        let fields = [currentLevelDatasetThematicField];
        let isLastLevelDataset =
            !this.mapThematicOverlayService.datasetsByParents.get(
                currentLevelDataset.id
            );
        if (isLastLevelDataset) {
            let additionalBreakdownField = currentLevelDataset.fields.find(
                (field) => field.name === "Postal Code"
            );
            if (additionalBreakdownField) {
                fields.push(additionalBreakdownField);
            }
            additionalBreakdownField = currentLevelDataset.fields.find(
                (field) => field.name === "Name"
            );
            if (additionalBreakdownField) {
                fields.push(additionalBreakdownField);
            }
        }
        currentLevelBreakdownFieldsByDataset.set(
            currentLevelDataset.id,
            fields
        );
        breakdownFields.push(currentLevelBreakdownFieldsByDataset);

        let occupancyBreakdownFieldsByDataset = new Map<
            string,
            DatasetField[]
        >();
        let occupancy = this.dataset.fields.find(
            (field) => field.name === "Occupancy"
        );
        if (occupancy) {
            occupancyBreakdownFieldsByDataset.set(this.dataset.id, [occupancy]);
            breakdownFields.push(occupancyBreakdownFieldsByDataset);
        }

        let constructionBreakdownFieldsByDataset = new Map<
            string,
            DatasetField[]
        >();
        let construction = this.dataset.fields.find(
            (field) => field.name === "Construction"
        );
        if (construction) {
            constructionBreakdownFieldsByDataset.set(this.dataset.id, [
                construction,
            ]);
            breakdownFields.push(constructionBreakdownFieldsByDataset);
        }

        return breakdownFields;
    }

    private getAggregateFieldForThematicReport(): DatasetField {
        return this.thematicMapMetric;
    }

    private getFilterForThematicInteraction() {
        let filter = JSON.parse(JSON.stringify(this.filter));
        let linkFilterToThematicLevel =
            this.mapThematicOverlayService.currentConfig.filter;
        if (linkFilterToThematicLevel) {
            const field: DatapointFilterField[] = [{ id: 'link_' + this.mapThematicOverlayService.currentConfig.parentDatasetId, maxDateValue: null, minDateValue: null, maxNumberValue: null, minNumberValue: 0, searchValue: null, textValues: [this.mapThematicOverlayService.currentConfig.geometryID.geometryID], distanceUnit: null }];
            filter.fields = filter.fields.length > 0 ? [...filter.fields, ...field] : field;
        }
        return filter;
    }

    private getFloatingFieldsValues() {
        this.fetchLocationsCount();
        this.fetchValuesForFloatingFields();
    }

    fetchLocationsCount() {
        let currentLevelDataset =
            this.mapThematicOverlayService.currentConfig.dataset;
        let filter = this.getFilterForThematicInteraction();
        let projection = this.prepareProjectionForFloatingFields();
        projection.geometryPrecision = 25;
        let groups: AggregateGroupRequest[] = [];
        groups.push({
            datasetID: currentLevelDataset.id,
            fieldID:
                currentLevelDataset.thematicMapSettings.mainThematicFieldId,
        });

        let reportRequest: ReportRequest = {
            datasetID: this.dataset.id,
            aggregateFieldCodes: [{ aggregateFieldCode: "1", id: "count" }],
            groups: groups,
            aggregateFieldType: DatapointAggregateFieldType.FIELD,
        };
        this.subscriptions.add(
            this.datapointAggregateService
                .getDatapointsCount(this.dataset.id, filter, projection)
                .subscribe((result) => {
                    this.datapointsCount = result.count;
                    this.accumulationsSerivce.emitThematicMapCount(result.count);
                })
        );
    }

    private fetchValuesForFloatingFields() {
        let currentLevelDataset =
            this.mapThematicOverlayService.currentConfig.dataset;
        this.floatingFieldsValuesByFields = new Map();

        let filter = this.getFilterForThematicInteraction();
        let projection = this.prepareProjectionForFloatingFields();

        this.datasetFloatingFields.forEach((field) => {
            let groups: AggregateGroupRequest[] = [];
            groups.push({
                datasetID: currentLevelDataset.id,
                fieldID:
                    currentLevelDataset.thematicMapSettings.mainThematicFieldId,
            });

            let formulaId = `${this.dataset.id}.${field.id}`;
            let reportRequest: ReportRequest = {
                datasetID: this.dataset.id,
                aggregateFieldCodes: [
                    { aggregateFieldCode: `VAR_${formulaId}`, id: formulaId },
                ],
                groups: groups,
                aggregateFieldType: DatapointAggregateFieldType.FIELD,
            };

            this.subscriptions.add(
                this.datapointAggregateService
                    .getDatapointsReport(
                        this.dataset.id,
                        filter,
                        reportRequest,
                        projection
                    )
                    .subscribe((result) => {
                        let totalValue = 0;
                        result.groupResults.forEach((groupResult) => {
                            if (
                                field.floatingOption ===
                                DatasetFieldFloatingOption.SUM
                            ) {
                                totalValue += groupResult.values[0].result;
                            } else {
                                totalValue +=
                                    groupResult.values[0].result /
                                    groupResult.values[0].count;
                            }
                        });
                        totalValue = Math.round(totalValue * 100) / 100;
                        this.floatingFieldsValuesByFields.set(
                            field,
                            totalValue
                        );
                        this.accumulationsSerivce.emitThematicMapFloatingFields(this.floatingFieldsValuesByFields)
                    })
            );
        });

        this.fetchTotalForSelectedMetric(currentLevelDataset, filter);
    }

    private fetchTotalForSelectedMetric(currentLevelDataset: Dataset, filter) {
        // if (!this.thematicMapMetric) {
        //     return;
        // }
        let projection: DatapointProjection;

        let groups: AggregateGroupRequest[];
        let reportRequest: ReportRequest;
        if (isUndefined(this.thematicMapFormula)) {
            projection = {
                datasetID: this.dataset.id,
                fields: [this.thematicMapMetric.id],
                links: [
                    {
                        datasetID: currentLevelDataset.id,
                        fields: [
                            currentLevelDataset.thematicMapSettings
                                .mainThematicFieldId,
                        ],
                    },
                ],
            };
            groups = [
                {
                    datasetID: currentLevelDataset.id,
                    fieldID:
                        currentLevelDataset.thematicMapSettings
                            .mainThematicFieldId,
                },
            ];
            const formulaId = `${this.dataset.id}.${this.thematicMapMetric.id}`;
            reportRequest = {
                datasetID: this.dataset.id,
                aggregateFieldCodes: [
                    { aggregateFieldCode: `VAR_${formulaId}`, id: formulaId },
                ],
                groups: groups,
                aggregateFieldType: DatapointAggregateFieldType.FIELD,
            };
        } else {
            let currentLevelDatasetThematicField =
                currentLevelDataset.fields.find(
                    (field) =>
                        field.id ===
                        currentLevelDataset.thematicMapSettings
                            .mainThematicFieldId
                );
            let breakdownFields = this.getBreakdownFields(
                currentLevelDataset,
                currentLevelDatasetThematicField
            );
            const field = !isUndefined(
                breakdownFields[breakdownFields.length - 1].get(this.dataset.id)
            )
                ? breakdownFields[breakdownFields.length - 1].get(
                    this.dataset.id
                )[0].id
                : null;
            projection = {
                datasetID: this.dataset.id,
                fields: [field],
                links: [],
            };
            groups = [
                {
                    datasetID: this.dataset.id,
                    fieldID: field,
                },
            ];
            reportRequest = {
                datasetID: this.dataset.id,
                aggregateFieldFormulaJson: this.thematicMapFormula.data,
                groups: groups,
                aggregateFieldType: DatapointAggregateFieldType.FORMULA,
            };
        }

        this.subscriptions.add(
            this.datapointAggregateService
                .getDatapointsReport(
                    this.dataset.id,
                    filter,
                    reportRequest,
                    projection
                )
                .subscribe((result) => {
                    let totalValue = 0;
                    result.groupResults.forEach(
                        (groupResult) =>
                            (totalValue += groupResult.values[0].result)
                    );
                    totalValue = Math.round(totalValue * 100) / 100;
                    this.thematicMapTotal = totalValue;
                    this.accumulationsSerivce.thematicMapTotal = totalValue;
                    this.accumulationsSerivce.emitThematicMapTotalValue(totalValue);
                })
        );
    }

    private prepareProjectionForFloatingFields(isCountApiCall: boolean = false): DatapointProjection {
        let currentLevelDataset =
            this.mapThematicOverlayService.currentConfig.dataset;
        let fields = this.dataset.fields
            .filter((f) => f.isFloating)
            .map((f) => f.id);
        let projection = {
            datasetID: this.dataset.id,
            fields: fields,
            links: [],
        };
        let linkProjection: DatapointProjection = {
            datasetID: currentLevelDataset.id,
            fields: [
                currentLevelDataset.thematicMapSettings.mainThematicFieldId,
            ],
        };
        if (!isCountApiCall) {
            projection.links.push(linkProjection);
        }
        return projection;
    }

    toggleThematicMap(checked: boolean) {
        let mapMode = this.datapointsPageStateService.getMapInteractionStatus();

        switch (mapMode.mode) {
            case MapInteractionMode.DEFAULT:
                if (checked) {
                    // we activate thematic
                    // TODO don't need to do all this every time. make the separate call for the thematic overlays from backend.
                    this.mapThematicOverlayService.prepareThematicMapDatasets();

                    if (this.thematicMapPreconditionsAreMet()) {
                        this.datapointsPageStateService.updateMapMode({
                            mode: MapInteractionMode.THEMATIC_MAP_ACTIVE,
                            externalDatasetName: null,
                            externalDatasetId: null,
                        });
                        this.mapThematicOverlayService.enableThematicMap();
                    }
                }
                break;
            case MapInteractionMode.THEMATIC_MAP_ACTIVE:
                if (!checked) {
                    // we disabled it
                    this.removeThematicMapLegends();
                    this.datapointsPageStateService.updateMapMode(
                        defaultMapStatus
                    );
                    this.mapThematicOverlayService.disableThmeaticMap();
                    if (
                        this.analyticsPanel &&
                        this.analyticsPanel.instance.isOpen
                    ) {
                        const { componentRef } = this.analyticsPanel.instance;
                        componentRef.instance.removeAllReports();
                    }
                }
                break;
            case MapInteractionMode.INTERACTION_DATASET_ACTIVE:
                this.notifService.error(
                    "Can't activate. The FEMA flood mode is active."
                );
                break;
        }
    }

    thematicMapPreconditionsAreMet(): boolean {
        let firstFloatingField = this.dataset.fields.find(
            (field) => field.isFloating
        );
        if (!firstFloatingField) {
            this.notifService.error(
                "Thematic map needs at least one floating field"
            );
            this.thematicMapToggleElement.checked = false; // turn off toggle programmatically
            return false;
        }
        const parentOverlaySize =
            this.mapThematicOverlayService.datasetsByParents.size;
        if (parentOverlaySize !== NR_THEMATIC_MAP_LEVELS) {
            this.thematicMapToggleElement.checked = false; // turn off toggle programmatically
            this.notifService.error(
                `You should have access to ${NR_THEMATIC_MAP_LEVELS} thematic overlays (Found ${parentOverlaySize}). Please contact your administrator`
            );
            return;
        }

        return true;
    }

    onToggleImageOverlay(event: ActivateImageOverlayEvent) {
        if (event.active) {
            // should activate overlay
            event.interactive
                ? this.enableInteractiveImageOverlay(
                    event.overlay,
                    event.opacity
                )
                : this.enableImageOverlay(event.overlay, event.opacity);
        } else {
            // should remove overlay
            event.interactive
                ? this.disableInteractiveImageOverlay(event.overlay)
                : this.disableImageOverlay(event.overlay);
        }
    }

    private enableImageOverlay(overlay: ImageOverlay, opacity: number = 1) {
        let versionToken = this.tileVersionService.getVersionToken();
        let cacheBuster = `&v=${versionToken}`;
        let layer = new google.maps.ImageMapType({
            getTileUrl: (coord, zoom) =>
                DatapointsComponent.computeImageOverlayUrl(
                    overlay.url,
                    zoom,
                    coord.x,
                    coord.y,
                    overlay.apiKey,
                    overlay.id,
                    overlay.offset
                ) + cacheBuster,
            minZoom: 1,
            maxZoom: 15,
            name: overlay.id,
            opacity: opacity,
            tileSize: new google.maps.Size(
                defaultTileSize.width,
                defaultTileSize.height
            ),
        });

        this.mapStateService.insertImageOverlay(overlay, layer);
    }

    private enableInteractiveImageOverlay(
        overlay: ImageOverlay,
        opacity: number
    ) {
        this.mapStateService.insertInteractiveImageOverlay(overlay, opacity);
    }

    private disableInteractiveImageOverlay(overlay: ImageOverlay) {
        this.mapStateService.removeInteractiveImageOverlay(overlay);
    }

    private disableImageOverlay(overlay: ImageOverlay) {
        this.mapStateService.removeImageOverlay(overlay);
    }

    openEventNotificationsPanel() {
        // Track navigation to Notifications Modal (hybrid approach)
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_event_notifications_modal_open');

        if (this.notificationsPanel) {
            // Bring panel to front FIRST
            this.sidePanelService.setPanelFirst(this.notificationsPanel.instance);
            this.notificationsPanel.instance.showPanel();
        } else {
            this.notifPanelIsOpen = true;
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.notificationsPanel =
                this.sidePanelService.open<EventNotificationComponentType>(
                    SidePanels.NOTIFICATIONS_PANEL,
                    {
                        width: 500,
                        id: "notificationsPanel",
                        panelTitle: "Alerts",
                        resizeable: true
                    },
                    {
                        dataset: this.dataset,
                        account: this.account,
                        groupsIds: this.groupsPanel.groupsIds,
                    }
                );
        }
    }

    openEditPanel($event: any) {
        // Track navigation to Edit Datapoint Panel (hybrid approach)
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_edit_datapoint_modal_open');
        if (this.alterDatapointsEnabled) {
            if (this.updateDatapointPanel) {
                // Bring panel to front FIRST
                this.sidePanelService.setPanelFirst(this.updateDatapointPanel.instance);
                this.updateDatapointPanel.instance.showPanel();
            } else {
                this.sidePanelService.setRootViewContainerRef(
                    this.viewContainerRef
                );
                this.updateDatapointPanel =
                    this.sidePanelService.open<UpdateDatapointComponentType>(
                        SidePanels.UPDATE_DATAPOINT,
                        {
                            width: 400,
                            id: "update-datapoint-panel",
                            panelTitle: "Edit",
                        },
                        {
                            dataset: this.dataset,
                        }
                    );

                this.datapointsServiceState.onUpdateDataPointInit$.subscribe(
                    () => {
                        const { componentRef } =
                            this.updateDatapointPanel.instance;
                        if (componentRef) {
                            componentRef.instance.setDataset($event);
                        }
                    }
                );

                this.datapointsServiceState.datapointUpdate$.subscribe(() =>
                    this.onUpdated()
                );
            }
        }
    }

    applyWorkspaceItemTableProjection(item: WorkspaceItem) {
        this.datapointsFilterService.updateArray([]);
        const parsedData = JSON.parse(item.data);
        this.projection = parsedData.projection;
        this.filter = parsedData.filter;

        // Restore sort configuration from saved view
        if (parsedData.sort) {
            this.sort = parsedData.sort;
        } else {
            // Reset to default sort if not present in saved view
            this.sort = { datasetID: this.dataset.id, links: [], fields: [] };
        }

        this.filter.groups = this.datapointsPageStateService.activeGroups;
        // Update page state active groups to match saved groups
        this.datapointsPageStateService.activeGroups = this.filter.groups;
        // Update filter service with saved groups
        if (this.filter.groups) {
            this.datapointsFilterService.updateGroups(this.filter.groups);
        }
        // Update group panel UI to reflect saved groups
        if (this.groupsPanel && this.filter.groups) {
            this.groupsPanel.markGroupsAsSelected(this.filter.groups);
        }
        this.linkedAccountDatasets.forEach((dataset) => {
            dataset.fields.forEach((field) => (field.isProjected = false)); // set everything to false first

            if (dataset.id !== this.dataset.id) {
                this.projection.links.forEach((link) => {
                    if (link.datasetID === dataset.id) {
                        dataset.fields.forEach((field) => {
                            if (link.fields.includes(field.id)) {
                                field.isProjected = true;
                            }
                        });
                    }
                });
            } else {
                dataset.fields.forEach((field) => {
                    if (this.projection.fields.includes(field.id)) {
                        field.isProjected = true;
                    }
                });
            }
        });
        this.linkedAccountOverlays.forEach((dataset) => {
            dataset.fields.forEach((field) => (field.isProjected = false)); // set everything to false first

            this.projection.links.forEach((link) => {
                if (link.datasetID === dataset.id) {
                    dataset.fields.forEach((field) => {
                        if (link.fields.includes(field.id)) {
                            field.isProjected = true;
                        }
                    });
                }
            });
        });
        let fields = this.projection.fields;
        this.projection.fields = fields;
        if (this.workspaceItemsForFormulas) {
            this.workspaceItemsForFormulas.forEach((formula) => {
                formula.isProjected = false; // set everything to false
                if (this.projection.formulas) {
                    this.projection.formulas.forEach((projectedFormula) => {
                        if (projectedFormula.id === formula.id) {
                            formula.isProjected = projectedFormula.isProjected;
                        }
                    });
                }
            });
        }
        this.datapointsFilterService.updateArray(this.projection.fields);
        this.removeFilterBar();
        if (this.filter.fields.length) {
            this.createPopulatedFilterBarItemForTableView(this.dataset, this.filter.fields);
        }
        this.datapointFilterObject = this.constructFilterObject();
        if (this.projection.formulas && this.projection.formulas.length) {
            this.datapointsFilterService.updateFilter();
        }

        // Apply saved sort to AG Grid
        if (this.sort && this.sort.fields && this.sort.fields.length > 0) {
            setTimeout(() => {
                if (this.tableComponent && this.tableComponent.gridColumnApi) {
                    const sortField = this.sort.fields[0];
                    const columnState = {
                        colId: sortField.id,
                        sort: sortField.sortOrder === 'ASCENDANT' ? 'asc' : 'desc',
                        sortIndex: 0
                    };
                    this.tableComponent.gridColumnApi.applyColumnState({
                        state: [columnState],
                        defaultState: { sort: null }
                    });
                }
            }, 100);
        }
        // this.datapointsFilterService.updateFilter();
        // setTimeout(() => {
        //     this.datapointFilterObject = this.constructFilterObject();
        //     this.datapointsFilterService.updateFilter();
        // }, 1000);
        // this.fetchDatapoints();
    }

    refreshWorkspaceItems(itemType: WorkspaceItemType) {
        this.fetchWorkspaceItems();
        // Refresh location profile dropdown when a formula is created
        if (itemType === WorkspaceItemType.FORMULA && this.locationProfilePanel) {
            this.locationProfilePanel.refreshLocationProfileDropdown();
        }
    }

    deleteWorkspaceItem(item: WorkspaceItem) {
        const dialogRef = this.dialog.open(DialogComponent, {
            data: new DialogModel(
                "Confirm Action",
                `Are you sure you want to delete "${item.name}"?`
            ),
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    this.workspaceItemsService
                        .deleteWorkspaceItem(item.id)
                        .subscribe(
                            (success) => {
                                this.datapointsFilterService.emitChangeSavedFilters();
                                this.fetchWorkspaceItems();
                                // update formulas projection
                                if (
                                    this.projection.formulas &&
                                    item.type === WorkspaceItemType.FORMULA &&
                                    item.isProjected
                                ) {
                                    this.findItemInListAndDelete(
                                        item,
                                        this.projection.formulas
                                    );
                                    this.fetchDatapoints();
                                }
                                // clear filters on delete one
                                if (item.type === WorkspaceItemType.FILTER) {
                                    this.removeFilterFromMap();
                                }
                                // Refresh location profile dropdown to reflect changes
                                if (this.locationProfilePanel) {
                                    this.locationProfilePanel.refreshLocationProfileDropdown();
                                }
                                this.notifService.success(
                                    "Item was deleted successfully"
                                );
                            },
                            (error) =>
                                this.notifService.error(error.error.message)
                        );
                }
            });
    }

    removeFilterFromMap() {
        this.removeFilterBar();
        this.mapStateService.clearShapes(MapDrawType.FILTER);
        this.mapStateService.emitSelectedGeoRegion([]);
        this.mapStateService.clearFilteredGeoRegions(true);
    }

    /**
     * the filter on datapoints page and filter service will recreate itself when the filter bar items are parsed
     */
    applyWorkspaceItemFilter(item: WorkspaceItem) {
        let filter: DatapointFilter = JSON.parse(item.data);
        let statisticsNeedToBeFetched = false;

        // allow only one filter to project - Filter, Select, Zoom
        this.removeFilterFromMap();

        // populate filter bar items
        this.filterAccountDatasets.forEach((dataset) => {
            dataset.fields.forEach((field) => (field.selected = false)); // set everything to false first

            if (dataset.id === this.dataset.id && filter.fields) {
                filter.fields.forEach((filterField) => {
                    statisticsNeedToBeFetched = true;
                    this.statisticsFiltersFetched = true;
                    this.createPopulatedFilterBarItem(dataset, filterField);
                });
            } else {
                this.createFilterBarItemsFromFilterLinks(
                    filter,
                    dataset,
                    statisticsNeedToBeFetched
                );
            }
        });

        this.linkedAccountOverlays.forEach((dataset) => {
            dataset.fields.forEach((field) => (field.selected = false)); // set everything to false first
            this.createFilterBarItemsFromFilterLinks(
                filter,
                dataset,
                statisticsNeedToBeFetched
            );
        });

        filter.groups = this.datapointsPageStateService.activeGroups;

        // populate shapes
        this.initializeShapesFromFilter(filter.geometryFilter);

        //populate Zoom region
        if (
            filter.geometryFilter &&
            filter.geometryFilter.regionIds &&
            filter.geometryFilter.regionIds.length > 0
        ) {
            this.initializeZoomRegionFromFilter(filter.geometryFilter);
        }
        if (statisticsNeedToBeFetched) {
            this.subscriptions.add(
                this.datapointsFilterService
                    .onFetchStatisticsReady()
                    .subscribe((ready) => {
                        if (
                            filter.fields.length > 0 &&
                            this.statisticsFiltersFetched
                        ) {
                            let filters = this.filterBarItems.filter((value) =>
                                filter.fields.find(
                                    (field) => field.id === value.id
                                )
                            );
                            if (filter.fields.length === filters.length) {
                                for (let i = 0; i < filters.length; i++) {
                                    if (
                                        filters[i].statisticValues !== null &&
                                        filter.fields[i].textValues.length > 0
                                    ) {
                                        filter.fields[i].textValues.forEach(
                                            (value) => {
                                                filters[i].statisticValues[
                                                    value
                                                ] = true;
                                                this.datapointsFilterService.populateFilterBarItemDisplayValues(
                                                    filters[i]
                                                );
                                            }
                                        );
                                    }
                                }
                            }

                            this.datapointsFilterService.initFilter(filter);
                            this.datapointsFilterService.emitFilterUpdate();
                            this.datapointsFilterService.emitSavedFilterApplied();
                            this.datapointFilterObject =
                                this.constructFilterObject();
                        }
                    })
            );
        } else {
            this.datapointsFilterService.initFilter(filter);
            this.datapointsFilterService.emitFilterUpdate();
            this.datapointsFilterService.emitSavedFilterApplied();
            this.datapointFilterObject = this.constructFilterObject();
        }
    }

    private initializeZoomFromActiveFilter() {
        let geometryFilter =
            this.datapointsFilterService.getActiveFilter().geometryFilter;
        this.initializeZoomRegionFromFilter(geometryFilter);
    }

    initializeZoomRegionFromFilter = async (geometryFilter) => {
        if (
            geometryFilter &&
            geometryFilter.regionIds &&
            geometryFilter.regionIds.length > 0
        ) {
            let regionArray = [];
            from(geometryFilter.regionIds)
                .pipe(
                    mergeMap((param) =>
                        this.geoRegionsService.getRegion(+param)
                    )
                )
                .subscribe((val) => {
                    regionArray.push(val);
                    this.datapointsFilterService.emitzoomFromFiter(regionArray);
                    this.mapStateService.emitSelectedGeoRegion(regionArray);
                });
        }
    };

    private createFilterBarItemsFromFilterLinks(
        filter: DatapointFilter,
        dataset,
        statisticsNeedToBeFetched: boolean
    ) {
        filter.links.forEach((link) => {
            if (link.datasetID === dataset.id) {
                link.fields.forEach((linkField) => {
                    statisticsNeedToBeFetched = true;
                    this.createPopulatedFilterBarItem(dataset, linkField);
                });
                link.linkFields.forEach((linkField) => {
                    this.createPopulatedDistanceFilterBarItem(
                        dataset,
                        linkField
                    );
                });
            }
        });
    }

    private createPopulatedDistanceFilterBarItem(dataset, linkField) {
        let distanceField: DatasetField = {
            id: "distance",
            name: "Distance",
            type: DatasetFieldSpecificType.NUMBER_FIELD,
            baseType: DatasetFieldType.NUMBER,
        };
        let filterBarItem = this.datapointsFilterService.addFilterBarItem(
            distanceField,
            dataset,
            true
        );
        switch (linkField.distanceUnit) {
            case DistanceUnit.KM:
                filterBarItem.maxNumberValue =
                    ComputationUtils.getDistanceInUnit(
                        linkField.maxNumberValue,
                        DistanceUnit.KM
                    );
                break;
            case DistanceUnit.MILES:
                filterBarItem.maxNumberValue =
                    ComputationUtils.getDistanceInUnit(
                        linkField.maxNumberValue,
                        DistanceUnit.MILES
                    );
                break;
        }
        filterBarItem.minNumberValue = 0;
        filterBarItem.distanceUnit = linkField.distanceUnit;

        if (
            this.overlaysFilterDistance[dataset.id] !==
            filterBarItem.maxNumberValue
        ) {
            this.overlaysFilterDistance[dataset.id] =
                filterBarItem.maxNumberValue;
        }
    }

    private createPopulatedFilterBarItemForTableView(dataset, filterField) {
        const filterFieldIds = filterField.map((f) => f.id);
        let datasetFields = dataset.fields.filter(
            (ds) => filterFieldIds.includes(ds.id)
        );
        if (datasetFields.length) {
            let params: Map<string, any> = new Map();
            this.filter.fields.forEach(field => {
                params.set(
                    field.id,
                    field
                );
            })
            this.datapointsFilterService.addFilterBarItemForTableView(datasetFields, dataset, params);
        }
    }

    private createPopulatedFilterBarItem(dataset, filterField) {
        let datasetField = dataset.fields.find(
            (ds) => ds.id === filterField.id
        );
        if (datasetField) {
            datasetField.selected = true;
            if (filterField.textValues && filterField.textValues.length > 0) {
                this.datapointsFilterService.addFilterBarItem(
                    datasetField,
                    dataset,
                    false,
                    filterField.textValues
                );
            } else {
                let filterBarItem =
                    this.datapointsFilterService.addFilterBarItem(
                        datasetField,
                        dataset
                    );
                filterBarItem.maxNumberValue = filterField.maxNumberValue;
                filterBarItem.minNumberValue = filterField.minNumberValue;
                filterBarItem.maxDateValue = filterField.DateValue;
                filterBarItem.minDateValue = filterField.DateValue;
                filterBarItem.searchValue = filterField.searchValue;
            }
        }
    }

    get MapInteractionMode() {
        return MapInteractionMode;
    }

    get DistanceUnit() {
        return DistanceUnit;
    }

    get DatasetFieldType() {
        return DatasetFieldType;
    }

    get MapDrawType() {
        return MapDrawType;
    }

    get MapShape() {
        return MapShape;
    }

    get DatasetGeometryType() {
        return DatasetGeometryType;
    }

    get WorkspaceItemType() {
        return WorkspaceItemType;
    }

    get JSON() {
        return JSON;
    }

    selectThematicMapMetric(field: DatasetField, $event: MatCheckboxChange) {
        this.customLegendsEnabled = false;
        this.mapThematicOverlayService.emitCustomizedLegends([]);
        this.legendLimitForm.reset();
        if ($event.checked) {
            this.thematicMapMetric = field;
            this.dataset.fields.forEach((f) => {
                f.selectedForTM = f.id === field.id;
            });
            this.thematicMapFormula = undefined;
            this.workspaceItemsForFormulas.forEach(
                (f) => (f.selectedForTM = false)
            );
        } else {
            this.thematicMapMetric = undefined;
        }
        if (this.isThematicMapActive) {
            this.mapThematicOverlayService.setActive(
                this.mapThematicOverlayService.currentConfig
            );
        }
    }

    selectThematicMapGrouping(item: string, $event: MatCheckboxChange) {
        if ($event.checked) {
            this.thematicMapGrouping = item;
        } else {
            this.thematicMapGrouping = "";
        }
        if (this.isThematicMapActive) {
            this.mapThematicOverlayService.setActive(
                this.mapThematicOverlayService.currentConfig
            );
        }
    }

    fetchExternalDataByCountry(datasetsByCountry: TessadataDatasetsByCountry) {
        let datasetsIds = [].concat
            .apply([], datasetsByCountry.datasets)
            .map((dataset) => dataset.datasetId);
        this.tableComponent.fetchExternalData([datasetsIds], false);
    }

    onCustomLocationDetailsSelected(location: Point) {
        this.datapointsServiceState.munichreFieldsWithValues = [];
        this.datapointsServiceState.dataSource = [];
        this.datapointsServiceState.riskDataSource = [];
      //  this.datapointsServiceState.tensorflightFieldsWithValues = [];
        this.datapointsServiceState.e2valueFieldsWithValues = [];
      //  this.datapointsServiceState.emitOnTensorflightAddressProfilePolygonFetch("");
        this.analytics.trackEvent('address_location_profile_opened');
        if (this.addressLocationPanel) {
            // Bring panel to front FIRST
            this.sidePanelService.setPanelFirst(this.addressLocationPanel.instance);
            this.addressLocationPanel.instance.hidePanel(null, true);
            this.addressLocationPanel.instance.showPanel();

            const { componentRef } = this.addressLocationPanel.instance;
            if (componentRef) {
                componentRef.instance.setLocation({
                    address: location,
                    externalPOIMenuItems: this.externalPOIMenuItems,
                    externalPOIDatasetsStructures:
                        this.externalPOIDatasetsStructures,
                });
                componentRef.instance.datasetID = this.dataset.id;
            }
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.addressLocationPanel =
                this.sidePanelService.open<AddressLocationProfileComponent>(
                    SidePanels.ADDRESS_LOCATION_PROFILE,
                    {
                        id: "addressLocationProfilePanel",
                        width: 500,
                        panelTitle: "Address Profile",
                        panelIcon: 'fa-map-marker-alt',
                        resizeable: true
                    }
                );

            this.datapointsServiceState.onAddressLocationProfileInit$.subscribe(
                () => {
                    if (this.addressLocationPanel) {
                        const { componentRef } = this.addressLocationPanel.instance;
                        if (componentRef) {
                            componentRef.instance.datasetID = this.dataset.id;
                            componentRef.instance.setLocation({
                                address: location,
                                externalPOIMenuItems: this.externalPOIMenuItems,
                                externalPOIDatasetsStructures:
                                    this.externalPOIDatasetsStructures,
                            });
                        }
                    }
                }
            );

            this.sidePanelService.onHide$.subscribe((id: string) => {
                if (id === "addressLocationProfilePanel")
                    this.removeSearchResultMarker();
            });

            this.sidePanelService.onDropDownValueChanged$.subscribe(
                (value: string) => {
                    this.datapointsServiceState.emitDropDownValue(value);
                }
            );

            this.datapointsServiceState.onAddressLocationProfileDestroyed$.subscribe(
                () => {
                    this.removeSearchResultMarker();
                }
            );
        }
    }

    isNotAllDatasetSelected(
        fields: DatasetField[],
        isLocationCheckBox?: boolean
    ): boolean {
        return (
            fields.filter((field) => {
                if (
                    isLocationCheckBox &&
                    (field.scope === this.datasetFieldScope.NRI ||
                        field.scope === this.datasetFieldScope.EXTERNAL)
                ) {
                    return;
                }

                return !field.isProjected;
            }).length > 0
        );
    }

    isNotAllNRIDatasetSelected(
        fields: DatasetField[],
        isLocationCheckBox?: boolean
    ): boolean {
        let result = false;
        fields.forEach((element1) => {
            let count = 0;
            element1.child.forEach((element2) => {
                if (
                    element2.child.scope == this.datasetFieldScope.NRI &&
                    element2.child.isProjected == false
                ) {
                    element1.isParentSelected = false;
                    result = true;
                    return;
                } else if (
                    element2.child.scope == this.datasetFieldScope.NRI &&
                    element2.child.isProjected == true
                ) {
                    count += 1;
                }
            });

            if (count == element1.child.length) {
                element1.isParentSelected = true;
            }
        });
        return result;
    }

    onFilterAllClick(
        $event: MatCheckboxChange,
        fields: DatasetField[],
        dataset: Dataset,
        isLocationCheckBox?: boolean
    ) {
        fields.forEach((field) => {
            if (
                isLocationCheckBox &&
                (field.scope === this.datasetFieldScope.NRI ||
                    field.scope === this.datasetFieldScope.EXTERNAL)
            ) {
                return;
            }

            field.isProjected = $event.checked;
            this.onProjectionChange(dataset, field);
        });
    }

    onNRIFilterAllClick(
        $event: MatCheckboxChange,
        fields: DatasetField[],
        dataset: Dataset,
        isLocationCheckBox?: boolean
    ) {
        fields.forEach((element1) => {
            element1.child.forEach((element2) => {
                if (element2.child.scope == this.datasetFieldScope.NRI) {
                    element2.child.isProjected = $event.checked;
                    this.onProjectionChange(dataset, element2);
                }
            });
            element1.isParentSelected = $event.checked;
        });
    }

    closeClusterPanel() {
        if (this.clusterPanel) {
            this.clusterPanel.instance.hidePanel();
        }
    }

    removeSearchResultMarker() {
        this.mapStateService.activeSearchResultMarker$.next(null);
        this.mapStateService.updateCurrentPinAddress(null);
        this.mapStateService.emitMarkerIsInitialized(false);
    }

    openPopup = (item) => {
        if (this.isThematicMapActive) {
            let currentActiveChecked =
                this.thematicMapFormula || this.thematicMapMetric;
            if (
                item.id === currentActiveChecked.id &&
                item.name === currentActiveChecked.name
            ) {
                this.customLegendsEnabled = true;
            }
        } else {
            this.notifService.error(
                "Please enable thematic Map first before customizing legends."
            );
        }
    };

    closePopup = () => {
        this.customLegendsEnabled = false;
        this.legendLimitForm.reset();
    };

    getLegends = () => {
        if (this.legendLimitForm.valid) {
            this.customLegendsEnabled = false;
            let legendArray = [];
            Object.keys(this.legendLimitForm.controls).forEach((key) => {
                legendArray.push(this.legendLimitForm.controls[key].value);
            });
            this.mapThematicOverlayService.emitCustomizedLegends(legendArray);
            this.mapThematicOverlayService.setActive(
                this.mapThematicOverlayService.currentConfig
            );
        } else {
            this.notifService.error("Please enter values for all fields.");
        }
    };

    groupByNriFields(nriFields) {
        const groupBy = (array, key) => {
            // Return the end result
            return array.reduce((result, currentValue) => {
                // If an array already present for key, push it to the array. Else create an array and push the object
                let symbol = null;
                if (currentValue[key].trim().split("-").length > 1) {
                    symbol = "-";
                } else if (currentValue[key].trim().split("–").length > 1) {
                    symbol = "–";
                }
                if (isNullOrUndefined(symbol)) {
                    (result[currentValue[key].trim()] =
                        result[currentValue[key].trim()] || []).push({
                            name: currentValue[key].trim(),
                            child: currentValue,
                        });
                } else {
                    (result[currentValue[key].trim().split(symbol)[0].trim()] =
                        result[
                        currentValue[key].trim().split(symbol)[0].trim()
                        ] || []).push({
                            name: currentValue[key].trim().split(symbol)[1],
                            child: currentValue,
                        });
                }
                // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
                return result;
            }, {}); // empty object is the initial value for result object
        };
        const groupByObjectResponse = groupBy(nriFields, "name");
        let tempArray = [];
        let nriSummaryArray = [
            { name: "NRI Summary", isParentSelected: true, child: [] },
        ];
        Object.keys(groupByObjectResponse).map(function (key) {
            let nameSplitValue = key.split(" ");
            groupByObjectResponse[key][0].child.isProjected = true;
            if (
                [
                    TessadataNriFields.SUMMARY_SOVI_RATING,
                    TessadataNriFields.SUMMARY_RESL_RATING,
                ].includes(groupByObjectResponse[key][0].child.id)
            ) {
                nriSummaryArray[0].child.push({
                    name:
                        nameSplitValue[1] + " " + nameSplitValue[2] + " Rating",
                    child: groupByObjectResponse[key][0].child,
                });
            } else if (
                groupByObjectResponse[key][0].child.id ==
                TessadataNriFields.SUMMARY_EAL_RATING
            ) {
                nriSummaryArray[0].child.push({
                    name: nameSplitValue[1] + " Rating",
                    child: groupByObjectResponse[key][0].child,
                });
            } else if (
                groupByObjectResponse[key][0].child.id ==
                TessadataNriFields.SUMMARY_RISK_RATING
            ) {
                nriSummaryArray[0].child.push({
                    name: "Overall " + nameSplitValue[1],
                    child: groupByObjectResponse[key][0].child,
                });
            } else {
                tempArray.push({
                    name: key,
                    isParentSelected: true,
                    child: groupByObjectResponse[key],
                });
                return tempArray;
            }
        });

        if (nriSummaryArray[0].child.length > 0) {
            tempArray = [...nriSummaryArray, ...tempArray];
        }
        return tempArray;
    }

    bindFilterIdRecurciveCall(parent, fieldIds, isFilterBarItemRemoveCall) {
        if (isUndefined(parent.children) && parent.length) {
            parent.forEach((element) => {
                if (!isUndefined(element.children) && element.children.length) {
                    this.bindFilterIdRecurciveCall(
                        element.children,
                        fieldIds,
                        isFilterBarItemRemoveCall
                    );
                    return;
                } else if (
                    isUndefined(element.children) &&
                    fieldIds.length > 0 &&
                    fieldIds.includes(element.id)
                ) {
                    element.selected = isFilterBarItemRemoveCall ? false : true;
                } else if (
                    isUndefined(element.children) &&
                    fieldIds.length > 0 &&
                    !fieldIds.includes(element.id)
                ) {
                    element.selected = false;
                } else if (
                    isUndefined(element.children) &&
                    fieldIds.length <= 0
                ) {
                    element.selected = false;
                }
            });
        }
    }

    bindFilterIds($event, isFilterBarItemRemoveCall: boolean = false) {
        if ($event.fieldIds.length > 0) {
            this.dataSource.data.forEach((element) => {
                if (!isUndefined(element.children) && element.children.length) {
                    this.bindFilterIdRecurciveCall(
                        element.children,
                        $event.fieldIds,
                        isFilterBarItemRemoveCall
                    );
                    return;
                }
            });
        } else if ($event.fieldIds.length <= 0 && isFilterBarItemRemoveCall) {
            this.dataSource.data.forEach((element) => {
                if (!isUndefined(element.children) && element.children.length) {
                    this.bindFilterIdRecurciveCall(
                        element.children,
                        $event.fieldIds,
                        isFilterBarItemRemoveCall
                    );
                    return;
                }
            });
        }
    }

    public openViewSaveAsModal() {
        // let agTableColumns = this.tableComponent.prepareColumnsForSaveAs();
        // agTableColumns = agTableColumns
        //     .filter((el) => el.split("_").length <= 1)
        //     .map((row) => row);
        //         let projection: DatapointProjection = this.projection;
        //         const selectedDownloadRequestData = this.tableComponent
        //               ? this.tableComponent.getSelectedDownloadRequestData()
        //               : { selectedRows: [], selectedColumns: [], overlayColumns: [] };
        //           projection.fields = selectedDownloadRequestData.selectedColumns;
        // if (agTableColumns.length) {
        //     projection.fields = agTableColumns.filter(
        //     (element) => element.split("_").length <= 1
        //     );
        // }
        let projection: DatapointProjection = this.projection;
        let formulaNames = projection.formulas && projection.formulas.length ? projection.formulas.map((field) => field.name) : [];
        const selectedDownloadRequestData = this.tableComponent
            ? this.tableComponent.getSelectedDownloadRequestData()
            : { selectedRows: [], selectedColumns: [], overlayColumns: [] };
        projection.fields = formulaNames.length ? selectedDownloadRequestData.selectedColumns.filter(column => !formulaNames.includes(column)) : selectedDownloadRequestData.selectedColumns; // [...new Set(projection.fields)];
        this.workspaceIemDialog.open(
            { filter: this.filter, projection: projection, sort: this.sort },
            WorkspaceItemType.TABLE_PROJECTION,
            false
        );
    }

    public openViewSaveModal() {
        let projection: DatapointProjection = this.projection;
        let formulaNames = projection.formulas && projection.formulas.length ? projection.formulas.map((field) => field.name) : [];
        const selectedDownloadRequestData = this.tableComponent
            ? this.tableComponent.getSelectedDownloadRequestData()
            : { selectedRows: [], selectedColumns: [], overlayColumns: [] };
        projection.fields = formulaNames.length ? selectedDownloadRequestData.selectedColumns.filter(column => !formulaNames.includes(column)) : selectedDownloadRequestData.selectedColumns; // [...new Set(projection.fields)];
        this.workspaceIemDialog.open(
            { filter: this.filter, projection: projection, sort: this.sort },
            WorkspaceItemType.TABLE_PROJECTION,
            true
        );
    }

    public closeCrisis24Panel(datasetId) {
        if (
            this.crises24DatapointsAgTablePanel &&
            datasetId == Crisis24Alert.getId()
        ) {
            this.crises24DatapointsAgTablePanel.instance.closePanel();
            this.crises24DatapointsAgTablePanel = null;
        }
    }

    callFilterAction($event, node) {
        const params = node.params;
        if (["dataset", "tesadataGroup", "nriUSA"].includes(params.callType)) {
            this.onFilterMenuFieldClick(!$event, params.dataset, params.field);
        } else if (params.callType == "climate") {
            this.onFilterMenuFieldClick(!$event, params.overlay, params.field);
        }
    }

    distanceFilter(dataset: Dataset, distance, distanceUnit: DistanceUnit) {
        this.applyDistanceFilter(dataset, distance, distanceUnit);
    }

    getDisplayName(node) {
        if (!isUndefined(node?.params?.field)) {
            const field = node.params.field;
            return field.displayName == null || field.displayName == undefined
                ? field.name
                : field.displayName;
        }
        return node.name;
    }

    openImport(): void {
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_import_modal_open');
        this.uploadComponent.openComponent();
    }

    onUploadComplete() {
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_datapoins_upload_completed');
        this.notifService.success("Successfully uploaded datapoints");
        this.datapointsFilterService.emitFilterUpdate();
    }

    changeInSelectedLocationProfile($event) {
        this.currentSelectedProfile = $event.newSelectedValue;
        this.mapComponent.createPreciselyPolygon($event);
        this.mapComponent.createPreciselyWildfirePolygon($event);
      //  this.mapComponent.createTensorflightPolygon($event);
        this.updatePreciselyCrimeBoundary($event);
    }

    /**
     * Draw the Census block group boundary while Precisely Crime is the selected profile, and
     * remove it as soon as any other option is chosen.
     *
     * The boundary is fetched on demand rather than with the datapoint: it is far larger than the
     * crime attributes themselves, and most users never open this profile.
     */
    private updatePreciselyCrimeBoundary($event) {
        const profileKey = this.locationProfile.PRECISELY_CRIME;

        if ($event.newSelectedValue !== profileKey) {
            if ($event.prevSelectedValue === profileKey) {
                this.profilePolygonService.clearPreciselyCrimeBoundary();
            }
            return;
        }

        const location = $event.location;
        this.profilePolygonService.loadPreciselyCrimeBoundary(
            $event.blockGroupCode,
            location ? location.y : undefined,
            location ? location.x : undefined,
            // Precisely's own data vintage, so the backend draws from a matching boundary layer
            // rather than assuming the current one.
            $event.blockGroupVintage
        );
    }

    /**
     * The consolidated risk score fields as a checkbox tree for the download dialog: the
     * group, a node per vulnerability profile type, then that profile's scenario/period
     * fields. Empty until a recalculation has generated the fields on this dataset.
     *
     * Node ids are negative so they cannot collide with the overlay group ids listed in the
     * same dialog - the dropdown identifies nodes by id.
     */
    private prepareConsolidatedRiskScoreDownloadItems(): TreeStructure[] {
        const fields = (this.dataset?.fields || []).filter(
            field => field.scope === DatasetFieldScope.CONSOLIDATED_RISK_SCORE && field.id);
        if (!fields.length) {
            return [];
        }

        let nextId = -1;
        const childrenByProfile = new Map<string, TreeStructure[]>();
        fields.forEach(field => {
            const profileName = (field.tags || [])
                .find(tag => tag && tag !== CONSOLIDATED_RISK_SCORE_TAG) || CONSOLIDATED_RISK_SCORE_TAG;
            if (!childrenByProfile.has(profileName)) {
                childrenByProfile.set(profileName, []);
            }
            childrenByProfile.get(profileName).push({
                id: nextId--,
                name: field.displayName || field.name || field.id,
                // Carried in params so prepareClimateDownloadLinks, which only looks at
                // params.overlay, leaves these alone.
                params: { showCheckBox: true, consolidatedRiskScoreFieldId: field.id },
            });
        });

        const profileNodes: TreeStructure[] = [];
        childrenByProfile.forEach((children, profileName) => {
            profileNodes.push({
                id: nextId--,
                name: profileName,
                params: { showCheckBox: true },
                children: children,
            });
        });

        return [{
            id: nextId--,
            name: CONSOLIDATED_RISK_SCORE_TAG,
            params: { showCheckBox: true },
            children: profileNodes,
        }];
    }

    /** The dataset field ids behind the consolidated risk score nodes the user ticked. */
    private prepareConsolidatedRiskScoreDownloadFields(selectedClimateData): string[] {
        return (selectedClimateData || [])
            .map(item => item?.params?.consolidatedRiskScoreFieldId)
            .filter(fieldId => !!fieldId);
    }

    prepareClimateDownloadLinks(selectedClimateData) {
        const outputData: OutputItem[] = selectedClimateData.reduce((acc: OutputItem[], item: any) => {
            const overlay = item.params?.overlay;
            if (overlay) {
                const datasetID = overlay.id;
                const existingItem = acc.find((outputItem) => outputItem.datasetID === datasetID);

                if (existingItem) {
                    existingItem.fields.push(item.id);
                } else {
                    acc.push({ datasetID, fields: [item.id] });
                }
            }

            return acc;
        }, []);
        return outputData;
    }

    updateMap() {
        this.mapStateService.updateOverlay(
            this.dataset.id,
            this.generatePortfolioLayer(true)
        );
    }

    toggleDatasetList(event: Event) {
        event.stopPropagation();
        this.showDatasetList = !this.showDatasetList;
    }

    toggleWorkspaceItemsProjectionMenu(): void {
        this.workspaceItemsProjectionMenuOpen = !this.workspaceItemsProjectionMenuOpen;
    }

    isWorkspaceItemsProjectionMenuOpen(): boolean {
        return this.workspaceItemsProjectionMenuOpen;
    }

    isThematicMapGroup: boolean = false;
    toggleThematicMapGroup(event: Event) {
        event.stopPropagation();
        this.isThematicMapGroup = !this.isThematicMapGroup;
    }

    isThematicMapValue: boolean = false;
    toggleThematicMapValue(event: Event) {
        event.stopPropagation();
        this.isThematicMapValue = !this.isThematicMapValue;
    }

    isThematicMapFormulas: boolean = false;
    toggleThematicMapFormulas(event: Event) {
        event.stopPropagation();
        this.isThematicMapFormulas = !this.isThematicMapFormulas;
    }

    prepareClimateOverlays() {
        return ObjectUtils.clone(
            this
                .filterAccountOverlays
        );
        // .filter(
        //     (params) =>
        //         ![
        //             "Risk Maps",
        //         ].includes(
        //             params.group
        //                 .name
        //         )
        // )
    }

    hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

    private buildExternalGroupTree(groups: TessadataDatasetsByGroup[]): TreeStructure[] {
        const temp_hide_datasets_ids = ["25", "26"];
        const nodeByGroupId = new Map<number, TreeStructure>();
        const ungroupedDatasets: TreeStructure[] = [];

        groups.forEach((group) => {
            const datasetNodes: TreeStructure[] = (group.datasets || [])
                .filter((dataset) => !temp_hide_datasets_ids.includes(dataset.datasetId))
                .map((dataset) => ({name: dataset.datasetLabel, datasetId: dataset.datasetId}));

            if (group.groupId == null) {
                ungroupedDatasets.push(...datasetNodes);
                return;
            }
            nodeByGroupId.set(group.groupId, {name: group.groupName, id: group.groupId, children: datasetNodes});
        });

        const roots: TreeStructure[] = [];
        groups.forEach((group) => {
            if (group.groupId == null) {
                return;
            }
            const node = nodeByGroupId.get(group.groupId);
            const parent = group.parentId != null ? nodeByGroupId.get(group.parentId) : null;
            if (parent) {
                parent.children.push(node);
            } else {
                roots.push(node);
            }
        });

        if (ungroupedDatasets.length) {
            roots.push({name: "Ungrouped", children: ungroupedDatasets});
        }
        return roots;
    }

    toggleExternalDataNode(node: TreeStructure): void {
        node.expanded = !node.expanded;
    }

    toggleExternalData(event: Event): void {
        event.stopPropagation();
        this.externalData = !this.externalData;
    }

    toggleReportList(event: Event) {
        event.stopPropagation();
        if (!this.reports.length) {
            return;
        }
        this.showReportList = !this.showReportList;
    }

    getReports(datasetId, accountId) {
        this.showReportList = false;
        this.reportService.fetchReports(datasetId, accountId);
        this.subscriptions.add(
            this.reportService.reports$.subscribe(reports => {
                this.reports = reports;
            })
        );

        this.subscriptions.add(
            this.workspaceItemsService.isReportsCallClose$.subscribe(
                (response) => {
                    if (response) {
                        this.reportPanel.instance.closePanel();
                    }
                }
            )
        );

        // Subscribe to analytics updates to refresh the dropdown list
        this.subscriptions.add(
            this.workspaceItemsService.analyticsUpdated$.subscribe(() => {
                this.fetchWorkspaceItems();
            })
        );
    }

    openReportPanelInCreateMode() {
        this.openReportPanel();
    }

    openReportPanelInEditMode(report) {
        this.openReportPanel(false, report)
    }

    openReportPanel(isCreateMode = true, report = null) {
        // Track navigation to Report Modal (hybrid approach)
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_report_modal_open');
        this.sidePanelService.setRootViewContainerRef(
            this.viewContainerRef
        );
        this.reportPanel =
            this.sidePanelService.open<ReportPanelConfig>(
                SidePanels.REPORT_PANEL,
                {
                    width: 500,
                    id: REPORT_PANEL_ID,
                    panelTitle: "Reports",
                    resizeable: true,
                    panelIcon: 'icon-analitycs',
                },
                {
                    dataset: this.dataset,
                    isCreateMode: isCreateMode,
                    selectedReport: report,
                    tabsAccess: { FLOOD_FEMA: this.isFloodFEMAAssociated() }
                }
            );
    }

    isFloodFEMAAssociated(): boolean {
        let hasFloodFEMAAccess = false;

        if (this.externalDataMenuItems?.length) {
            this.externalDataMenuItems.some((country) => {
                if (country?.datasets?.length) {
                    const hasFlood = country.datasets.findIndex(dataset => dataset.datasetId === Constants.FLOOD_FEMA_DATASET_ID) !== -1;
                    if (hasFlood) {
                        hasFloodFEMAAccess = true;
                        return true;
                    }
                }
                return false;
            });
        }

        return hasFloodFEMAAccess;
    }

    downloadRenewalReport(report) {
        this.reportService.downloadRenewalReport(report);
    }

    deleteRenewalReport(report) {
        this.reportService.deleteRenewalReport(report, this.dataset.id, this.dataset.accountID);
    }

    truncateName(name: string, truncate_length: number = 16): string {
        const decodedName = decodeHtmlText(name);
        if (decodedName.length > 20) {
            return decodedName.substring(0, truncate_length) + '...';
        }
        return decodedName;
    }

    openFilterPanel() {
        // Track navigation to Filter Modal (hybrid approach)
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_filter_modal_open');
        if (this.filterPanel) {
            // Bring panel to front FIRST
            this.sidePanelService.setPanelFirst(this.filterPanel.instance);
            this.filterPanel.instance.showPanel();

            if (this.analyticsPanel) {
                this.analyticsPanel.instance.hidePanel();
            }
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.filterPanel =
                this.sidePanelService.open<FilterPanelType>(
                    SidePanels.FILTER_PANEL,
                    {
                        width: 500,
                        id: "filterPanel",
                        panelTitle: "Filter",
                        panelIcon: "fa-filter",
                        resizeable: true,
                    },
                    {
                        dataset: this.dataset,
                        account: this.account,
                        filter: this.filter,
                        workspaceItemsForFilter: this.workspaceItemsForFilter,
                        dataSource: this.dataSource,
                        filterTreeStrcuture: this.filterTreeStrcuture,
                        treeControl: this.treeControl
                    }
                );

            this.datapointsFilterService.onGlobalFilterRemoved().subscribe(
                () =>
                    this.removeFilterFromMap()
            );

            this.datapointsFilterService.onSaveFilterApply().subscribe(
                (filterConfiguration) =>
                    this.applyWorkspaceItemFilter(filterConfiguration)
            );

            this.datapointsFilterService.onDeleteSavedFilter().subscribe(
                (filterConfiguration) =>
                    this.deleteWorkspaceItem(filterConfiguration)
            );
        }
    }

    openAccumulationsPanel() {

        this.heatMapDataSource.data = this.filterData(ObjectUtils.clone(this.dataSource.data));
        // Track navigation to Accumalations Modal (hybrid approach)
        this.analytics.trackEvent((this.isMapView ? 'map' : 'table') + '_accumalations_modal_open');
        if (this.accumulationsPanel) {
            // Bring panel to front FIRST
            this.sidePanelService.setPanelFirst(this.accumulationsPanel.instance);
            this.accumulationsPanel.instance.showPanel();
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.accumulationsPanel =
                this.sidePanelService.open<AccumulationsComponentType>(
                    SidePanels.ACCUMULATIOS_PANEL,
                    {
                        width: COMMON_PANEL_WIDTH,
                        id: ACCUMULATIONS_PANEL_ID,
                        panelTitle: "Accumulations",
                        panelIcon: "fa-atom",
                        resizeable: true,
                    },
                    {
                        dataset: this.dataset,
                        filter: this.filter,
                        initSettings: this.clusteringSettings,
                        formulas: this.workspaceItemsForFormulas,
                        dataSource: this.heatMapDataSource,
                        treeControl: this.heatMaptreeControl,
                        heatMapTreeStructure: this.heatMapTreeStructure,
                        nriFields: isUndefined(this.tessadataFieldsByDataset[this.dataset.id]) ? [] :
                            this.tessadataFieldsByDataset[this.dataset.id]
                                .nriFields,
                        climateOverlays: this.prepareClimateOverlays()
                    }
                );

            this.datapointsServiceState.onDataPointSelected$.subscribe(
                (clusterPoint: ClusterDatapoint) =>
                    this.openLocationProfile(clusterPoint)
            );
            this.datapointsServiceState.onApplySettings$.subscribe(
                (settings: ClusteringRequest) => {
                    this.clusteringSettings = settings;
                }
            );
            this.datapointsServiceState.onCancelClustering$.subscribe(() => {
                this.clusteringSettings = undefined;
                this.closeClusterPanel();
                this.tileVersionService.incrementVersionToken();
                  this.isAccumalationApplied = false;
                this.updateMap();
            });

            this.accumulationsSerivce.onHeatmapActivated().subscribe((response) => {
                if (!response) {
                    let searchElement = this.legends.find(
                        (legend) => legend.datasetId === "Heatmap legend"
                    );
                    if(searchElement) {
                        this.tileVersionService.incrementVersionToken();
                          this.isAccumalationApplied = false;
                        this.updateMap();
                        this.removeLegend("Heatmap legend");
                    }
                } else {
                    this.tileVersionService.incrementVersionToken();
                      this.isAccumalationApplied = true;
                    this.updateMap();
                    let minWeight: number = Infinity;
                    let maxWeight: number = -Infinity;
                    response.data.forEach((data) => {
                        if (data.weight < minWeight) {
                            minWeight = data.weight;
                        }
                        if (data.weight > maxWeight) {
                            maxWeight = data.weight;
                        }
                    });
                    this.addLegend(
                        "Heatmap legend", null, true, "Spatial Heatmap", response.fieldName,
                        LegendUtils.createGradientLegendsForHeatmap(
                            minWeight,
                            maxWeight
                        )
                    );
                }
            });

            // Thematic map subscriptions
            this.addThematicMapSubscriptions()

        }
    }


    filterData(data) {
        return data.reduce((acc, fieldObj) => {
            if (fieldObj?.params?.field?.baseType === DatasetFieldType.NUMBER) {
                acc.push(fieldObj);
            } else if (fieldObj.children) {
                const filteredChildren = this.filterData(fieldObj.children);
                if (filteredChildren.length) {
                    acc.push({ ...fieldObj, children: filteredChildren });
                }
            }
            return acc;
        }, []);
    }

    addThematicMapSubscriptions() {
        this.setDefaultThematicMapMetric();

        this.accumulationsSerivce.onThematicMapAnalyticsOpen$.subscribe(() => {
            this.toggleAggregateChartPanel();
        })

        this.sidePanelService.onHide$.subscribe((panel) => {
            // Track panel close and reset to base view
            if (panel === ANALYTICS_PANEL_ID && this.isAccumulationsPanelClosedForceFully) {
                // this.navigationTracker.trackBaseViewNavigation({
                //     section: 'datapoints',
                //     viewMode: this.isMapView ? 'map' : 'table',
                //     datasetId: this.dataset?.id,
                //     datasetName: this.dataset?.name
                // });
                this.isAccumulationsPanelClosedForceFully = false;
                this.accumulationsPanel.instance.width = COMMON_PANEL_WIDTH;
                this.openAccumulationsPanel();
            }
        });

        this.accumulationsSerivce.onThematicMapActivate$.subscribe(() => {
            this.setThematicMapGrouping()
            this.setThematicMapFormula();
            this.setThematicMapMetric();

            if (this.isThematicMapActive) {
                this.mapThematicOverlayService.setActive(
                    this.mapThematicOverlayService.currentConfig
                );
            } else {
                this.toggleThematicMap(true)
            }
        });

        this.accumulationsSerivce.onThematicMapDeactivate$.subscribe(() => {
            this.toggleThematicMap(false)
        });
    }



    closeAccumulationsPanel() {
        this.accumulationsPanel.instance.width = 0;
        this.accumulationsPanel.instance.hidePanel();
        this.isAccumulationsPanelClosedForceFully = true;

        this.cd.detectChanges();
    }

    setThematicMapGrouping() {
        this.thematicMapGrouping = this.accumulationsSerivce.thematicMapGrouping;
    }

    setThematicMapMetric() {
        this.customLegendsEnabled = false;
        this.mapThematicOverlayService.emitCustomizedLegends([]);
        this.legendLimitForm.reset();
        if (this.accumulationsSerivce.thematicMapMetric) {
            this.thematicMapMetric = this.accumulationsSerivce.thematicMapMetric;
            this.dataset.fields.forEach((f) => {
                f.selectedForTM = f.id === this.accumulationsSerivce.thematicMapMetric.id;
            });
            this.thematicMapFormula = undefined;
            this.workspaceItemsForFormulas.forEach(
                (f) => (f.selectedForTM = false)
            );
        } else {
            this.thematicMapMetric = undefined;
        }
    }

    setThematicMapFormula() {
        this.mapThematicOverlayService.emitCustomizedLegends([]);
        this.customLegendsEnabled = false;
        this.legendLimitForm.reset();
        if (this.accumulationsSerivce.thematicMapFormula) {
            this.thematicMapFormula = this.accumulationsSerivce.thematicMapFormula;
            this.workspaceItemsForFormulas.forEach((f) => {
                f.selectedForTM = f.id === this.accumulationsSerivce.thematicMapFormula.id;
            });
            this.thematicMapMetric = undefined;
            this.dataset.fields.forEach((f) => (f.selectedForTM = false));
        } else {
            this.thematicMapFormula = undefined;
        }
    }

    setDefaultThematicMapMetric() {
        this.datasetFloatingFields = this.dataset.fields.filter(
            (field) => field.isFloating
        );
        this.accumulationsSerivce.thematicMapMetric = this.datasetFloatingFields[0];
    }

    startDragging(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (this.isResizing || target.classList.contains('resize-handle')) {
          return; // Don't initiate drag during resize
        }

        this.isDragging = true;
        this.dragMoved = false;
        const elementRect = (event.currentTarget as HTMLElement).getBoundingClientRect();

        if (this.showDynamicIndicatorPopup) {
          this.dragOffset.x = -175;
          this.dragOffset.y = -140;
        } else {
          this.dragOffset.x = event.clientX - elementRect.left;
          this.dragOffset.y = event.clientY - elementRect.top;
        }

        document.addEventListener('mousemove', this.dragIcon);
        document.addEventListener('mouseup', this.stopDragging);
      }

    handleOnClick(): void {
        if (!this.dragMoved) {
            this.showDynamicIndicatorPopup = true;
            this.cd.detectChanges();
        }
    }
    isShowDynamicIndicatorSetting() {
        if (this.justResized) return;
        this.showDynamicIndicatorSettings = true;
    }

    copyDynamicIndicatorValues() {
        const data = this.dynamicIndicatorValues.map(item => `${item.name}: ${item.value.toLocaleString()}`).join('\n');
        window.navigator.clipboard.writeText(data).then(
            () => this.notifService.success("Copied All data to clipboard"),
            (err) => console.error("Failed to copy measurements:", err)
        );
    }

    closePopup2(event: Event) {
        event.stopPropagation();
        this.showDynamicIndicatorPopup = false;
        this.showDynamicIndicatorSettings = false;
        this.cd.detectChanges();
    }

    closeDynamicIndicatorSetting() {
        this.showDynamicIndicatorSettings = false;
    }

    onFieldTypeChange(event: any, newFilter?) {
        this.loadDIValues(newFilter, true)
    }

    compareDropdownValues(option: any, selected: any): boolean {
        return option && selected ? option.id === selected.id : option === selected;
    }

    isOptionDisabled(item: any): boolean {
        const selectedValues = this.createDropdownForm.get('baseValue')?.value || [];
        if (selectedValues.length === 1 && this.isSelected(item)) {
            return true;
        }
        if (selectedValues.length >= 3 && !this.isSelected(item)) {
            return true;
        }
        return false;
    }

    isMaxSelected(): boolean {
        return (this.createDropdownForm.get('baseValue')?.value || []).length >= 3;
    }

    isSelected(item: any): boolean {
        return (this.createDropdownForm.get('baseValue')?.value || []).some((selected: any) => selected.id === item.id);
    }

        loadDIValues(newFilter?, callSave?) {
            const selectedValues = this.createDropdownForm.get('baseValue')?.value || [];
            const accountId = +this.route.snapshot.paramMap.get("accountId");
            const datasetId = this.route.snapshot.paramMap.get("datasetId");
            let pendingApiCalls = 0;
            if (selectedValues.length > 0) {
                const newlySelected = selectedValues.filter(
                    (item: any) => !this.dynamicIndicatorValues.some((d) => d.id === item.id) && !this.pendingRequests.has(item.id)
                );
                const deselectedItems = this.dynamicIndicatorValues.filter(
                    (item) => !selectedValues.some((selected: any) => selected.id === item.id)
                );
                let iterationValues;
                iterationValues = this.filterChanged || !newlySelected.length ? selectedValues : newlySelected
                const filter = newFilter ? newFilter : this.datapointsFilterService.getActiveFilter();
                const projection = { datasetID: datasetId, geometryPrecision: 25 };
                const isAdmin = this.userStateService.isSuperadmin || this.userStateService.isAccountAdmin(this.accountId);
                iterationValues.forEach((item: any) => {
                    this.pendingRequests.add(item.id);
                    pendingApiCalls++;
                    switch (item.scope) {
                        case "INTERNAL":
                            this.datapointsAggregateService.getDatapointsFieldStatisticsForDI(datasetId!, item.id, filter).subscribe((statistics) => {
                                this.pendingRequests.delete(item.id);
                                this.pushToDynamicIndicatorValues(item, statistics);
                                pendingApiCalls--;
                                if (callSave) {
                                    this.checkAndSave(pendingApiCalls);
                                }
                            });
                            break;

                        case "LAYER_EXPOSURE":
                            this.layerExposeService.getLayerSummaryResponse(filter, accountId, +item.id).subscribe((response) => {
                                this.pendingRequests.delete(item.id);
                                this.pushToDynamicIndicatorValues(item, response);
                                pendingApiCalls--;
                                if (callSave) {
                                    this.checkAndSave(pendingApiCalls);
                                }
                            });
                            break;

                        case "COUNT":
                            if (filter.groups.length <= 0) {
                                filter.groups = this.accGroups;
                            }
                            this.datapointService.getDatapointsCount(filter, projection).subscribe((response) => {
                                this.pendingRequests.delete(item.id);
                                this.pushToDynamicIndicatorValues(item, response);
                                pendingApiCalls--;
                                if (callSave) {
                                    this.checkAndSave(pendingApiCalls);
                                }
                            });
                            break;

                        case "FORMULA":
                            // Find the formula from workspaceItemsForFormulas
                            const formula = this.workspaceItemsForFormulas.find(f => f.id === item.id);
                            if (formula) {
                                // Deep clone formula data to avoid closure issues
                                const formulaData = JSON.parse(JSON.stringify(formula.data));

                                // Create report request for formula aggregation
                                const reportRequest = {
                                    datasetID: datasetId,
                                    groups: [], // For dynamic indicators, we don't need breakdown groups
                                    // Add unique cache-busting parameter to prevent browser caching
                                    aggregateFieldCodes: [
                                        {
                                            aggregateFieldCode: `FORMULA_${formula.id}_${Date.now()}`,
                                            id: `${formula.id}`
                                        }
                                    ],
                                    aggregateFieldType: DatapointAggregateFieldType.FORMULA,
                                    aggregateFieldFormulaJson: formulaData
                                };

                                this.datapointsAggregateService.getDatapointsReport(datasetId, filter, reportRequest, projection).subscribe((response) => {
                                    this.pendingRequests.delete(item.id);
                                    // Extract the total value from the report response by summing all group results
                                    let totalValue = 0;
                                    if (response.groupResults && response.groupResults.length > 0) {
                                        totalValue = response.groupResults.reduce((sum, groupResult) => {
                                            return sum + (groupResult.values[0]?.result || 0);
                                        }, 0);
                                    }
                                    this.pushToDynamicIndicatorValues(item, { total: totalValue });
                                    pendingApiCalls--;
                                    if (callSave) {
                                        this.checkAndSave(pendingApiCalls);
                                    }
                                }, (error) => {
                                    console.error("Error fetching formula data:", error);
                                    this.pendingRequests.delete(item.id);
                                    pendingApiCalls--;
                                    if (callSave) {
                                        this.checkAndSave(pendingApiCalls);
                                    }
                                });
                            } else {
                                console.warn("Formula not found for id:", item.id);
                                this.pendingRequests.delete(item.id);
                                pendingApiCalls--;
                                if (callSave) {
                                    this.checkAndSave(pendingApiCalls);
                                }
                            }
                            break;

                        default:
                            console.warn("Unknown scope:", item.scope);
                            this.pendingRequests.delete(item.id);
                            pendingApiCalls--;
                            if (callSave) {
                                this.checkAndSave(pendingApiCalls);
                            }
                    }
                });

                deselectedItems.forEach((item: any) => {
                    const index = this.dynamicIndicatorValues.findIndex((d) => d.id === item.id);
                    if (index !== -1) {
                        this.dynamicIndicatorValues.splice(index, 1);
                    }
                });

                this.dynamicIndicatorValues = this.dynamicIndicatorValues.map((item, index) => ({
                    ...item,
                    index: index + 1,
                }));
                this.createDropdownForm.get('baseValue')?.valueChanges
                .pipe(skip(1))
                .subscribe((value) => {
                    if (callSave) {
                        this.checkAndSave(pendingApiCalls);
                    }
                });
            }
        }

        settingDynamicIndicator() {
            this.initForm();
            let accountId = +this.route.snapshot.paramMap.get("accountId");
            const datasetId = this.route.snapshot.paramMap.get("datasetId")

            let numberFieldsArray = [];
            let accountDataLoaded = false;
            let layerExposeDataLoaded = false;
            let formulasLoaded = false;

            const checkAndSetdynamicDropDownList = () => {
              if (accountDataLoaded && layerExposeDataLoaded && formulasLoaded) {
                const countField = {
                    id: "count",
                    name: "Count",
                    scope: "COUNT"
                  };
                this.dynamicDropDownList = [...numberFieldsArray, countField];
                let filter: any;
                if (!this.datapointsFilterService.getActiveFilter()) {
                    filter = {"datasetID": datasetId, "groups" : this.accGroups, "fields" : [], "links": []}
                } else {
                    filter = this.datapointsFilterService.getActiveFilter()
                }
                this.getDyIndi(this.accountDetails.id, filter);
              }
            };
            const dataset = this.accountDetails.datasets.find(ds => +ds.id === +datasetId);
            if (dataset) {
                const numberFields = dataset.fields.filter(field => field.type === "NUMBER_FIELD" && field.scope === DatasetFieldScope.INTERNAL);
                numberFieldsArray.push(...numberFields);
            }

            // Add formulas to the dropdown list
            if (this.workspaceItemsForFormulas && this.workspaceItemsForFormulas.length > 0) {
                const formulaFields = this.workspaceItemsForFormulas.map(formula => ({
                    id: formula.id,
                    name: formula.name,
                    scope: "FORMULA"
                }));
                numberFieldsArray.push(...formulaFields);
            }

            accountDataLoaded = true;
            formulasLoaded = true;
            checkAndSetdynamicDropDownList();
            this.layerExposeService.getAppliedLayerExpose(accountId).subscribe((data) => {
                const modifiedData = data.map(item => ({ ...item, scope: 'LAYER_EXPOSURE' }));
                numberFieldsArray.push(...modifiedData);
                layerExposeDataLoaded = true;
                checkAndSetdynamicDropDownList();
            });
        }

        initForm() {
            this.createDropdownForm = this.fb.group({
                baseValue: new FormControl([])
            });
        }

        getDyIndi(accountId, filter) {
          const isAdmin = this.userStateService.isSuperadmin || this.userStateService.isAccountAdmin(accountId);
          const localData = localStorage.getItem('dynamicIndicatorValues_'+accountId);
          if (isAdmin || (!localData || localData?.length <= 0)) {
            this.accountService.getAccountDynamicIndicatorSetting(accountId).subscribe((response) => {
                const savedFields = response.fields;
                if (this.dynamicDropDownList && this.dynamicDropDownList.length > 0) {
                    const preSelectedItems = this.dynamicDropDownList.filter((item) =>
                        savedFields.some((field: any) => field.id === item.id.toString() && field.type === item.scope)
                    ).map(item => this.getDropdownValue(item));
                    this.createDropdownForm.get('baseValue')?.setValue(preSelectedItems);
                    const callSave = !isAdmin;
                    this.loadDIValues(filter, callSave)
                }
            });
          } else {
            if (localData) {
                this.dynamicIndicatorValues = JSON.parse(localData);
            }
            if (this.dynamicDropDownList && this.dynamicDropDownList.length > 0) {
                const preSelectedItems = this.dynamicDropDownList
                .filter(item =>
                    this.dynamicIndicatorValues.some(
                    (field: any) => field.id === item.id && field.scope === item.scope
                    )
                )
                .map(item => this.getDropdownValue(item));
                this.createDropdownForm.get('baseValue')?.setValue(preSelectedItems);
            }
            this.loadDIValues(filter, false);
          }
        }


    dragIcon = (event: any): void => {
        if (!this.isDragging) return;
        this.dragMoved = true;

        let newX = event.clientX - this.dragOffset.x;
        let newY = event.clientY - this.dragOffset.y;

        const popupWidth = 0;
        const popupHeight = 0;

        if (newX < 0) {
          newX = 0;
        } else if (newX + popupWidth > window.innerWidth) {
          newX = window.innerWidth - popupWidth;
        }

        const bottomMargin = 0;
        if (newY < 0) {
          newY = 0;
        } else if (newY + popupHeight > window.innerHeight - bottomMargin) {
          newY = window.innerHeight - bottomMargin - popupHeight;
        }
        this.iconPosition.x = newX;
        this.iconPosition.y = newY;
        this.updatePopupPosition();
    };

    stopDragging = (): void => {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.dragIcon);
      document.removeEventListener('mouseup', this.stopDragging);
    };

    pushToDynamicIndicatorValues(item: any, response: any) {
        const datasetId = this.route.snapshot.paramMap.get("datasetId");
        const existingIndicator = this.dynamicIndicatorValues.find((d) => d.id === item.id);
        if (existingIndicator) {
            existingIndicator.value = this.getResponseValue(item.scope, response);
            existingIndicator.data = response;
        } else if (!this.dynamicIndicatorValues.some((d) => d.id === item.id)) {
                this.dynamicIndicatorValues.push({
                    id: item.id,
                    name: item.name,
                    scope: item.scope,
                    datasetId: datasetId,
                    value: this.getResponseValue(item.scope, response),
                    data: response
                });
        } else {
            this.dynamicIndicatorValues.push({
                id: item.id,
                name: item.name,
                scope: item.scope,
                datasetId: datasetId,
                value: this.getResponseValue(item.scope, response),
                data: response
            });
        }
        this.cd.detectChanges();
    }

    checkAndSave(pendingApiCalls) {
        if (pendingApiCalls === 0) {
            const isAdmin = (this.userStateService.isSuperadmin || this.userStateService.isAccountAdmin(this.accountId));
            if (isAdmin) {
                this.saveDynamicIndicatorSettings();
            } else {
                const key = 'dynamicIndicatorValues_' + this.accountDetails.id;
                localStorage.setItem(
                    key,
                    JSON.stringify(this.dynamicIndicatorValues)
                );
            }
        }
    }

    getDropdownValue(item: any) {
        return {
          id: item.id,
          scope: item.scope,
          name: item.name
        };
      }

      updatePopupPosition(): void {
        const popup = document.querySelector('.di-pop-up') as HTMLElement;
        const popupWidth = popup?.offsetWidth || this.popupWidth;
        const popupHeight = popup?.offsetHeight || 300;
        if (this.iconPosition.x !== null && this.iconPosition.y !== null) {
            // const popupWidth = this.popupWidth;
            // const popupHeight = 300;
            let fpX = this.iconPosition.x - popupWidth;
            let fpY = this.iconPosition.y - 150;

            if (fpX < 0) {
              fpX = 0;
            } else if (fpX + popupWidth > window.innerWidth) {
              fpX = window.innerWidth - popupWidth;
            }

            if (fpY < 0) {
              fpY = 0;
            } else if (fpY + popupHeight > window.innerHeight + 112) {
              fpY = window.innerHeight + 112 - popupHeight;
            }

            this.firstPopupPosition.x = fpX;
            this.firstPopupPosition.y = fpY;

            let spX = this.iconPosition.x - popupWidth;
            let spY = this.iconPosition.y - 350;

            if (spX < 0) {
              spX = 0;
            } else if (spX + popupWidth > window.innerWidth) {
              spX = window.innerWidth - popupWidth;
            }

            if (spY < 0) {
              spY = 0;
            } else if (spY + popupHeight > window.innerHeight) {
              spY = window.innerHeight - popupHeight;
            }

            this.secondPopupPosition.x = spX;
            this.secondPopupPosition.y = spY;

          } else {
            this.firstPopupPosition.x = null;
            this.firstPopupPosition.y = null;
            this.secondPopupPosition.x = null;
            this.secondPopupPosition.y = null;
          }
    }

    getResponseValue(scope: string, response: any) {
        switch (scope) {
            case "INTERNAL":
                return response.stdevValue;
            case "LAYER_EXPOSURE":
                return response.totalSumOfLayerExposure;
            case "COUNT":
                return response.count;
            case "FORMULA":
                return response.total;
            default:
                return null;
        }
    }

    saveDynamicIndicatorSettings() {
        const datasetId = this.route.snapshot.paramMap.get("datasetId");
        const payload = {
            accountId: this.accountDetails?.id,
            fields: Array.isArray(this.dynamicIndicatorValues)
                ? this.dynamicIndicatorValues.map((field) => ({
                    id: field?.id?.toString() || '',
                    type: field?.scope || '',
                    datasetId: datasetId?.toString() || ''
                  }))
                : []
        };
        this.accountService.saveAccountDynamicIndicatorSetting(this.accountDetails.id, payload).subscribe((response) => {});
    }

    togglePopup() {
        this.popupService.togglePopup();
    }

    startResizing(event: MouseEvent): void {
        this.isResizing = true;
        this.resizeStart.x = event.clientX;
        this.resizeStart.y = event.clientY;

        const popup = (event.target as HTMLElement).closest('.di-pop-up') as HTMLElement;
        this.initialSize.width = popup.offsetWidth;
        this.initialSize.height = popup.offsetHeight;

        document.addEventListener('mousemove', this.onResizing);
        document.addEventListener('mouseup', this.stopResizing);
    }

    onResizing = (event: MouseEvent): void => {
        if (!this.isResizing) return;

        const dx = event.clientX - this.resizeStart.x;
        const dy = event.clientY - this.resizeStart.y;

        const newWidth = Math.max(this.initialSize.width + dx, 200); // Min width
        const newHeight = Math.max(this.initialSize.height + dy, 100); // Min height

        const popup = document.querySelector('.di-pop-up') as HTMLElement;
        popup.style.width = `${newWidth}px`;
        popup.style.height = `${newHeight}px`;
    };

    stopResizing = (): void => {
        this.isResizing = false;
        setTimeout(() => {
            this.justResized = false;
            }, 300);
        this.justResized = true;
        document.removeEventListener('mousemove', this.onResizing);
        document.removeEventListener('mouseup', this.stopResizing);
    };

    // ==================== COLORIZE MARKERS METHODS ====================

    /**
     * Show the colorize markers panel using side panel service
     */
    showColorizeMarkersPanel(): void {
        if (this.colorizeMarkersPanel) {
            // Bring panel to front FIRST (before showing)
            this.sidePanelService.setPanelFirst(this.colorizeMarkersPanel.instance);

            // Update inputs with latest data
            const componentInstance = this.colorizeMarkersPanel.instance.componentRef.instance;
            componentInstance.dataset = this.dataset;
            componentInstance.renderingOptions = this.renderingOptions;

            // Then show the panel
            this.colorizeMarkersPanel.instance.showPanel();
        } else {
            this.sidePanelService.setRootViewContainerRef(
                this.viewContainerRef
            );
            this.colorizeMarkersPanel =
                this.sidePanelService.open(
                    SidePanels.COLORIZE_MARKERS,
                    {
                        width: 500,
                        id: COLORIZE_MARKERS_PANEL_ID,
                        panelTitle: "Colorize Markers",
                        resizeable: true,
                        panelIcon: 'fa-palette',
                    },
                    {
                        dataset: this.dataset,
                        renderingOptions: this.renderingOptions
                    }
                );

            // Subscribe to component outputs after creation
            // Use setTimeout to ensure component is fully initialized
            setTimeout(() => {
                if (this.colorizeMarkersPanel && this.colorizeMarkersPanel.instance.componentRef) {
                    const componentInstance = this.colorizeMarkersPanel.instance.componentRef.instance;
                    // Handle Apply button - submit changes
                    if (componentInstance.submitChanges) {
                        componentInstance.submitChanges.subscribe((updatedRenderingOptions) => {
                            this.onApplyMarkerColorization(updatedRenderingOptions);
                        });
                    }

                    // Handle Reset button
                    if (componentInstance.Reset) {
                        componentInstance.Reset.subscribe(() => {

                            this.onResetMarkerColorization();
                        });
                    }

                    // Handle close panel
                    if (componentInstance.closePanel) {
                        componentInstance.closePanel.subscribe(() => {
                            if (this.colorizeMarkersPanel) {
                                this.colorizeMarkersPanel.instance.hidePanel();
                            }
                        });
                    }
                }
            }, 0);
        }
    }

    /**
     * Toggle (for compatibility with existing button click handler)
     */
    toggleColorizeMarkersPanel(): void {
        this.showColorizeMarkersPanel();
    }

    /**
     * Apply marker colorization settings from the colorize markers panel
     * @param updatedRenderingOptions - Updated rendering options with climatology settings
     */
    onApplyMarkerColorization(updatedRenderingOptions: RenderingOptions): void {
        try {
            // Update rendering options with climatology settings
            this.renderingOptions = updatedRenderingOptions;

            // Ensure climatology options are enabled
            if (this.renderingOptions.climatologyOptions) {
                this.renderingOptions.climatologyOptions.enabled = true;
            }

            // Create legend for marker colorization
            const climatologyOptions = this.renderingOptions.climatologyOptions;
            const stylingOptions = this.renderingOptions.datasetStylingOptions;

            // Remove any existing legend first
            this.removeLegend(this.dataset.id);

            if (stylingOptions && climatologyOptions) {
                // Get the field label for the legend - use the climate indicator name instead of field name
                let fieldLabel = '';
                const colorizationFieldIndex = stylingOptions.colorizationFieldIndex;
                let field: DatasetField = null;

                if (colorizationFieldIndex !== null && colorizationFieldIndex !== undefined) {
                    field = this.dataset.fields[colorizationFieldIndex];
                }


                if (climatologyOptions.selectedIndicator) {
                    // Get the climate indicator name from CLIMATE_INDICATORS_LEGEND constant
                    const indicator = CLIMATE_INDICATORS_LEGEND[climatologyOptions.selectedIndicator.toLowerCase()];
                    fieldLabel = indicator ? indicator.name : climatologyOptions.selectedIndicator;
                } else if (climatologyOptions.vulnerabilityProfileId) {
                    fieldLabel = climatologyOptions.vulnerabilityProfileName || '';
                } else if (field) {
                    fieldLabel = field.displayName || field.name;
                }


                let datasetName = climatologyOptions.enabled
                    ? (climatologyOptions.vulnerabilityProfileId ? 'Consolidated Risk Score' : 'Climate Score')
                    : this.dataset.name;

                // Ensure converter options have field statistics for proper legend generation
                if (field && !this.renderingOptions.converterOptions) {
                    this.renderingOptions.converterOptions = {
                        type: DatapointConverterType.NONE,
                        datasetID: this.dataset.id,
                        fieldID: field.id
                    };
                }

                // Helper function to finalize colorization after legend is created
                const finalizeColorization = () => {
                    // Trigger change detection to update legend
                    this.cd.detectChanges();

                    // Refresh the map tiles with new colorization
                    let layer = this.generatePortfolioLayer();
                    this.mapStateService.updateOverlay(layer.name, layer);

                    // Close the panel
                    if (this.colorizeMarkersPanel) {
                        this.colorizeMarkersPanel.instance.hidePanel();
                    }

                    // Show success notification
                    this.notifService.success('Marker colorization applied successfully');
                };

                // Create legend based on color scale type. Consolidated Risk Score is settled
                // first: its scale is fixed, so the legend is the scale itself rather than
                // something derived from the values actually present (FR-1.49).
                if (climatologyOptions.enabled && climatologyOptions.vulnerabilityProfileId) {
                    this.addLegend(
                        this.dataset.id,
                        this.consolidatedRiskScoreLegend(),
                        false,
                        datasetName,
                        fieldLabel,
                        null,
                        climatologyOptions
                    );
                    finalizeColorization();
                } else if (stylingOptions.type === ColorScaleType.GRADIENT) {
                    // For climate data, use fixed 1-5 scale instead of actual field values
                    const isClimateData = climatologyOptions && climatologyOptions.enabled;

                    if (isClimateData) {
                        // Climate data: Use fixed 1-5 scale for gradient
                        this.renderingOptions.converterOptions.type = DatapointConverterType.NUMBER_FIELD;
                        this.renderingOptions.converterOptions.minNumber = 1;
                        this.renderingOptions.converterOptions.maxNumber = 5;

                        // Create gradient legend with 1-5 range
                        const gradientDetails = LegendUtils.createGradientForLegend(
                            this.renderingOptions,
                            this.dataset.isGeoserver
                        );

                        this.addLegend(
                            this.dataset.id,
                            null,
                            false,
                            datasetName,
                            fieldLabel,
                            gradientDetails,
                            climatologyOptions
                        );

                        // Finalize after legend is created
                        finalizeColorization();
                    } else if (field) {
                        // Non-climate data: Fetch actual field statistics for gradient
                        this.datapointAggregateService
                            .getDatapointsFieldStatistics(
                                this.dataset.id,
                                field.id,
                                { datasetID: this.dataset.id }
                            )
                            .subscribe((statistics) => {
                                // Update converter options with field statistics
                                if (statistics.values) {
                                    // Text field - use values
                                    this.renderingOptions.converterOptions.type = DatapointConverterType.TEXT_FIELD;
                                    this.renderingOptions.converterOptions.values = statistics.values;
                                } else {
                                    // Number field - use min/max
                                    this.renderingOptions.converterOptions.type = DatapointConverterType.NUMBER_FIELD;
                                    this.renderingOptions.converterOptions.minNumber = statistics.minValue;
                                    this.renderingOptions.converterOptions.maxNumber = statistics.maxValue;
                                }

                                // Create gradient legend using LegendUtils
                                const gradientDetails = LegendUtils.createGradientForLegend(
                                    this.renderingOptions,
                                    this.dataset.isGeoserver
                                );

                                this.addLegend(
                                    this.dataset.id,
                                    null,
                                    false,
                                    datasetName,
                                    fieldLabel,
                                    gradientDetails
                                );

                                // Finalize after legend is created
                                finalizeColorization();
                            });
                    } else {
                        // No field selected, just finalize
                        finalizeColorization();
                    }
                } else if (stylingOptions.type === ColorScaleType.FIXED) {
                    // For climate data, use fixed 1-5 scale instead of actual field values
                    const isClimateData = climatologyOptions && climatologyOptions.enabled;

                    if (isClimateData) {
                        // Climate data: Use fixed 1-5 scale for intervals
                        this.renderingOptions.converterOptions.type = DatapointConverterType.NUMBER_FIELD;
                        this.renderingOptions.converterOptions.minNumber = 1;
                        this.renderingOptions.converterOptions.maxNumber = 5;

                        // Create intervals using LegendUtils with 1-5 range
                        const intervals = LegendUtils.createIntervalsForLegend(
                            this.renderingOptions,
                            this.dataset.isGeoserver
                        );


                        this.addLegend(
                            this.dataset.id,
                            intervals,
                            false,
                            datasetName,
                            fieldLabel,
                            null,
                            climatologyOptions
                        );

                        // Finalize after legend is created
                        finalizeColorization();
                    } else if (field) {
                        // Non-climate data: Fetch actual field statistics for intervals
                        this.datapointAggregateService
                            .getDatapointsFieldStatistics(
                                this.dataset.id,
                                field.id,
                                { datasetID: this.dataset.id }
                            )
                            .subscribe((statistics) => {
                                // Update converter options with field statistics
                                if (statistics.values) {
                                    // Text field - use values
                                    this.renderingOptions.converterOptions.type = DatapointConverterType.TEXT_FIELD;
                                    this.renderingOptions.converterOptions.values = statistics.values;
                                } else {
                                    // Number field - use min/max
                                    this.renderingOptions.converterOptions.type = DatapointConverterType.NUMBER_FIELD;
                                    this.renderingOptions.converterOptions.minNumber = statistics.minValue;
                                    this.renderingOptions.converterOptions.maxNumber = statistics.maxValue;
                                }

                                // Create intervals using LegendUtils
                                const intervals = LegendUtils.createIntervalsForLegend(
                                    this.renderingOptions,
                                    this.dataset.isGeoserver
                                );


                                this.addLegend(
                                    this.dataset.id,
                                    intervals,
                                    false,
                                    datasetName,
                                    fieldLabel
                                );

                                // Finalize after legend is created
                                finalizeColorization();
                            });
                    } else {
                        // No field selected, just finalize
                        finalizeColorization();
                    }
                } else if (stylingOptions.type === ColorScaleType.INTERVAL && stylingOptions.intervalOptions?.length > 0) {
                    // For interval type, show intervals (synchronous)
                    this.addLegend(
                        this.dataset.id,
                        stylingOptions.intervalOptions,
                        false,
                        datasetName,
                        fieldLabel,
                        null,
                        climatologyOptions
                    );

                    // Finalize after legend is created
                    finalizeColorization();
                } else if (stylingOptions.type === ColorScaleType.CONSTANT) {
                    // For constant type, show single color (synchronous)
                    const constantInterval: IntervalOption = {
                        color: stylingOptions.defaultColor || stylingOptions.colors?.[0] || 0xd3d3d3,
                        minValue: 'All',
                        maxValue: 'All',
                        total: 0,
                        isTextInterval: true
                    };
                    this.addLegend(
                        this.dataset.id,
                        [constantInterval],
                        false,
                        datasetName,
                        fieldLabel,
                        null,
                        climatologyOptions
                    );

                    // Finalize after legend is created
                    finalizeColorization();
                } else {
                    // No legend to create, just finalize
                    finalizeColorization();
                }
            } else {
                // No styling options, just finalize
                this.cd.detectChanges();
                let layer = this.generatePortfolioLayer();
                this.mapStateService.updateOverlay(layer.name, layer);
                if (this.colorizeMarkersPanel) {
                    this.colorizeMarkersPanel.instance.hidePanel();
                }
                this.notifService.success('Marker colorization applied successfully');
            }


        } catch (error) {
            this.notifService.error('Failed to apply marker colorization');
        }
    }

    /**
     * Reset marker colorization to initial settings (as they were when the map first loaded)
     */
    onResetMarkerColorization(): void {
        try {

            if (!this.dataset || !this.dataset.id) {
                this.notifService.error('Cannot reset colorization - dataset not available');
                return;
            }

            if (!this.initialRenderingOptions) {
                this.notifService.error('Initial rendering options not found');
                return;
            }

            // Restore rendering options to the initial state (deep copy to avoid reference issues)
            this.renderingOptions = JSON.parse(JSON.stringify(this.initialRenderingOptions));

            // Disable climatology options if they exist
            if (this.renderingOptions.climatologyOptions) {
                this.renderingOptions.climatologyOptions.enabled = false;
            }

            // Reset dataset's climatology overlay config
            if (this.dataset.climatologyOverlayConfig) {
                this.dataset.climatologyOverlayConfig.enabled = false;
                this.dataset.climatologyOverlayConfig.assignedOverlays = [];
            }

            // Reset climatology styling options to default
            this.dataset.climatologyStylingOptions = {
                type: ColorScaleType.GRADIENT,
                colorizationFieldIndex: 0,
                defaultColor: 0xd3d3d3,
                colors: [0xfff2cc, 0xffd966, 0xf4cccc, 0xe06666, 0xcc0000],//[0x2166ac, 0x92c5de, 0xfddbc7, 0xf4a582, 0xb2182b],
                markerId: 0,
                intervalOptions: [],
                backgroundOpacity: 1
            };

            // Remove any existing legends before regenerating
            this.removeLegend(this.dataset.id);

            // Trigger change detection to ensure view is updated
            this.cd.detectChanges();

            // Use updatePortfolioLayer() instead of generatePortfolioLayer() directly
            // This properly handles colorization based on styling options type (FIXED, GRADIENT, INTERVAL, CONSTANT)
            // and regenerates legends with field statistics
            this.updatePortfolioLayer();

            this.notifService.success('Marker colorization reset to initial settings');

        } catch (error) {
            this.notifService.error('Failed to reset marker colorization');
        }
    }

}
